<template>
	<div class="Container">
		<div class="Toast" :class="{ show: showToast }">
			<div class="toast-container">
				<svg v-if="toastType === 'recording'" style="width: 24px; height: 24px" viewBox="0 0 24 24">
					<path fill="#f14c49" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
				</svg>
				<svg v-else-if="toastType === 'recording_ended'" style="width: 24px; height: 24px" viewBox="0 0 24 24">
					<path fill="#4CAF50" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
				</svg>
				<svg v-else-if="toastType === 'participant_left'" style="width: 24px; height: 24px" viewBox="0 0 24 24">
					<path fill="#FF9800" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7L12,14L16,10L12,7Z" />
				</svg>
				<div v-if="toastType === 'recording'">{{ getRecordingName }} {{ $t('partecipant_is_recording') }}</div>
				<div v-else-if="toastType === 'recording_ended'">{{ $t('recording_ended') }}</div>
				<div v-else-if="toastType === 'participant_left'">{{ getLeftParticipantName }} {{ $t('participant_left') }}</div>
			</div>
		</div>
		<div class="Scenary">
			<div class="Conference" :class="{ boxRightOpen: chatVisible || partecipantsVisible }" ref="conference">
				<div class="Screen" :class="{ pinned: videoPinned }" v-if="videoPinned">
					<div class="ScreenSharingOn" v-if="videoPinned && videoPinned.isScreenShare">
						<div class="ScreenSharingOn-container">
							<span>
								<svg viewBox="0 0 24 24" style="width: 22px; height: 22px; margin-right: 5px">
									<path
										fill="white"
										d="M23 4V16C23 17.11 22.11 18 21 18H15V16H21V4H3V16H9V18H3C1.9 18 1 17.11 1 16V4C1 2.89 1.89 2 3 2H21C22.1 2 23 2.89 23 4M13 13H16L12 9L8 13H11V20H8V22H16V20H13V13Z"
									></path>
								</svg>
								<span> {{ videoPinned.isLocal ? $t('you_are_streaming') : videoPinned.name.substring(0, 1).toUpperCase() + ' ' + $t('partecipant_is_streaming') }}</span>
							</span>
							<span>
								<button v-if="videoPinned.isLocal" @click="shareScreen()">{{ $t('stop_streaming') }}</button>
							</span>
						</div>
					</div>
					<div class="PinnedContainer">
						<span class="pin" @click="unexpand(videoPinned)" v-if="videoPinned">
							<svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
								<path fill="white" d="M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z" />
							</svg>
						</span>
						<video
							v-show="videoPinned && videoPinned.videoEnabled"
							:srcObject.prop="videoPinned ? videoPinned.stream : ''"
							v-bind:video="videoPinned"
							autoplay
							playsinline
							:muted="videoPinned ? videoPinned.isLocal || videoPinned.muted : false"
							:id="videoPinned ? 'pinned_' + videoPinned.id : ''"
							class="video-pinned"
							:class="{ isScreenShare: videoPinned && videoPinned.isScreenShare }"
						/>

						<div style="width: 100%; height: 100%; position: relative" v-if="videoPinned && !videoPinned.videoEnabled">
							<div class="effect-container" v-show="videoPinned && !videoPinned.isScreenShare && videoPinned.audioEnabled" :class="{ speaking: videoPinned.isSpeaking }">
								<div :class="'o1_' + videoPinned.id"></div>
								<div :class="'o2_' + videoPinned.id"></div>
								<div :class="'o3_' + videoPinned.id"></div>
							</div>
							<!-- audio muted visible only if is not a screenshare and islocal with audio off or !islocal with audio not enabled -->
							<span v-if="!videoPinned.isScreenShare && !videoPinned.audioEnabled" class="audio">
								<svg viewBox="0 0 24 24">
									<path
										d="M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5A3,3 0 0,1 12,2A3,3 0 0,1 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14A3,3 0 0,1 9,11V10.28L3,4.27L4.27,3Z
									"
									/>
								</svg>
							</span>
							<div v-if="!videoPinned.videoEnabled" class="container-initials">
								<span :class="'initials-audio-effect-' + videoPinned.id" />
								<span :class="'initials-audio-effect-big-' + videoPinned.id" />
								<span class="initials" :style="'background-color:' + getRandomColor(videoPinned.name)">
									{{ videoPinned.name ? videoPinned.name.substring(0, 1).toUpperCase() : '' }}
								</span>
							</div>
						</div>
						<span class="info">{{ videoPinned && videoPinned.name ? (videoPinned.isLocal ? 'Tu' : videoPinned.name) : '' }}</span>
					</div>
				</div>
				<div class="Dish" v-if="videoList.filter((f) => !f.pinned).length > 0">
					<div class="video-container" :class="item.videoEnabled ? '' : 'video-' + item.id" v-for="item in videoList.filter((f) => !f.pinned)" v-bind:key="item.id" :style="getVideoStyle">
						<span class="pin" @click="expand(item)">
							<svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
								<path fill="white" d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
							</svg>
						</span>
						<div class="effect-container" v-show="!item.isScreenShare && item.audioEnabled" :class="{ speaking: item.isSpeaking }">
							<div :class="'o1_' + item.id"></div>
							<div :class="'o2_' + item.id"></div>
							<div :class="'o3_' + item.id"></div>
						</div>
						<!-- recording -->
						<span v-if="!item.isScreenShare && item.isRecording" class="recording">
							<svg viewBox="0 0 24 24">
								<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
							</svg>
						</span>
						<!-- audio muted visible only if is not a screenshare and islocal with audio off or !islocal with audio not enabled -->
						<span v-if="!item.isScreenShare && !item.audioEnabled" class="audio">
							<svg viewBox="0 0 24 24">
								<path
									d="M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5A3,3 0 0,1 12,2A3,3 0 0,1 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14A3,3 0 0,1 9,11V10.28L3,4.27L4.27,3Z
									"
								/>
							</svg>
						</span>
						<div v-if="!item.videoEnabled" class="container-initials">
							<span :class="'initials-audio-effect-' + item.id" />
							<span :class="'initials-audio-effect-big-' + item.id" />
							<span class="initials" :style="'background-color:' + getRandomColor(item.name)">
								{{ getName(item) }}
							</span>
						</div>
						<video
							v-show="item.videoEnabled"
							:srcObject.prop="item ? item.stream : ''"
							autoplay
							playsinline
							ref="videos"
							:muted="item.isLocal || item.muted"
							:id="item.id"
							:class="{ isScreenShare: item.isScreenShare }"
						></video>
						<span class="info">{{ item.isLocal ? 'Tu' : item.name }} {{ item.isScreenShare ? ' (presentazione)' : '' }}</span>
					</div>
				</div>

				<div class="RightBox" v-on:keyup.enter="addMessage" :class="{ open: chatVisible || partecipantsVisible || showMediaPipe }">
					<Chat
						:visible="chatVisible"
						:messages="messages"
						:participants="videoList"
						:currentUserId="getCurrentUserId"
						:alreadyOpen="alreadyOpen"
						:chatInfoText="$t('chat_info')"
						:messagePlaceholder="$t('write_message')"
						@close="manageRightBox('chat')"
						@send-message="handleSendMessage"
					/>
					<UserList :participants="videoList" :visible="partecipantsVisible" :recordOn="recordOn" @close="manageRightBox('list')" @pin="handleUserPin" />

					<div class="background-container" v-show="showMediaPipe">
						<div class="effects-header">
							<span>{{ $t('video_effects') }}</span>
							<svg @click="manageRightBox('background')" style="width: 20px; height: 20px" viewBox="0 0 24 24">
								<path fill="white" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
							</svg>
						</div>
						<div class="canvas-container">
							<canvas class="output_canvas_preview" v-show="canvasVisible"></canvas>
							<video id="hidden-preview-video" style="display: none" autoplay muted playsinline></video>
						</div>

						<div class="scroller-container">
							<!--Nuovo-->
							<div class="effects-container">
								<label v-text="$t('selectEffect')"></label>
								<div class="container-choices">
									<div class="choice" :class="{ selected: (!previewBlurLevel || previewBlurLevel === 0 ) && !previewVirtualBackground && !background}" @click="clearAllEffects">
										<svg style="width: 24px; height: 24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
											<title>blur-off</title>
											<path
												fill="white"
												d="M3,13.5A0.5,0.5 0 0,0 2.5,14A0.5,0.5 0 0,0 3,14.5A0.5,0.5 0 0,0 3.5,14A0.5,0.5 0 0,0 3,13.5M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M10,20.5A0.5,0.5 0 0,0 9.5,21A0.5,0.5 0 0,0 10,21.5A0.5,0.5 0 0,0 10.5,21A0.5,0.5 0 0,0 10,20.5M3,9.5A0.5,0.5 0 0,0 2.5,10A0.5,0.5 0 0,0 3,10.5A0.5,0.5 0 0,0 3.5,10A0.5,0.5 0 0,0 3,9.5M6,13A1,1 0 0,0 5,14A1,1 0 0,0 6,15A1,1 0 0,0 7,14A1,1 0 0,0 6,13M21,13.5A0.5,0.5 0 0,0 20.5,14A0.5,0.5 0 0,0 21,14.5A0.5,0.5 0 0,0 21.5,14A0.5,0.5 0 0,0 21,13.5M10,17A1,1 0 0,0 9,18A1,1 0 0,0 10,19A1,1 0 0,0 11,18A1,1 0 0,0 10,17M2.5,5.27L6.28,9.05L6,9A1,1 0 0,0 5,10A1,1 0 0,0 6,11A1,1 0 0,0 7,10C7,9.9 6.97,9.81 6.94,9.72L9.75,12.53C9.04,12.64 8.5,13.26 8.5,14A1.5,1.5 0 0,0 10,15.5C10.74,15.5 11.36,14.96 11.47,14.25L14.28,17.06C14.19,17.03 14.1,17 14,17A1,1 0 0,0 13,18A1,1 0 0,0 14,19A1,1 0 0,0 15,18C15,17.9 14.97,17.81 14.94,17.72L18.72,21.5L20,20.23L3.77,4L2.5,5.27M14,20.5A0.5,0.5 0 0,0 13.5,21A0.5,0.5 0 0,0 14,21.5A0.5,0.5 0 0,0 14.5,21A0.5,0.5 0 0,0 14,20.5M18,7A1,1 0 0,0 19,6A1,1 0 0,0 18,5A1,1 0 0,0 17,6A1,1 0 0,0 18,7M18,11A1,1 0 0,0 19,10A1,1 0 0,0 18,9A1,1 0 0,0 17,10A1,1 0 0,0 18,11M18,15A1,1 0 0,0 19,14A1,1 0 0,0 18,13A1,1 0 0,0 17,14A1,1 0 0,0 18,15M10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7M21,10.5A0.5,0.5 0 0,0 21.5,10A0.5,0.5 0 0,0 21,9.5A0.5,0.5 0 0,0 20.5,10A0.5,0.5 0 0,0 21,10.5M10,3.5A0.5,0.5 0 0,0 10.5,3A0.5,0.5 0 0,0 10,2.5A0.5,0.5 0 0,0 9.5,3A0.5,0.5 0 0,0 10,3.5M14,3.5A0.5,0.5 0 0,0 14.5,3A0.5,0.5 0 0,0 14,2.5A0.5,0.5 0 0,0 13.5,3A0.5,0.5 0 0,0 14,3.5M13.8,11.5H14A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 14,8.5A1.5,1.5 0 0,0 12.5,10V10.2C12.61,10.87 13.13,11.39 13.8,11.5M14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7Z"
											/>
										</svg>
										<div class="choice-tooltip">{{ $t('no_effects') }}</div>
									</div>
									<div class="choice" :class="{ selected: previewBlurLevel === 1 && !previewVirtualBackground }" @click="() => applyBlur(1)">
										<svg style="width: 24px; height: 24px; opacity: 0.75" viewBox="0 0 24 24">
											<path
												fill="currentColor"
												d="M14,8.5A1.5,1.5 0 0,0 12.5,10A1.5,1.5 0 0,0 14,11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 14,8.5M14,12.5A1.5,1.5 0 0,0 12.5,14A1.5,1.5 0 0,0 14,15.5A1.5,1.5 0 0,0 15.5,14A1.5,1.5 0 0,0 14,12.5M10,17A1,1 0 0,0 9,18A1,1 0 0,0 10,19A1,1 0 0,0 11,18A1,1 0 0,0 10,17M10,8.5A1.5,1.5 0 0,0 8.5,10A1.5,1.5 0 0,0 10,11.5A1.5,1.5 0 0,0 11.5,10A1.5,1.5 0 0,0 10,8.5M14,20.5A0.5,0.5 0 0,0 13.5,21A0.5,0.5 0 0,0 14,21.5A0.5,0.5 0 0,0 14.5,21A0.5,0.5 0 0,0 14,20.5M14,17A1,1 0 0,0 13,18A1,1 0 0,0 14,19A1,1 0 0,0 15,18A1,1 0 0,0 14,17M21,13.5A0.5,0.5 0 0,0 20.5,14A0.5,0.5 0 0,0 21,14.5A0.5,0.5 0 0,0 21.5,14A0.5,0.5 0 0,0 21,13.5M18,5A1,1 0 0,0 17,6A1,1 0 0,0 18,7A1,1 0 0,0 19,6A1,1 0 0,0 18,5M18,9A1,1 0 0,0 17,10A1,1 0 0,0 18,11A1,1 0 0,0 19,10A1,1 0 0,0 18,9M18,17A1,1 0 0,0 17,18A1,1 0 0,0 18,19A1,1 0 0,0 19,18A1,1 0 0,0 18,17M18,13A1,1 0 0,0 17,14A1,1 0 0,0 18,15A1,1 0 0,0 19,14A1,1 0 0,0 18,13M10,12.5A1.5,1.5 0 0,0 8.5,14A1.5,1.5 0 0,0 10,15.5A1.5,1.5 0 0,0 11.5,14A1.5,1.5 0 0,0 10,12.5M10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7M10,3.5A0.5,0.5 0 0,0 10.5,3A0.5,0.5 0 0,0 10,2.5A0.5,0.5 0 0,0 9.5,3A0.5,0.5 0 0,0 10,3.5M10,20.5A0.5,0.5 0 0,0 9.5,21A0.5,0.5 0 0,0 10,21.5A0.5,0.5 0 0,0 10.5,21A0.5,0.5 0 0,0 10,20.5M3,13.5A0.5,0.5 0 0,0 2.5,14A0.5,0.5 0 0,0 3,14.5A0.5,0.5 0 0,0 3.5,14A0.5,0.5 0 0,0 3,13.5M14,3.5A0.5,0.5 0 0,0 14.5,3A0.5,0.5 0 0,0 14,2.5A0.5,0.5 0 0,0 13.5,3A0.5,0.5 0 0,0 14,3.5M14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7M21,10.5A0.5,0.5 0 0,0 21.5,10A0.5,0.5 0 0,0 21,9.5A0.5,0.5 0 0,0 20.5,10A0.5,0.5 0 0,0 21,10.5M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5M3,9.5A0.5,0.5 0 0,0 2.5,10A0.5,0.5 0 0,0 3,10.5A0.5,0.5 0 0,0 3.5,10A0.5,0.5 0 0,0 3,9.5M6,9A1,1 0 0,0 5,10A1,1 0 0,0 6,11A1,1 0 0,0 7,10A1,1 0 0,0 6,9M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M6,13A1,1 0 0,0 5,14A1,1 0 0,0 6,15A1,1 0 0,0 7,14A1,1 0 0,0 6,13Z"
											/>
										</svg>
										<div class="choice-tooltip">{{ $t('light_blur') }}</div>
									</div>
									<div class="choice" :class="{ selected: previewBlurLevel === 2 && !previewVirtualBackground }" @click="() => applyBlur(2)">
										<svg style="width: 28px; height: 28px; opacity: 0.85" viewBox="0 0 24 24">
											<path
												fill="currentColor"
												d="M14,8.5A1.5,1.5 0 0,0 12.5,10A1.5,1.5 0 0,0 14,11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 14,8.5M14,12.5A1.5,1.5 0 0,0 12.5,14A1.5,1.5 0 0,0 14,15.5A1.5,1.5 0 0,0 15.5,14A1.5,1.5 0 0,0 14,12.5M10,17A1,1 0 0,0 9,18A1,1 0 0,0 10,19A1,1 0 0,0 11,18A1,1 0 0,0 10,17M10,8.5A1.5,1.5 0 0,0 8.5,10A1.5,1.5 0 0,0 10,11.5A1.5,1.5 0 0,0 11.5,10A1.5,1.5 0 0,0 10,8.5M14,20.5A0.5,0.5 0 0,0 13.5,21A0.5,0.5 0 0,0 14,21.5A0.5,0.5 0 0,0 14.5,21A0.5,0.5 0 0,0 14,20.5M14,17A1,1 0 0,0 13,18A1,1 0 0,0 14,19A1,1 0 0,0 15,18A1,1 0 0,0 14,17M21,13.5A0.5,0.5 0 0,0 20.5,14A0.5,0.5 0 0,0 21,14.5A0.5,0.5 0 0,0 21.5,14A0.5,0.5 0 0,0 21,13.5M18,5A1,1 0 0,0 17,6A1,1 0 0,0 18,7A1,1 0 0,0 19,6A1,1 0 0,0 18,5M18,9A1,1 0 0,0 17,10A1,1 0 0,0 18,11A1,1 0 0,0 19,10A1,1 0 0,0 18,9M18,17A1,1 0 0,0 17,18A1,1 0 0,0 18,19A1,1 0 0,0 19,18A1,1 0 0,0 18,17M18,13A1,1 0 0,0 17,14A1,1 0 0,0 18,15A1,1 0 0,0 19,14A1,1 0 0,0 18,13M10,12.5A1.5,1.5 0 0,0 8.5,14A1.5,1.5 0 0,0 10,15.5A1.5,1.5 0 0,0 11.5,14A1.5,1.5 0 0,0 10,12.5M10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7M10,3.5A0.5,0.5 0 0,0 10.5,3A0.5,0.5 0 0,0 10,2.5A0.5,0.5 0 0,0 9.5,3A0.5,0.5 0 0,0 10,3.5M10,20.5A0.5,0.5 0 0,0 9.5,21A0.5,0.5 0 0,0 10,21.5A0.5,0.5 0 0,0 10.5,21A0.5,0.5 0 0,0 10,20.5M3,13.5A0.5,0.5 0 0,0 2.5,14A0.5,0.5 0 0,0 3,14.5A0.5,0.5 0 0,0 3.5,14A0.5,0.5 0 0,0 3,13.5M14,3.5A0.5,0.5 0 0,0 14.5,3A0.5,0.5 0 0,0 14,2.5A0.5,0.5 0 0,0 13.5,3A0.5,0.5 0 0,0 14,3.5M14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7M21,10.5A0.5,0.5 0 0,0 21.5,10A0.5,0.5 0 0,0 21,9.5A0.5,0.5 0 0,0 20.5,10A0.5,0.5 0 0,0 21,10.5M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5M3,9.5A0.5,0.5 0 0,0 2.5,10A0.5,0.5 0 0,0 3,10.5A0.5,0.5 0 0,0 3.5,10A0.5,0.5 0 0,0 3,9.5M6,9A1,1 0 0,0 5,10A1,1 0 0,0 6,11A1,1 0 0,0 7,10A1,1 0 0,0 6,9M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M6,13A1,1 0 0,0 5,14A1,1 0 0,0 6,15A1,1 0 0,0 7,14A1,1 0 0,0 6,13Z"
											/>
										</svg>
										<div class="choice-tooltip">{{ $t('mid_blur') }}</div>
									</div>
									<div class="choice" :class="{ selected: previewBlurLevel === 3 && !previewVirtualBackground }" @click="() => applyBlur(3)">
										<svg style="width: 32px; height: 32px" viewBox="0 0 24 24">
											<path
												fill="currentColor"
												d="M14,8.5A1.5,1.5 0 0,0 12.5,10A1.5,1.5 0 0,0 14,11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 14,8.5M14,12.5A1.5,1.5 0 0,0 12.5,14A1.5,1.5 0 0,0 14,15.5A1.5,1.5 0 0,0 15.5,14A1.5,1.5 0 0,0 14,12.5M10,17A1,1 0 0,0 9,18A1,1 0 0,0 10,19A1,1 0 0,0 11,18A1,1 0 0,0 10,17M10,8.5A1.5,1.5 0 0,0 8.5,10A1.5,1.5 0 0,0 10,11.5A1.5,1.5 0 0,0 11.5,10A1.5,1.5 0 0,0 10,8.5M14,20.5A0.5,0.5 0 0,0 13.5,21A0.5,0.5 0 0,0 14,21.5A0.5,0.5 0 0,0 14.5,21A0.5,0.5 0 0,0 14,20.5M14,17A1,1 0 0,0 13,18A1,1 0 0,0 14,19A1,1 0 0,0 15,18A1,1 0 0,0 14,17M21,13.5A0.5,0.5 0 0,0 20.5,14A0.5,0.5 0 0,0 21,14.5A0.5,0.5 0 0,0 21.5,14A0.5,0.5 0 0,0 21,13.5M18,5A1,1 0 0,0 17,6A1,1 0 0,0 18,7A1,1 0 0,0 19,6A1,1 0 0,0 18,5M18,9A1,1 0 0,0 17,10A1,1 0 0,0 18,11A1,1 0 0,0 19,10A1,1 0 0,0 18,9M18,17A1,1 0 0,0 17,18A1,1 0 0,0 18,19A1,1 0 0,0 19,18A1,1 0 0,0 18,17M18,13A1,1 0 0,0 17,14A1,1 0 0,0 18,15A1,1 0 0,0 19,14A1,1 0 0,0 18,13M10,12.5A1.5,1.5 0 0,0 8.5,14A1.5,1.5 0 0,0 10,15.5A1.5,1.5 0 0,0 11.5,14A1.5,1.5 0 0,0 10,12.5M10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7M10,3.5A0.5,0.5 0 0,0 10.5,3A0.5,0.5 0 0,0 10,2.5A0.5,0.5 0 0,0 9.5,3A0.5,0.5 0 0,0 10,3.5M10,20.5A0.5,0.5 0 0,0 9.5,21A0.5,0.5 0 0,0 10,21.5A0.5,0.5 0 0,0 10.5,21A0.5,0.5 0 0,0 10,20.5M3,13.5A0.5,0.5 0 0,0 2.5,14A0.5,0.5 0 0,0 3,14.5A0.5,0.5 0 0,0 3.5,14A0.5,0.5 0 0,0 3,13.5M14,3.5A0.5,0.5 0 0,0 14.5,3A0.5,0.5 0 0,0 14,2.5A0.5,0.5 0 0,0 13.5,3A0.5,0.5 0 0,0 14,3.5M14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7M21,10.5A0.5,0.5 0 0,0 21.5,10A0.5,0.5 0 0,0 21,9.5A0.5,0.5 0 0,0 20.5,10A0.5,0.5 0 0,0 21,10.5M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5M3,9.5A0.5,0.5 0 0,0 2.5,10A0.5,0.5 0 0,0 3,10.5A0.5,0.5 0 0,0 3.5,10A0.5,0.5 0 0,0 3,9.5M6,9A1,1 0 0,0 5,10A1,1 0 0,0 6,11A1,1 0 0,0 7,10A1,1 0 0,0 6,9M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M6,13A1,1 0 0,0 5,14A1,1 0 0,0 6,15A1,1 0 0,0 7,14A1,1 0 0,0 6,13Z"
											/>
										</svg>
										<div class="choice-tooltip">{{ $t('high_blur') }}</div>
									</div>
									<!-- Background options -->
									<div
										v-show="canvasVisible"
										class="choice"
										:class="{ selected: (background?.image === bg.image || previewVirtualBackground?.image === bg.image) && !previewBlurLevel, loading: backgroundsLoading }"
										@click="() => !backgroundsLoading && applyVirtualBackground(bg)"
										v-for="(bg, index) in backgrounds"
										:key="index"
										:style="'background:url(' + bg.image + ')'"
									>
										<div class="choice-tooltip" v-text="bg.tooltip" />
										<div v-if="backgroundsLoading && background === bg" class="loading-spinner">
											<svg style="width: 24px; height: 24px; animation: spin 1s linear infinite" viewBox="0 0 24 24">
												<path
													fill="white"
													d="M12,4A8,8 0 0,1 20,12C20,16.42 16.42,20 12,20A8,8 0 0,1 4,12C4,7.58 7.58,4 12,4M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
												/>
											</svg>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="effects-footer">
							<button @click="saveMediaPipe()">{{ $t('save_settings') }}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Controls">
			<div class="Controls-meet-title">
				<a href="https://cving.com" target="_blank"><img alt="CVing logo" src="/img/logo-cving.d1aad1ca.svg" height="30" width="85" /></a>
				<p>{{ meetName }}</p>
			</div>
			<div class="Controls-main-buttons">
				<span class="media-action-button-wrapper">
					<button class="media-action-button" @click="toggleAudio()" :class="{ 'media-action-button-disabled': !audioOn }">
						<svg viewBox="0 0 24 24">
							<path
								:d="
									audioOn
										? 'M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z'
										: 'M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5A3,3 0 0,1 12,2A3,3 0 0,1 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14A3,3 0 0,1 9,11V10.28L3,4.27L4.27,3Z'
								"
							/>
						</svg>
					</button>
					<span class="media-tooltip" v-text="audioOn ? $t('disable_audio') : $t('enable_audio')"></span>
				</span>
				<span class="media-action-button-wrapper">
					<button class="media-action-button" @click="toggleVideo()" :class="{ 'media-action-button-disabled': !videoOn }">
						<svg viewBox="0 0 24 24">
							<path
								:d="
									videoOn
										? 'M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z'
										: 'M3.27,2L2,3.27L4.73,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7A1,1 0 0,0 16,6H9.82L21,17.18V6.5Z'
								"
							/>
						</svg>
					</button>
					<span class="media-tooltip" v-text="videoOn ? $t('disable_video') : $t('enable_video')"></span>
				</span>
				<span class="media-action-button-wrapper media-action-button-wrapper--share">
					<button class="media-action-button" @click="shareScreen()" :class="{ 'media-action-button-disabled': !shareOn }">
						<svg viewBox="0 0 24 24" style="width: 24px; height: 24px">
							<path
								d="M23 4V16C23 17.11 22.11 18 21 18H15V16H21V4H3V16H9V18H3C1.9 18 1 17.11 1 16V4C1 2.89 1.89 2 3 2H21C22.1 2 23 2.89 23 4M13 13H16L12 9L8 13H11V20H8V22H16V20H13V13Z"
							/>
						</svg>
					</button>
					<span class="media-tooltip" v-text="!shareOn ? $t('share_screen') : $t('stop_share_screen')"></span>
				</span>
				<span class="media-action-button-wrapper media-action-button-wrapper--record">
					<button
						class="media-action-button"
						@click="recordVideo()"
						:class="recordOn ? 'record' : hasOtherRecordingParticipants ? 'media-action-button-disabled-recording' : 'media-action-button-disabled'"
						:disabled="hasOtherRecordingParticipants && !recordOn"
					>
						<svg viewBox="0 0 24 24">
							<path
								:d="
									recordOn
										? 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z'
										: 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z'
								"
							/>
						</svg>
					</button>
					<span
						class="media-tooltip"
						v-text="hasOtherRecordingParticipants && !recordOn ? $t('someone_else_recording') : !recordOn ? $t('register_screen') : $t('stop_register_screen')"
					></span>
					<div class="timestamp" v-if="timestampRecord">{{ getTime }}</div>
				</span>
				<span class="media-action-button-wrapper">
					<button class="hangup" @click="leave">
						<svg viewBox="0 0 24 24">
							<path
								fill="white"
								d="M12,9C10.4,9 8.85,9.25 7.4,9.72V12.82C7.4,13.22 7.17,13.56 6.84,13.72C5.86,14.21 4.97,14.84 4.17,15.57C4,15.75 3.75,15.86 3.5,15.86C3.2,15.86 2.95,15.74 2.77,15.56L0.29,13.08C0.11,12.9 0,12.65 0,12.38C0,12.1 0.11,11.85 0.29,11.67C3.34,8.77 7.46,7 12,7C16.54,7 20.66,8.77 23.71,11.67C23.89,11.85 24,12.1 24,12.38C24,12.65 23.89,12.9 23.71,13.08L21.23,15.56C21.05,15.74 20.8,15.86 20.5,15.86C20.25,15.86 20,15.75 19.82,15.57C19.03,14.84 18.14,14.21 17.16,13.72C16.83,13.56 16.6,13.22 16.6,12.82V9.72C15.15,9.25 13.6,9 12,9Z"
							/>
						</svg>
					</button>
					<span class="media-tooltip" v-text="$t('exit')"></span>
				</span>
			</div>
			<div class="Controls-info">
				<span class="chat-action">
					<button class="media-effects" :class="{ mediapipeOn: mediapipeOn }" @click="manageRightBox('background')">
						<svg viewBox="0 0 24 24" style="width: 24px; height: 24px">
							<path
								fill="currentColor"
								d="M10.6 9.6L9 15L7.4 9.6L2 8L7.4 6.4L9 1L10.6 6.4L16 8L10.6 9.6M17 14.2L21 12L18.8 16L21 20L17 17.8L13 20L15.2 16L13 12L17 14.2M10 16L8.3 19L10 22L7 20.3L4 22L5.7 19L4 16L7 17.7L10 16"
							></path>
						</svg>
					</button>
					<span class="media-tooltip" v-text="$t('video_settings')"></span>
				</span>
				<span class="chat-action list-users" @click="manageRightBox('list')">
					<span class="count-badge list-users-count" :class="{ active: newUser }">{{ videoList.filter((f) => !f.isScreenShare).length }}</span>
					<button :class="{ active: partecipantsVisible }">
						<svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
							<path
								d="M16 17V19H2V17S2 13 9 13 16 17 16 17M12.5 7.5A3.5 3.5 0 1 0 9 11A3.5 3.5 0 0 0 12.5 7.5M15.94 13A5.32 5.32 0 0 1 18 17V19H22V17S22 13.37 15.94 13M15 4A3.39 3.39 0 0 0 13.07 4.59A5 5 0 0 1 13.07 10.41A3.39 3.39 0 0 0 15 11A3.5 3.5 0 0 0 15 4Z"
							/>
						</svg>
					</button>
					<span class="media-tooltip" v-text="!partecipantsVisible ? $t('open_list') : $t('close_list')"></span>
				</span>
				<span class="chat-action" @click="manageRightBox('chat')">
					<span class="count-badge message-chat-count" v-if="countMessage > 0">{{ countMessage }}</span>
					<button :class="{ active: chatVisible }" style="margin-top: 4px">
						<svg viewBox="0 0 24 24">
							<path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M6,9H18V11H6M14,14H6V12H14M18,8H6V6H18" />
						</svg>
					</button>
					<span class="media-tooltip" v-text="!chatVisible ? $t('open_chat') : $t('close_chat')"></span>
				</span>
				<span class="chat-action-mobile">
					<div class="menu-list" :class="{ show: chatActionMobile }">
						<div class="menu-list-close" @click="chatActionMobile = false">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
								<title>close</title>
								<path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
							</svg>
						</div>
						<!-- <div class="menu-list-option" @click="openMediaPipeFromMobile" :class="{ disabled: isEffectsDisabled }">
							<svg viewBox="0 0 24 24" style="width: 24px; height: 24px">
								<path
									fill="rgba(85,85,85,.8)"
									d="M10.6 9.6L9 15L7.4 9.6L2 8L7.4 6.4L9 1L10.6 6.4L16 8L10.6 9.6M17 14.2L21 12L18.8 16L21 20L17 17.8L13 20L15.2 16L13 12L17 14.2M10 16L8.3 19L10 22L7 20.3L4 22L5.7 19L4 16L7 17.7L10 16"
								></path>
							</svg>
							<span>{{ $t('video_settings') }}</span>
						</div> -->
						<div
							class="menu-list-option"
							:class="recordOn || hasOtherRecordingParticipants ? 'menu-list-option-recording' : ''"
							@click="recordVideo()"
							:disabled="hasOtherRecordingParticipants && !recordOn"
						>
							<svg viewBox="0 0 24 24" style="width: 22px; height: 22px">
								<path
									fill="rgba(85,85,85,.8)"
									:d="
										recordOn
											? 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z'
											: 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z'
									"
								/>
							</svg>
							<span>{{ $t('recordVideo') }} </span>
						</div>
						<div class="menu-list-option menu-list-option-blur" @click="manageRightBox('background')">
							<svg viewBox="0 0 24 24" style="width: 22px; height: 22px">
								<path
									fill="rgba(85,85,85,.75)"
									d="M10.6 9.6L9 15L7.4 9.6L2 8L7.4 6.4L9 1L10.6 6.4L16 8L10.6 9.6M17 14.2L21 12L18.8 16L21 20L17 17.8L13 20L15.2 16L13 12L17 14.2M10 16L8.3 19L10 22L7 20.3L4 22L5.7 19L4 16L7 17.7L10 16"
								></path>
							</svg>
							<span>{{ $t('bgAndBlur') }} </span>
						</div>
						<div class="menu-list-option" @click="manageRightBox('chat')">
							<svg viewBox="0 0 24 24" style="width: 22px; height: 22px">
								<path fill="rgba(85,85,85,.8)" d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M6,9H18V11H6M14,14H6V12H14M18,8H6V6H18" />
							</svg>
							<span>Chat </span>
						</div>
						<div class="menu-list-option" @click="manageRightBox('list')">
							<svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
								<path
									fill="rgba(85,85,85,.8)"
									d="M16 17V19H2V17S2 13 9 13 16 17 16 17M12.5 7.5A3.5 3.5 0 1 0 9 11A3.5 3.5 0 0 0 12.5 7.5M15.94 13A5.32 5.32 0 0 1 18 17V19H22V17S22 13.37 15.94 13M15 4A3.39 3.39 0 0 0 13.07 4.59A5 5 0 0 1 13.07 10.41A3.39 3.39 0 0 0 15 11A3.5 3.5 0 0 0 15 4Z"
								/>
							</svg>
							<span>{{ $t('partecipants') }} </span>
						</div>
					</div>
					<svg class="settings" style="width: 22px; height: 22px" viewBox="0 0 24 24" @click="chatActionMobile = !chatActionMobile">
						<path fill="white" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
					</svg>
				</span>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/event-bus'
import UserList from './UserList.vue'
import Chat from './Chat.vue'
import dayjs from 'dayjs'
import { requiresIOSVideoWorkaround, getPlatformInfo } from '../../utils/platformDetection'
import { parseIdentity, getNameFromIdentity, getEmailFromIdentity } from '../../utils/identityUtils'
import { getBlurFilterRadius } from '../../utils/blurFilters'
import { goapi } from '../../api'
import i18n from '@/i18n'
dayjs.locale(i18n.locale)

// SimpleSignalClient removed - now using Twilio Video

export default Vue.extend({
	name: 'vue-webrtc',
	components: {
		UserList,
		Chat
	},
	data() {
		return {
			showMediaPipe: false,
			canvasVisible: false,
			background: null,
			inheritedProcessors: null,
			blur: 0,
			backgrounds: [
				{ image: '/backgrounds/office1.jpg', tooltip: 'Contemporarary open space' },
				{ image: '/backgrounds/office2.jpg', tooltip: 'Cozy workplace at home' },
				{ image: '/backgrounds/office3.jpg', tooltip: 'Simple office' },
				{ image: '/backgrounds/office4.jpg', tooltip: 'Houseplants background' },
				{ image: '/backgrounds/office5.jpg', tooltip: 'Creative office' },
				{ image: '/backgrounds/office6.jpg', tooltip: 'Modern office' },
				{ image: '/backgrounds/office7.jpg', tooltip: 'Medical office' },
				{ image: '/backgrounds/office8.jpg', tooltip: 'Modern white office' },
				{ image: '/backgrounds/office9.jpg', tooltip: 'Office background' },
				{ image: '/backgrounds/office10.jpg', tooltip: 'Office interior' },
				{ image: '/backgrounds/office11.jpg', tooltip: 'Office with various plants' }
				// { image: '/backgrounds/office12.jpg', tooltip: 'Office room with a white background' }
			],
			mediapipeOn: false,
			videoProcessors: null,
			currentProcessor: null,
			currentBlurLevel: null,
			previewProcessor: null,
			previewBlurLevel: null,
			previewVideoTrack: null,
			previewRenderingLoop: null,
			// Virtual background processor variables
			virtualBackgroundProcessor: null,
			currentVirtualBackground: null,
			previewVirtualBackground: null,
			backgroundsLoading: false,
			chatActionMobile: false,
			showEmoji: false,
			meetName: '',
			localStream: null,
			localVideoTrack: null,
			localAudioTrack: null,
			signalClient: null,
			videoList: [],
			canvas: null,
			socket: null,
			// style
			margin: 10,
			aspect: 0,
			dishWidth: 0,
			dishHeight: 0,
			videoOn: false,
			audioOn: false,
			shareOn: false,
			screenStream: MediaStream,
			screenTrack: null, // Twilio LocalVideoTrack for screen sharing
			partecipant: null, // it's me
			chatVisible: false,
			messages: [],
			textMessage: '',
			countMessage: 0,
			newUser: false,
			partecipantsVisible: false,
			alreadyOpen: false,
			recordOn: false,
			recordingInProgress: false,
			recordedScreen: MediaStream,
			mediaRecorder: null,
			timestampRecord: null,
			dayjs,
			interval: null,
			showPartecipants: false,
			image: null,
			selfieStart: false,
			selfieSegementationsCostructors: [],
			selfieSegementationsImages: [],
			cameras: [],
			showToast: false,
			toastType: 'recording',
			alertTimeout: null,
			leftParticipantName: '',
			tmpVideoList: [],
			twilioRoom: null,
			participantTracks: {},
			isIOSDevice: requiresIOSVideoWorkaround(),
			platformInfo: getPlatformInfo(),
			noiseCancellation: true, // Always enabled by default
			localDataTrack: null, // Twilio LocalDataTrack for chat (created in join method)
			remoteDataTracks: new Map(), // Map to store remote data tracks by participant
			recordingParticipantEmails: new Set() // Track participant emails during recording (add-only)
		}
	},
	props: {
		roomId: {
			type: String,
			default: 'public-room-v2'
		},
		cameraHeight: {
			type: [Number, String],
			default: 160
		},
		autoplay: {
			type: Boolean,
			default: true
		},
		screenshotFormat: {
			type: String,
			default: 'image/jpeg'
		},
		enableLogs: {
			type: Boolean,
			default: true
		},
		deviceId: {
			type: String,
			default: null
		}
	},
	watch: {
		chatVisible() {
			if (this.chatVisible) {
				this.countMessage = 0
			}
		},
		videoList: {
			// Will fire as soon as the component is created
			immediate: true,
			deep: true,
			handler() {
				// Only handle layout changes, not recording toast
				this.dimensions()
			}
		},
		recordingParticipants: {
			immediate: true,
			handler(newRecordingParticipants, oldRecordingParticipants) {
				// Show toast only when recording participants actually change
				const hasRecordingParticipants = newRecordingParticipants && newRecordingParticipants.length > 0
				const hadRecordingParticipants = oldRecordingParticipants && oldRecordingParticipants.length > 0

				// Only show toast if:
				// 1. There are new recording participants AND
				// 2. This is a state change (not just a re-render)
				if (hasRecordingParticipants && !hadRecordingParticipants) {
					// Clear any existing timeout to avoid conflicts
					if (this.alertTimeout) {
						clearTimeout(this.alertTimeout)
					}

					this.toastType = 'recording'
					this.showToast = true
					this.alertTimeout = setTimeout(() => {
						this.showToast = false
						this.alertTimeout = null
					}, 5000)
				} else if (!hasRecordingParticipants && hadRecordingParticipants) {
					// Recording has stopped - show recording ended notification
					if (this.alertTimeout) {
						clearTimeout(this.alertTimeout)
						this.alertTimeout = null
					}

					// Show recording ended message to all participants
					this.toastType = 'recording_ended'
					this.showToast = true
					this.alertTimeout = setTimeout(() => {
						this.showToast = false
						this.alertTimeout = null
					}, 7000)
				} else if (!hasRecordingParticipants && this.showToast && (this.toastType === 'recording' || this.toastType === 'recording_ended')) {
					// Hide toast immediately if no one is recording anymore - but only for recording toasts
					if (this.alertTimeout) {
						clearTimeout(this.alertTimeout)
						this.alertTimeout = null
					}
					this.showToast = false
				}
			}
		}
	},
	computed: {
		isEffectsDisabled() {
			const local = this.videoList.find((f) => f.isLocal)
			if (local) {
				return !local.videoEnabled
			}
			return false
		},
		getPartecipants() {
			const string = this.textMessage.slice(1)
			let filtred = JSON.parse(JSON.stringify(this.videoList))
			if (string !== '') {
				try {
					filtred = filtred.filter((f) => !f.isLocal && f.name?.toLowerCase().replace(' ', '_').startsWith(string.toLowerCase()))
				} catch (error) {
					console.log('REPLACE', error)
				}
			} else {
				filtred = filtred.filter((f) => !f.isLocal)
			}
			if (filtred) {
				filtred.forEach((p) => {
					try {
						p.name = p.name.replace(' ', '_')
					} catch (error) {
						console.log('REPLACE', error)
					}
				})
				return filtred
			}
			return []
		},
		getTop() {
			if (this.getPartecipants) {
				let calc = this.getPartecipants.length * 25
				calc = calc + 28
				return calc >= 135 ? 135 : calc
			}
			return 0
		},
		getTime() {
			return this.timestampRecord.format('HH:mm:ss')
		},
		getRecordingName() {
			let name = ''
			for (let i = this.videoList.length - 1; i >= 0; i--) {
				const v = this.videoList[i]
				if (v.isRecording && !v.isLocal) {
					name = v.name.charAt(0).toUpperCase() + v.name.slice(1) + ' '
					break
				}
			}
			return name
		},
		getLeftParticipantName() {
			return this.leftParticipantName.charAt(0).toUpperCase() + this.leftParticipantName.slice(1)
		},
		ratio() {
			return 3 / 4
		},
		getVideoStyle() {
			const m = this.margin + 'px'
			const w = this.dishWidth + 'px'
			const h = this.dishWidth * this.ratio + 'px'
			return {
				width: w,
				margin: m,
				height: h
			}
		},
		videoPinned() {
			return this.videoList.find((f) => f.pinned)
		},
		recordingParticipants() {
			return this.videoList.filter((v) => v.isRecording && !v.isLocal)
		},
		hasOtherRecordingParticipants() {
			return this.recordingParticipants.length > 0
		},
		getCurrentUserId() {
			return this.partecipant?.partecipantName || null
		}
	},
	methods: {
		getName(item) {
			console.log('---> GETNAME START <---')
			if (item.name) {
				const name = item.name.split(' ')
				// Gestisce casi con solo un nome o nomi multipli
				let initials = name[0].substring(0, 1).toUpperCase()
				if (name.length > 1 && name[1]) {
					initials += name[1].substring(0, 1).toUpperCase()
				}
				return initials
			}

			console.log('---> GETNAME END <---')
			return ''
		},
		openMediaPipeFromMobile() {
			if (!this.isEffectsDisabled) {
				this.manageRightBox('background')
			}
		},
		moveUlFocus(e) {
			if ((e.keyCode === 38 || e.keyCode === 40) && this.showPartecipants) {
				const ul = document.getElementById('ul-list-messages')
				let index = null
				for (let i = 0; i < ul.children.length; i++) {
					const c = ul.children[i]
					if (c === document.activeElement) {
						index = i
						break
					}
				}
				if (index === null) {
					index = e.keyCode === 38 ? 1 : ul.children.length
				}
				if (e.keyCode === 38) {
					if (index > 0) {
						ul.children[index - 1].focus()
					} else {
						ul.children[ul.childElementCount - 1].focus()
					}
				} else {
					if (index >= ul.childElementCount - 1) {
						ul.children[0].focus()
					} else {
						ul.children[index + 1].focus()
					}
				}
			}
		},
		showSuggestion(e) {
			if (e.type === 'click') {
				this.showPartecipants = true
			}
			this.showEmoji = false
			const ul = document.getElementById('ul-list-messages')
			let li = null
			if (ul) {
				li = e.keyCode === 38 || e.type === 'click' ? ul.firstChild : ul.lastChild
			}
			if (li) {
				if (e.type === 'click') {
					ul.parentNode.style.left = '-33px'
					li.focus()
				} else {
					if ((e.keyCode === 38 || e.keyCode === 40) && this.showPartecipants) {
						li.focus()
					}
					if (e.target.selectionStart === 1) {
						this.showPartecipants = true
					}
					if (this.textMessage.charAt(0) === '@') {
						const split = this.textMessage.split(' ')
						if (split.length === 1) {
							const string = this.textMessage.slice(1)
							const found = this.videoList.find((f) => !f.isLocal && f.name.toLowerCase().startsWith(string.toLowerCase()))
							if (found.name === string) {
								this.showPartecipants = false
							} else {
								found ? (this.showPartecipants = true) : (this.showPartecipants = false)
							}
						} else {
							this.showPartecipants = false
						}
					} else {
						this.showPartecipants = false
					}
				}
			}
		},
		setSuggestion(name) {
			try {
				this.textMessage = '@' + name.replace(' ', '_') + ' '
			} catch (error) {
				console.log('REPLACE', error)
			}
			this.showPartecipants = false
			const input = document.getElementById('field-chat-messages')
			input.focus()
		},
		startLocal() {
			const newVideo = document.createElement('video')
			newVideo.srcObject = this.localStream
			newVideo.autoplay = true
			newVideo.muted = true
			newVideo.controls = false

			let canvasElement = document.getElementsByClassName('output_canvas_preview')[0]
			while (!canvasElement) {
				canvasElement = document.getElementsByClassName('output_canvas_preview')[0]
			}
		},
		onResults(canvasCtx, canvasElement, results) {
			canvasCtx.save()
			canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height)
			canvasCtx.drawImage(results.segmentationMask, 0, 0, canvasElement.width, canvasElement.height)

			// Only overwrite existing pixels.
			canvasCtx.globalCompositeOperation = 'source-in'
			canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height)

			// Only overwrite missing pixels.
			canvasCtx.globalCompositeOperation = 'destination-atop'
			canvasCtx.filter = 'blur(' + this.blur + 'px)'
			// canvasCtx.filter = 'hue-rotate(90deg)'

			if (this.image) {
				canvasCtx.drawImage(this.image, 0, 0, canvasElement.width, canvasElement.height)
			} else {
				canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height)
			}
			canvasCtx.restore()
		},
		setImageSrc() {
			this.image = null
			let i = null
			i = document.createElement('img')
			if (this.background && this.background.image) {
				i.src = this.background.image
				this.image = i
			}
		},
		closeModal() {
			if ((!this.background || this.background.image === '') && (!this.blur || this.blur <= 0)) {
				this.selfieStart = false
			}
			this.showMediaPipe = false
			this.canvasVisible = false
		},
		async saveMediaPipe() {
			console.log('Saving media pipe settings with Twilio processors')
			const localVideo = this.videoList.find((v) => v.isLocal)

			// Save preview settings to actual settings
			this.blur = this.previewBlurLevel || 0
			this.currentVirtualBackground = this.previewVirtualBackground
			this.background = this.previewVirtualBackground

			// Apply the effects to the video stream
			if (this.previewVirtualBackground && this.previewVirtualBackground.image) {
				// Apply virtual background
				await this.applyVirtualBackgroundToMainVideo(this.previewVirtualBackground)
			} else if (this.blur > 0) {
				// Apply blur filter
				await this.applyActualBlurFilter(this.blur)
			} else {
				// Remove all effects
				await this.removeVideoProcessor()
			}

			if (localVideo) {
				// Update local video effects
				if (this.currentVirtualBackground && this.currentVirtualBackground.image) {
					localVideo.videoEffects.blur = 0
					localVideo.videoEffects.src = this.currentVirtualBackground.image
					this.mediapipeOn = true
				} else if (this.blur > 0) {
					localVideo.videoEffects.blur = this.blur
					localVideo.videoEffects.src = ''
					this.mediapipeOn = true
				} else {
					localVideo.videoEffects.blur = 0
					localVideo.videoEffects.src = ''
					this.mediapipeOn = false
				}

				// Emit to other participants (if socket is available)
				if (this.socket) {
					this.socket.emit('manageMediapipe', {
						key: this.roomId,
						id: localVideo.id,
						videoEffects: localVideo.videoEffects
					})
				}
			}

			this.showMediaPipe = false
			this.canvasVisible = false
		},
		async applyActualBlurFilter(blurLevel) {
			console.log('Applying actual blur filter level:', blurLevel)

			if (blurLevel === 0) {
				// Remove blur filter
				await this.removeVideoProcessor()
				return
			}

			try {
				// Initialize video processors if needed
				if (!this.videoProcessors) {
					await this.initializeVideoProcessors()
				}

				// Clean up existing processor
				await this.removeVideoProcessor()

				// Create new blur processor
				const { GaussianBlurBackgroundProcessor } = this.videoProcessors
				const blurFilterRadius = getBlurFilterRadius(blurLevel)

				this.currentProcessor = new GaussianBlurBackgroundProcessor({
					assetsPath: window.location.origin + '/video-processors',
					blurFilterRadius: blurFilterRadius
				})

				console.log('Loading actual processor model...')
				await this.currentProcessor.loadModel()
				console.log('Actual model loaded successfully')

				// Apply processor to local video track
				await this.applyProcessorToLocalTrack()
			} catch (error) {
				console.error('Failed to apply actual blur filter:', error)
			}
		},
		async applyBlur(blurLevel) {
			console.log('Showing blur preview level:', blurLevel)
			// Only change preview settings, NOT the saved settings (this.blur)
			this.previewBlurLevel = blurLevel
			this.previewVirtualBackground = null // Clear virtual background when applying blur
			this.background = null

			// Show preview in canvas (this should NOT affect the live video)
			await this.showBlurPreview(blurLevel)
		},
		calculatePreviewCanvasDimensions(videoWidth, videoHeight, containerWidth = 300, containerHeight = 225) {
			// Calculate aspect ratios
			const videoAspectRatio = videoWidth / videoHeight
			const containerAspectRatio = containerWidth / containerHeight

			let canvasWidth, canvasHeight

			if (videoAspectRatio > containerAspectRatio) {
				// Video is wider than container - fit to width
				canvasWidth = containerWidth
				canvasHeight = containerWidth / videoAspectRatio
			} else {
				// Video is taller than container - fit to height
				canvasHeight = containerHeight
				canvasWidth = containerHeight * videoAspectRatio
			}

			return {
				width: Math.round(canvasWidth),
				height: Math.round(canvasHeight),
				aspectRatio: videoAspectRatio
			}
		},
		async showBlurPreview(blurLevel) {
			// Don't create preview if video is turned off
			if (!this.videoOn) {
				console.log('Video is OFF - skipping blur preview')
				return
			}

			if (blurLevel === 0) {
				// Use unified removal logic instead of duplicate code
				await this.removeAllEffectsAndShowOriginal()
				return
			}

			try {
				// Initialize video processors if needed
				if (!this.videoProcessors) {
					await this.initializeVideoProcessors()
				}

				// Create preview video track
				const previewTrack = await this.createPreviewTrack()
				if (!previewTrack) {
					console.error('Failed to create preview track')
					return
				}

				// Create or update preview processor
				if (!this.previewProcessor || this.previewBlurLevel !== blurLevel) {
					// Clean up existing processor first
					if (this.previewProcessor) {
						this.previewProcessor = null
					}

					const { GaussianBlurBackgroundProcessor } = this.videoProcessors
					const blurFilterRadius = getBlurFilterRadius(blurLevel)
					this.previewProcessor = new GaussianBlurBackgroundProcessor({
						assetsPath: window.location.origin + '/video-processors',
						blurFilterRadius: blurFilterRadius
					})

					console.log('Loading preview processor model...')
					await this.previewProcessor.loadModel()
					console.log('Preview model loaded successfully')

					this.previewBlurLevel = blurLevel
				}

				// Apply processor to preview track
				console.log('Adding processor to preview track...')
				try {
					await previewTrack.addProcessor(this.previewProcessor, {
						inputFrameBufferType: 'videoframe',
						outputFrameBufferContextType: 'bitmaprenderer'
					})
					console.log('Processor attached successfully to preview track')
				} catch (processorError) {
					console.error('Failed to attach processor to preview track:', processorError)
					console.log('Proceeding with unprocessed preview track')
				}

				// Start rendering to canvas
				await this.startPreviewRendering(previewTrack)
			} catch (error) {
				console.error('Failed to show blur preview:', error)
				await this.cleanupPreviewTrack()
			}
		},
		async startPreviewRendering(previewTrack) {
			try {
				// Get the hidden video element
				const hiddenVideo = document.getElementById('hidden-preview-video')
				if (!hiddenVideo) {
					console.error('Hidden preview video element not found')
					return
				}

				// Get the preview canvas
				const canvas = document.querySelector('.output_canvas_preview')
				if (!canvas) {
					console.error('Preview canvas not found')
					return
				}

				console.log('Preview track ready state before attach:', previewTrack.mediaStreamTrack.readyState)

				// Attach the processed preview track to the hidden video element
				previewTrack.attach(hiddenVideo)

				// Ensure video is playing
				try {
					await hiddenVideo.play()
					console.log('Hidden video started playing')
				} catch (error) {
					console.warn('Could not autoplay hidden video, but proceeding:', error)
				}

				// Wait for video to be ready and have dimensions
				await this.waitForVideoReady(hiddenVideo)

				// Calculate canvas dimensions maintaining aspect ratio
				const videoWidth = hiddenVideo.videoWidth || 320
				const videoHeight = hiddenVideo.videoHeight || 180

				// Get container dimensions (canvas-container has aspect-ratio 4/3)
				const canvasContainer = canvas.parentElement
				const containerRect = canvasContainer.getBoundingClientRect()

				const dimensions = this.calculatePreviewCanvasDimensions(videoWidth, videoHeight, containerRect.width || 300, containerRect.height || 225)

				canvas.width = dimensions.width
				canvas.height = dimensions.height

				console.log(`Canvas dimensions set to: ${canvas.width}x${canvas.height} (aspect ratio preserved)`)
				console.log(`Video dimensions: ${videoWidth}x${videoHeight}`)
				console.log(`Container dimensions: ${containerRect.width}x${containerRect.height}`)

				// Start the rendering loop
				const ctx = canvas.getContext('2d')
				let frameCount = 0

				const renderFrame = () => {
					try {
						frameCount++

						// Check if video has valid dimensions and is playing
						if (hiddenVideo.videoWidth > 0 && hiddenVideo.videoHeight > 0 && !hiddenVideo.paused) {
							// Clear the canvas
							ctx.clearRect(0, 0, canvas.width, canvas.height)

							// Draw the processed video frame to canvas
							ctx.drawImage(hiddenVideo, 0, 0, canvas.width, canvas.height)

							// Log first successful frame
							if (frameCount === 1) {
								console.log('First frame rendered successfully')
							}
						} else if (frameCount % 60 === 0) {
							// Log every 60 frames if video not ready
							console.log(
								`Video not ready for rendering - Width: ${hiddenVideo.videoWidth}, Height: ${hiddenVideo.videoHeight}, Paused: ${hiddenVideo.paused}, ReadyState: ${hiddenVideo.readyState}`
							)

							// Try to play video if it's paused
							if (hiddenVideo.paused && hiddenVideo.readyState >= 2) {
								console.log('Attempting to resume paused video')
								hiddenVideo.play().catch((e) => console.warn('Failed to resume video:', e))
							}
						}

						// Continue the rendering loop
						this.previewRenderingLoop = requestAnimationFrame(renderFrame)
					} catch (error) {
						console.error('Error in render frame:', error)
						// Continue the loop even if one frame fails
						this.previewRenderingLoop = requestAnimationFrame(renderFrame)
					}
				}

				// Start rendering
				renderFrame()
				console.log('Started preview rendering to canvas')
			} catch (error) {
				console.error('Failed to start preview rendering:', error)
				// Try fallback preview
				await this.startFallbackPreview()
			}
		},
		async applyVirtualBackground(backgroundImage) {
			console.log('Showing virtual background preview:', backgroundImage)
			// Only change preview settings, NOT the saved settings (this.currentVirtualBackground)
			this.previewVirtualBackground = backgroundImage
			this.previewBlurLevel = null // Clear blur when applying virtual background

			// Show preview in canvas (this should NOT affect the live video)
			await this.showVirtualBackgroundPreview(backgroundImage)
		},
		async showVirtualBackgroundPreview(backgroundImage) {
			// Don't create preview if video is turned off
			if (!this.videoOn) {
				console.log('Video is OFF - skipping virtual background preview')
				return
			}
			console.log('Showing virtual background preview for image:', backgroundImage)
			if (!backgroundImage) {
				console.log('Entro qui')

				// Use unified removal logic to avoid race conditions
				await this.removeAllEffectsAndShowOriginal()
				return
			}

			try {
				this.backgroundsLoading = true

				// Initialize video processors if needed
				if (!this.videoProcessors) {
					await this.initializeVideoProcessors()
				}

				// Create preview video track
				const previewTrack = await this.createPreviewTrack()
				if (!previewTrack) {
					console.error('Failed to create preview track')
					this.backgroundsLoading = false
					return
				}

				// Load the background image as HTMLImageElement
				const imageElement = await this.loadBackgroundImage(backgroundImage.image)

				// Create and configure virtual background processor
				const { VirtualBackgroundProcessor } = this.videoProcessors
				const virtualBackgroundProcessor = new VirtualBackgroundProcessor({
					assetsPath: '/video-processors/',
					backgroundImage: imageElement
				})

				console.log('Loading virtual background model...')
				await virtualBackgroundProcessor.loadModel()
				console.log('Virtual background model loaded successfully')

				// Apply virtual background processor to preview track
				await previewTrack.addProcessor(virtualBackgroundProcessor)

				this.previewProcessor = virtualBackgroundProcessor
				this.backgroundsLoading = false

				// Start rendering the processed preview
				await this.startPreviewRendering(previewTrack)

				console.log('Virtual background preview applied successfully')
			} catch (error) {
				console.error('Failed to apply virtual background preview:', error)
				this.backgroundsLoading = false
				// Try fallback to original video
				await this.showOriginalVideoPreview()
			}
		},
		async applyVirtualBackgroundToMainVideo(backgroundImage) {
			if (!backgroundImage || !backgroundImage.image) {
				console.log('Clearing virtual background from main video')
				await this.removeVideoProcessor()
				return
			}

			try {
				console.log('Applying virtual background to main video:', backgroundImage.image)

				// Initialize video processors if needed
				if (!this.videoProcessors) {
					await this.initializeVideoProcessors()
				}

				// Clean up existing processor
				if (this.virtualBackgroundProcessor) {
					console.log('Cleaning up existing virtual background processor')
					await this.removeVideoProcessor()
				}

				// Get the local video participant
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (!localVideo || !localVideo.stream) {
					console.error('No local video stream found')
					return
				}

				// Load the background image as HTMLImageElement
				const imageElement = await this.loadBackgroundImage(backgroundImage.image)

				// Create and configure virtual background processor
				const { VirtualBackgroundProcessor } = this.videoProcessors
				this.virtualBackgroundProcessor = new VirtualBackgroundProcessor({
					assetsPath: '/video-processors/',
					backgroundImage: imageElement
				})

				console.log('Loading virtual background model for main video...')
				await this.virtualBackgroundProcessor.loadModel()

				// Set the current processor reference
				this.currentProcessor = this.virtualBackgroundProcessor
				this.currentVirtualBackground = backgroundImage
				this.currentBlurLevel = null // Clear blur when applying virtual background

				// Apply processor to local video track using the same method as blur
				await this.applyProcessorToLocalTrack()

				console.log('Virtual background applied to main video successfully')
			} catch (error) {
				console.error('Failed to apply virtual background to main video:', error)
			}
		},
		async waitForVideoReady(videoElement) {
			return new Promise((resolve) => {
				const checkReady = () => {
					console.log(`Video readyState: ${videoElement.readyState}, dimensions: ${videoElement.videoWidth}x${videoElement.videoHeight}`)

					// Check if video has loaded metadata and has dimensions
					if (videoElement.readyState >= 2 && videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
						console.log('Video is ready for rendering')
						resolve()
					} else {
						// Continue checking
						setTimeout(checkReady, 100)
					}
				}

				// Add event listeners for video events
				videoElement.addEventListener('loadeddata', () => {
					console.log('Video loadeddata event fired')
					checkReady()
				})

				videoElement.addEventListener('canplay', () => {
					console.log('Video canplay event fired')
					checkReady()
				})

				videoElement.addEventListener('error', (e) => {
					console.error('Video error event:', e)
					resolve() // Resolve anyway to prevent hanging
				})

				// Start checking immediately
				checkReady()

				// Timeout after 5 seconds
				setTimeout(() => {
					console.warn('Video ready timeout, proceeding anyway')
					resolve()
				}, 5000)
			})
		},
		async loadBackgroundImage(imageSrc) {
			return new Promise((resolve, reject) => {
				const img = new Image()
				img.crossOrigin = 'anonymous'
				img.onload = () => {
					console.log('Background image loaded successfully:', imageSrc)
					resolve(img)
				}
				img.onerror = (error) => {
					console.error('Failed to load background image:', imageSrc, error)
					reject(new Error(`Failed to load background image: ${imageSrc}`))
				}
				img.src = imageSrc
			})
		},
		async startFallbackPreview() {
			try {
				console.log('Starting fallback preview (unprocessed video)')

				// Get elements
				const canvas = document.querySelector('.output_canvas_preview')
				if (!canvas) return

				// Try to use the original local video instead
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (!localVideo) return

				const videoElement = this.getLocalVideoElement(localVideo)
				if (!videoElement) return

				// Calculate canvas dimensions maintaining aspect ratio
				const videoWidth = videoElement.videoWidth || 320
				const videoHeight = videoElement.videoHeight || 180

				// Get container dimensions
				const canvasContainer = canvas.parentElement
				const containerRect = canvasContainer.getBoundingClientRect()

				const dimensions = this.calculatePreviewCanvasDimensions(videoWidth, videoHeight, containerRect.width || 300, containerRect.height || 225)

				canvas.width = dimensions.width
				canvas.height = dimensions.height

				console.log(`Fallback canvas dimensions: ${canvas.width}x${canvas.height} (aspect ratio preserved)`)
				const ctx = canvas.getContext('2d')

				// Simple rendering from original video
				const renderFallback = () => {
					if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
						ctx.clearRect(0, 0, canvas.width, canvas.height)
						ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height)
					}
					this.previewRenderingLoop = requestAnimationFrame(renderFallback)
				}

				renderFallback()
				console.log('Fallback preview started')
			} catch (error) {
				console.error('Fallback preview failed:', error)
			}
		},
		clearPreviewCanvas() {
			const canvas = document.querySelector('.output_canvas_preview')
			if (canvas) {
				const ctx = canvas.getContext('2d')
				ctx.clearRect(0, 0, canvas.width, canvas.height)
				console.log('Cleared preview canvas')
			}
		},
		async removeAllEffectsAndShowOriginal() {
			console.log('Removing all effects - clearing preview completely')

			// Immediately clear canvas to remove any effect frames
			const canvas = document.querySelector('.output_canvas_preview')
			if (canvas) {
				const canvasCtx = canvas.getContext('2d')
				canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
				console.log('Immediately cleared preview canvas for no effects')
			}

			// Only remove the processor, don't destroy the track!
			if (this.previewProcessor && this.previewVideoTrack) {
				console.log('Removing processor from preview track (keeping track alive)')
				try {
					// Check if processor is still attached to the track
					await this.previewVideoTrack.removeProcessor(this.previewProcessor)
					console.log('Processor removed, destroying it')

					// Safe destroy with null check
					if (this.previewProcessor && this.previewProcessor.destroy) {
						await this.previewProcessor.destroy()
					}
				} catch (err) {
					// Only log the error if it's not about processor already being removed
					if (!err.message.includes('No existing VideoProcessor')) {
						console.warn('Error removing processor:', err)
					}
				}
				this.previewProcessor = null
			}

			// Don't call cleanupPreviewTrack() here as it stops the video track!
			await this.showOriginalVideoPreview()
		},
		async clearAllEffects() {
			// Clear both blur and virtual background settings
			this.previewBlurLevel = 0
			this.previewVirtualBackground = null
			this.background = null

			// Use unified removal logic to prevent race conditions
			await this.removeAllEffectsAndShowOriginal()
		},
		getPreviewStream() {
			// Always try to use a safe stream for preview that won't affect live video
			console.log('Getting safe preview stream...')

			// Method 1: If we have a cloned preview track, create stream from it
			if (this.previewVideoTrack && this.previewVideoTrack.mediaStreamTrack) {
				console.log('Using cloned preview track for safe stream')
				const clonedStream = new MediaStream([this.previewVideoTrack.mediaStreamTrack])
				console.log('Created safe preview stream from cloned track:', {
					id: clonedStream.id,
					active: clonedStream.active,
					tracks: clonedStream.getTracks().length
				})
				return clonedStream
			}

			// Method 2: Get fresh video track from localVideo and clone it immediately
			const localVideo = this.videoList.find((v) => v.isLocal)
			if (localVideo && localVideo.stream && this.validateStreamSafety(localVideo.stream, 'localVideo.stream')) {
				console.log('Creating safe preview stream from validated local video stream')
				const videoTracks = localVideo.stream.getVideoTracks()
				if (videoTracks.length > 0) {
					const originalTrack = videoTracks[0]
					// Clone immediately to avoid touching the live stream
					const clonedTrack = originalTrack.clone()
					const safeStream = new MediaStream([clonedTrack])

					// Validate the created safe stream before returning
					if (this.validateStreamSafety(safeStream, 'safe preview stream')) {
						console.log('Created safe preview stream from fresh clone:', {
							id: safeStream.id,
							active: safeStream.active,
							originalTrackId: originalTrack.id,
							clonedTrackId: clonedTrack.id
						})
						return safeStream
					} else {
						console.error('Failed to create valid safe preview stream')
						// Clean up the failed stream
						clonedTrack.stop()
					}
				}
			}

			// Method 3: Fallback - but we should never reach this in normal conditions
			console.warn('No safe preview stream available - this should not happen!')
			return null
		},
		validateStreamSafety(stream, streamName = 'stream') {
			// Comprehensive validation of stream safety
			if (!stream) {
				console.warn(`${streamName} is null or undefined`)
				return false
			}

			if (!stream.active) {
				console.warn(`${streamName} is not active`)
				return false
			}

			const videoTracks = stream.getVideoTracks()
			if (videoTracks.length === 0) {
				console.warn(`${streamName} has no video tracks`)
				return false
			}

			const videoTrack = videoTracks[0]
			if (videoTrack.readyState !== 'live') {
				console.warn(`${streamName} video track is not live (state: ${videoTrack.readyState})`)
				return false
			}

			if (!videoTrack.enabled) {
				console.warn(`${streamName} video track is disabled`)
				return false
			}

			console.log(`${streamName} validation passed - stream is safe to use`)
			return true
		},
		async showOriginalVideoPreview() {
			try {
				console.log('=== SHOWING ORIGINAL VIDEO PREVIEW ===')

				// Don't create preview if video is turned off
				if (!this.videoOn) {
					console.log('Video is OFF - skipping original video preview')
					return
				}

				// Ensure any lingering processors are removed from preview track
				if (this.previewProcessor && this.previewVideoTrack) {
					console.log('Removing lingering processor before showing original video')
					try {
						await this.previewVideoTrack.removeProcessor(this.previewProcessor)
						// Safe destroy with null check
						if (this.previewProcessor && this.previewProcessor.destroy) {
							await this.previewProcessor.destroy()
						}
					} catch (err) {
						// Only log the error if it's not about processor already being removed
						if (!err.message.includes('No existing VideoProcessor')) {
							console.warn('Error removing lingering processor:', err)
						}
					}
					this.previewProcessor = null
				}

				// Use a safe preview stream that won't affect live video
				const hiddenVideo = document.getElementById('hidden-preview-video')
				if (!hiddenVideo) {
					console.error('Hidden preview video element not found')
					return
				}

				// Get safe preview stream (never use this.localStream directly!)
				const safePreviewStream = this.getPreviewStream()
				if (!safePreviewStream) {
					console.error('No safe preview stream available')
					return
				}

				console.log('Using safe preview stream for original preview')
				console.log('Safe stream active:', safePreviewStream.active)
				console.log(
					'Safe stream tracks:',
					safePreviewStream.getTracks().map((t) => t.readyState)
				)

				// Set the safe stream to the hidden video element
				hiddenVideo.srcObject = safePreviewStream
				await hiddenVideo.play()

				// Store reference to clean up later if needed
				this.currentPreviewStream = safePreviewStream

				// Get canvas for rendering
				const canvas = document.querySelector('.output_canvas_preview')
				if (!canvas) {
					console.error('Preview canvas not found')
					return
				}

				// Clear canvas before starting
				const canvasCtx = canvas.getContext('2d')
				canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
				console.log('Cleared preview canvas before showing original video')

				// Small delay to ensure canvas is completely cleared
				await new Promise((resolve) => setTimeout(resolve, 50))

				// Video element is already set above, just verify it's ready

				// Calculate canvas dimensions maintaining aspect ratio
				const videoWidth = hiddenVideo.videoWidth || 320
				const videoHeight = hiddenVideo.videoHeight || 180

				// Get container dimensions
				const canvasContainer = canvas.parentElement
				const containerRect = canvasContainer.getBoundingClientRect()

				const dimensions = this.calculatePreviewCanvasDimensions(videoWidth, videoHeight, containerRect.width || 300, containerRect.height || 225)

				canvas.width = dimensions.width
				canvas.height = dimensions.height

				console.log(`Original video canvas dimensions: ${canvas.width}x${canvas.height} (aspect ratio preserved)`)
				console.log(`Video dimensions: ${videoWidth}x${videoHeight}`)

				// Start rendering original video to canvas
				const ctx = canvas.getContext('2d')
				let frameCount = 0

				const renderOriginalFrame = () => {
					try {
						frameCount++

						// Check if video is ready and playing
						if (hiddenVideo.videoWidth > 0 && hiddenVideo.videoHeight > 0 && !hiddenVideo.paused) {
							// Clear canvas
							ctx.clearRect(0, 0, canvas.width, canvas.height)

							// Draw original video frame
							ctx.drawImage(hiddenVideo, 0, 0, canvas.width, canvas.height)

							// Log first successful frame
							if (frameCount === 1) {
								console.log('First original video frame rendered successfully')
							}
						} else if (frameCount % 60 === 0) {
							console.log(`Original video not ready - Width: ${hiddenVideo.videoWidth}, Height: ${hiddenVideo.videoHeight}, Paused: ${hiddenVideo.paused}`)
						}

						// Continue rendering loop
						this.previewRenderingLoop = requestAnimationFrame(renderOriginalFrame)
					} catch (error) {
						console.error('Error in original video rendering:', error)
						this.previewRenderingLoop = requestAnimationFrame(renderOriginalFrame)
					}
				}

				// Start rendering original video
				renderOriginalFrame()
				console.log('Started original video preview rendering')
			} catch (error) {
				console.error('Failed to show original video preview:', error)
			}
		},
		async removeProcessorsFromLocalVideo() {
			try {
				console.log('Removing processors from local video')

				// Find the local video element
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (!localVideo) {
					console.log('No local video found to remove processors from')
					return
				}

				const videoElement = this.getLocalVideoElement(localVideo)
				if (!videoElement) {
					console.log('Local video element not found')
					return
				}

				// Reset the video element source to the local stream
				if (this.localStream && this.validateStreamSafety(this.localStream, 'this.localStream for reset')) {
					console.log('Resetting local video to validated local stream')
					videoElement.srcObject = this.localStream
					videoElement.play().catch((e) => console.warn('Could not play reset video:', e))
				} else {
					console.warn('Cannot reset video - localStream is not safe')
				}

				console.log('Processors removed from local video')
			} catch (error) {
				console.error('Failed to remove processors from local video:', error)
			}
		},
		async applySelectedBlurToMainVideo() {
			try {
				console.log(`Applying selected blur (${this.blur}) to main video`)

				// Find the local video element
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (!localVideo) {
					console.log('No local video found')
					return
				}

				if (this.blur === 0) {
					// Remove any blur effects
					await this.removeProcessorsFromLocalVideo()
				} else {
					// Apply blur effect to main video
					await this.applyBlurToMainVideo(this.blur)
				}

				console.log(`Blur settings (${this.blur}) applied to main video`)
			} catch (error) {
				console.error('Failed to apply blur to main video:', error)
			}
		},
		async applyBlurToMainVideo(blurLevel) {
			try {
				console.log(`Applying blur level ${blurLevel} to main video`)

				// Initialize video processors if needed
				if (!this.videoProcessors) {
					await this.initializeVideoProcessors()
				}

				// Find the local video element
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (!localVideo) {
					console.log('No local video found for blur application')
					return
				}

				const videoElement = this.getLocalVideoElement(localVideo)
				if (!videoElement) {
					console.log('Local video element not found for blur application')
					return
				}

				// Create and apply blur processor to main video
				const blurProcessor = new this.videoProcessors.GaussianBlurBackgroundProcessor({
					assetsPath: window.location.origin + '/video-processors',
					blurFilterRadius: blurLevel * 10 // Convert to appropriate scale
				})

				await blurProcessor.loadModel()
				console.log('Blur processor loaded for main video')

				// Validate localStream before using it
				if (!this.validateStreamSafety(this.localStream, 'this.localStream for blur')) {
					console.error('localStream is not safe for blur application')
					return
				}

				// Clone the local track and apply processor
				const originalTrack = this.localStream.getVideoTracks()[0]
				const clonedTrack = originalTrack.clone()

				// Create Twilio LocalVideoTrack from cloned track
				const { LocalVideoTrack } = await import('twilio-video')
				const localVideoTrack = new LocalVideoTrack(clonedTrack, { name: 'main-video-with-blur' })

				// Add processor to the track
				await localVideoTrack.addProcessor(blurProcessor)

				// Update the video element with processed track
				localVideoTrack.attach(videoElement)
				await videoElement.play()

				console.log('Blur applied to main video successfully')
			} catch (error) {
				console.error('Failed to apply blur to main video:', error)
			}
		},
		async initializeVideoProcessors() {
			try {
				console.log('Initializing Twilio video processors')
				this.videoProcessors = await import('@twilio/video-processors')
				console.log('Video processors initialized successfully')
			} catch (error) {
				console.error('Failed to initialize video processors:', error)
			}
		},
		async reapplyActiveFilters() {
			try {
				console.log('=== REAPPLYING ACTIVE FILTERS ===')
				console.log('Current filter state:', {
					blur: this.blur,
					background: this.background,
					videoOn: this.videoOn
				})

				// Ensure video is actually on before applying filters
				if (!this.videoOn) {
					console.log('Video is off, skipping filter reapplication')
					return
				}

				// Wait for video track to be fully ready and published
				await new Promise((resolve) => setTimeout(resolve, 800))

				// Double-check that we have video tracks
				const videoPublications = Array.from(this.twilioRoom.localParticipant.videoTracks.values())
				if (videoPublications.length === 0) {
					console.log('No video tracks found, retrying in 500ms...')
					await new Promise((resolve) => setTimeout(resolve, 500))
				}

				// Initialize video processors if not already done
				if (!this.videoProcessors) {
					console.log('Initializing video processors for filter reapplication')
					await this.initializeVideoProcessors()
				}

				// Apply currently active filters with priority: background > blur
				if (this.background && this.background.image) {
					// Apply virtual background
					console.log('Reapplying virtual background:', this.background.image)
					await this.applyVirtualBackgroundToMainVideo(this.background)
					console.log('Virtual background reapplied successfully')
				} else if (this.blur && this.blur > 0) {
					// Apply blur filter
					console.log('Reapplying blur filter level:', this.blur)
					await this.applyActualBlurFilter(this.blur)
					console.log('Blur filter reapplied successfully')
				} else {
					console.log('No active filters to reapply')
				}

				console.log('=== FILTER REAPPLICATION COMPLETED ===')
			} catch (error) {
				console.error('Failed to reapply active filters:', error)
				// Retry once after a delay
				setTimeout(async () => {
					console.log('Retrying filter reapplication...')
					try {
						if (this.background && this.background.image) {
							await this.applyVirtualBackgroundToMainVideo(this.background)
						} else if (this.blur && this.blur > 0) {
							await this.applyActualBlurFilter(this.blur)
						}
						console.log('Filter reapplication retry completed')
					} catch (retryError) {
						console.error('Filter reapplication retry failed:', retryError)
					}
				}, 1000)
			}
		},
		async applyFiltersToNewTrack(videoTrack) {
			try {
				console.log('=== APPLYING FILTERS TO NEW TRACK ===')
				console.log('Current filter state:', {
					blur: this.blur,
					background: this.background?.image || null,
					videoOn: this.videoOn
				})

				// Initialize video processors if not already done
				if (!this.videoProcessors) {
					console.log('Initializing video processors for new track')
					await this.initializeVideoProcessors()
				}

				// Apply currently active filters with priority: background > blur
				if (this.background && this.background.image) {
					// Apply virtual background
					console.log('Applying virtual background to new track:', this.background.image)
					const { VirtualBackgroundProcessor } = this.videoProcessors
					const backgroundProcessor = new VirtualBackgroundProcessor({
						assetsPath: window.location.origin + '/video-processors',
						backgroundImage: await this.loadBackgroundImage(this.background.image)
					})
					await backgroundProcessor.loadModel()
					await videoTrack.addProcessor(backgroundProcessor)
					console.log('Virtual background applied to new track')
				} else if (this.blur && this.blur > 0) {
					// Apply blur filter
					console.log('Applying blur filter to new track, level:', this.blur)
					const { GaussianBlurBackgroundProcessor } = this.videoProcessors
					const blurProcessor = new GaussianBlurBackgroundProcessor({
						assetsPath: window.location.origin + '/video-processors',
						blurFilterRadius: this.blur * 10 // Convert to appropriate scale
					})
					await blurProcessor.loadModel()
					await videoTrack.addProcessor(blurProcessor)
					console.log('Blur filter applied to new track')
				} else {
					console.log('No active filters to apply to new track')
				}

				console.log('=== FILTER APPLICATION TO NEW TRACK COMPLETED ===')
			} catch (error) {
				console.error('Failed to apply filters to new track:', error)
				// Don't throw error - allow track to be published even without filters
			}
		},
		hasActiveFilters() {
			const hasBlur = this.blur && this.blur > 0
			const hasBackground = this.background && this.background.image
			return hasBlur || hasBackground
		},
		async createPreviewTrack() {
			try {
				// Don't create preview track if video is turned off
				if (!this.videoOn) {
					console.log('Video is OFF - skipping preview track creation')
					return null
				}

				// Clean up existing preview track first
				await this.cleanupPreviewTrack()

				// Get the current video stream from local participant
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (!localVideo || !localVideo.stream) {
					console.error('No local video stream found for preview')
					return null
				}

				console.log('Local video stream found:', {
					id: localVideo.id,
					streamId: localVideo.stream.id,
					active: localVideo.stream.active
				})

				// Get video track from the stream
				const videoTracks = localVideo.stream.getVideoTracks()
				if (videoTracks.length === 0) {
					console.error('No video tracks found in local stream')
					return null
				}

				const originalTrack = videoTracks[0]
				console.log('Original track details:', {
					id: originalTrack.id,
					kind: originalTrack.kind,
					readyState: originalTrack.readyState,
					enabled: originalTrack.enabled,
					settings: originalTrack.getSettings()
				})

				// Clone the video track to create an independent preview track
				const clonedTrack = originalTrack.clone()
				console.log('Cloned track created:', {
					id: clonedTrack.id,
					readyState: clonedTrack.readyState,
					enabled: clonedTrack.enabled
				})

				// Create LocalVideoTrack from cloned track
				const { createLocalVideoTrack } = await import('twilio-video')
				this.previewVideoTrack = await createLocalVideoTrack(clonedTrack)

				console.log('Preview video track created successfully:', {
					name: this.previewVideoTrack.name,
					sid: this.previewVideoTrack.sid,
					kind: this.previewVideoTrack.kind,
					isEnabled: this.previewVideoTrack.isEnabled,
					isStarted: this.previewVideoTrack.isStarted
				})

				return this.previewVideoTrack
			} catch (error) {
				console.error('Failed to create preview track:', error)
				return null
			}
		},
		async cleanupPreviewTrack() {
			try {
				// Stop rendering loop
				if (this.previewRenderingLoop) {
					cancelAnimationFrame(this.previewRenderingLoop)
					this.previewRenderingLoop = null
				}

				// Cleanup preview processor - MUST remove from track first!
				if (this.previewProcessor && this.previewVideoTrack) {
					console.log('Removing processor from preview track')
					try {
						// Remove the processor from the preview track
						await this.previewVideoTrack.removeProcessor(this.previewProcessor)
						console.log('Successfully removed processor from preview track')

						// Destroy the processor to free WebGL resources
						if (this.previewProcessor.destroy) {
							await this.previewProcessor.destroy()
							console.log('Preview processor destroyed successfully')
						}
					} catch (removeError) {
						console.warn('Error removing preview processor:', removeError)
					}
					this.previewProcessor = null
				}

				// Cleanup preview video track
				if (this.previewVideoTrack) {
					console.log('Cleaning up preview video track')
					this.previewVideoTrack.stop()
					this.previewVideoTrack = null
				}

				// Clear the hidden video element
				const hiddenVideo = document.getElementById('hidden-preview-video')
				if (hiddenVideo) {
					hiddenVideo.srcObject = null
				}

				// Clean up current preview stream and its tracks
				if (this.currentPreviewStream) {
					console.log('Cleaning up current preview stream')
					this.currentPreviewStream.getTracks().forEach(track => {
						track.stop()
						console.log('Stopped preview stream track:', track.id)
					})
					this.currentPreviewStream = null
				}

				// Clear preview canvas
				this.clearPreviewCanvas()

				console.log('Preview track cleanup completed')
			} catch (error) {
				console.error('Error during preview track cleanup:', error)
			}
		},
		async applyProcessorToLocalTrack() {
			if (!this.twilioRoom) {
				console.error('No Twilio room available')
				return
			}

			// Find the local participant's video track from Twilio room
			const localParticipant = this.twilioRoom.localParticipant
			if (!localParticipant) {
				console.error('No local participant found')
				return
			}

			// Find the video track publication
			let videoTrackPublication = null
			for (const publication of localParticipant.videoTracks.values()) {
				if (publication.track && !publication.track.name.includes('screen')) {
					videoTrackPublication = publication
					break
				}
			}

			if (!videoTrackPublication || !videoTrackPublication.track) {
				console.error('No local video track found in room')
				return
			}

			try {
				const localVideoTrack = videoTrackPublication.track
				console.log('Found local video track:', localVideoTrack)

				// Check if track already has processors and remove them first
				if (localVideoTrack.processor) {
					console.log('Removing existing processor from track before adding new one')
					try {
						await localVideoTrack.removeProcessor(localVideoTrack.processor)
						console.log('Existing processor removed successfully')
					} catch (removeError) {
						console.warn('Could not remove existing processor:', removeError)
					}
				}

				// Apply processor directly to the existing Twilio track
				await localVideoTrack.addProcessor(this.currentProcessor, {
					inputFrameBufferType: 'videoframe',
					outputFrameBufferContextType: 'bitmaprenderer'
				})

				console.log('Processor applied to video track successfully')

				// Update local video element to show processed video
				this.updateLocalVideoElement(localVideoTrack)
			} catch (error) {
				console.error('Failed to apply processor to local track:', error)
			}
		},
		updateLocalVideoElement(processedTrack) {
			console.log('=== UPDATE LOCAL VIDEO ELEMENT ===')
			// Find local video in videoList
			const localVideo = this.videoList.find((v) => v.isLocal)
			if (!localVideo) {
				console.error('No local video found in videoList')
				return
			}

			console.log('Local video found:', {
				id: localVideo.id,
				videoEnabled: localVideo.videoEnabled,
				hasStream: !!localVideo.stream,
				isPinned: localVideo.pinned
			})

			try {
				// Get the video element using helper function
				const videoElement = this.getLocalVideoElement(localVideo)
				if (!videoElement) {
					console.error('❌ Local video element not found with either ID:', localVideo.id, `or pinned_${localVideo.id}`)
					return
				}

				console.log('Video element found:', {
					id: videoElement.id,
					currentSrcObject: !!videoElement.srcObject,
					readyState: videoElement.readyState
				})

				// Note: With unified stream approach, no need to detach/attach tracks
				console.log('Video element will be updated by Vue reactivity')

				// Also clear any existing srcObject to ensure clean state
				if (videoElement.srcObject) {
					console.log('Clearing existing srcObject from video element')
					videoElement.srcObject = null
				}

				// Attach processed track
				console.log('Attaching processed track to video element:', {
					trackId: processedTrack.sid,
					hasProcessors: processedTrack.processors ? processedTrack.processors.length : 0
				})
				processedTrack.attach(videoElement)
				console.log('Attached processed track to local video element')

				console.log('Video element after attachment:', {
					readyState: videoElement.readyState,
					videoWidth: videoElement.videoWidth,
					videoHeight: videoElement.videoHeight
				})
			} catch (error) {
				console.error('Failed to update local video element:', error)
			}
		},
		getLocalVideoElement(localVideo) {
			// Helper function to get the local video element, checking both normal and pinned IDs
			let videoElement = document.getElementById(localVideo.id)
			let elementType = 'normal'

			if (!videoElement) {
				// Try pinned version
				const pinnedId = `pinned_${localVideo.id}`
				videoElement = document.getElementById(pinnedId)
				elementType = 'pinned'
				console.log('🔍 Trying pinned element ID:', pinnedId)
			}

			console.log(videoElement ? '✅ Found video element:' : '❌ No video element found:', elementType, videoElement?.id || 'none')
			return videoElement
		},
		async removeVideoProcessor() {
			try {
				console.log('Starting video processor removal', {
					hasCurrentProcessor: !!this.currentProcessor,
					hasInheritedProcessors: !!this.inheritedProcessors,
					inheritedProcessorsCount: this.inheritedProcessors?.length || 0
				})

				if (this.currentProcessor) {
					console.log('Removing current video processor from local track')

					// First restore the original video element
					await this.restoreOriginalVideoElement()

					// Find the local video track and remove processor from it
					const localParticipant = this.twilioRoom?.localParticipant
					if (localParticipant) {
						for (const publication of localParticipant.videoTracks.values()) {
							if (publication.track && !publication.track.name.includes('screen')) {
								await publication.track.removeProcessor(this.currentProcessor)
								console.log('Successfully removed processor from local track')
								break
							}
						}
					}

					// Clean up processor to free WebGL contexts
					if (this.currentProcessor.destroy) {
						await this.currentProcessor.destroy()
						console.log('Processor destroyed successfully')
					}

					// Store reference to current processor for inherited processors check
					const removedProcessor = this.currentProcessor

					this.currentProcessor = null
					this.currentBlurLevel = null

					// Remove the processor from inherited processors list if it's there to avoid duplicate removal
					if (this.inheritedProcessors) {
						this.inheritedProcessors = this.inheritedProcessors.filter((p) => p !== removedProcessor)
						console.log('Removed current processor from inherited processors list to avoid duplicate removal')
					}
				}

				// Also clean up virtual background processor if it exists
				if (this.virtualBackgroundProcessor) {
					console.log('Cleaning up virtual background processor')

					try {
						if (this.virtualBackgroundProcessor.destroy) {
							await this.virtualBackgroundProcessor.destroy()
						}
					} catch (error) {
						console.warn('Error destroying virtual background processor:', error)
					}

					this.virtualBackgroundProcessor = null
					this.currentVirtualBackground = null
				}

				// Clean up any remaining inherited processors from Preview if they exist
				if (this.inheritedProcessors && this.inheritedProcessors.length > 0 && this.localVideoTrack) {
					console.log('Removing remaining inherited processors from LocalVideoTrack:', this.inheritedProcessors.length)

					for (const processor of this.inheritedProcessors) {
						try {
							// Check if processor is still on the track
							if (this.localVideoTrack.processors && this.localVideoTrack.processors.includes(processor)) {
								await this.localVideoTrack.removeProcessor(processor)
								console.log('Removed inherited processor from LocalVideoTrack')

								// Destroy processor if possible
								if (processor.destroy) {
									await processor.destroy()
									console.log('Inherited processor destroyed')
								}
							} else {
								console.log('Inherited processor already removed from track')
							}
						} catch (error) {
							console.warn('Error removing inherited processor:', error)
						}
					}

					this.inheritedProcessors = null
					console.log('All inherited processors cleaned up')
				} else if (this.inheritedProcessors && this.inheritedProcessors.length === 0) {
					console.log('No inherited processors to remove (already handled by current processor removal)')
					this.inheritedProcessors = null
				}
			} catch (error) {
				console.error('Error removing video processor:', error)
			}
		},
		async restoreOriginalVideoElement() {
			// Find local video in videoList
			const localVideo = this.videoList.find((v) => v.isLocal)
			if (!localVideo) {
				return
			}

			try {
				// Get video element
				const videoElement = this.getLocalVideoElement(localVideo)
				if (!videoElement) {
					return
				}

				// Reset video element to use the localStream directly
				if (this.localStream) {
					try {
						videoElement.srcObject = this.localStream
						localVideo.stream = this.localStream
						console.log('Reset video element to use localStream')

						// Wait for stream to be ready before playing
						videoElement.onloadedmetadata = () => {
							videoElement.play().catch((e) => console.warn('Could not play reset video:', e))
						}
					} catch (resetError) {
						console.warn('Error resetting to localStream:', resetError)
					}
				}
			} catch (error) {
				console.error('Failed to restore original video element:', error)
			}
		},
		attachTrackToPinnedElement(localVideo) {
			console.log('🔗 [TWILIO ATTACH] Attaching track to pinned element')

			// Get both elements
			const normalElement = document.getElementById(localVideo.id)
			const pinnedElement = document.getElementById(`pinned_${localVideo.id}`)

			if (!normalElement) {
				console.log('🔗 [TWILIO ATTACH] Normal element not found:', localVideo.id)
				return
			}

			if (!pinnedElement) {
				console.log('🔗 [TWILIO ATTACH] Pinned element not found:', `pinned_${localVideo.id}`)
				return
			}

			// Find the local video track from Twilio
			if (this.localVideoTrack) {
				try {
					console.log('🔗 [TWILIO ATTACH] Detaching track from normal element')
					this.localVideoTrack.detach(normalElement)

					console.log('🔗 [TWILIO ATTACH] Attaching track to pinned element')
					const attachedElements = this.localVideoTrack.attach(pinnedElement)
					console.log('🔗 [TWILIO ATTACH] Successfully attached to pinned element:', attachedElements.length, 'elements')
				} catch (error) {
					console.error('🔗 [TWILIO ATTACH] Error during detach/attach for pinned:', error)
					// Fallback to stream assignment
					if (normalElement.srcObject) {
						pinnedElement.srcObject = normalElement.srcObject
					}
				}
			} else {
				console.log('🔗 [TWILIO ATTACH] No localVideoTrack found, using fallback')
				if (normalElement.srcObject) {
					pinnedElement.srcObject = normalElement.srcObject
				}
			}
		},
		attachTrackToNormalElement(localVideo) {
			console.log('🔗 [TWILIO ATTACH] Attaching track back to normal element')

			// Get both elements
			const normalElement = document.getElementById(localVideo.id)
			const pinnedElement = document.getElementById(`pinned_${localVideo.id}`)

			if (!normalElement) {
				console.log('🔗 [TWILIO ATTACH] Normal element not found:', localVideo.id)
				return
			}

			// Find the local video track from Twilio
			if (this.localVideoTrack) {
				try {
					// Detach from pinned element if it still exists
					if (pinnedElement) {
						console.log('🔗 [TWILIO ATTACH] Detaching track from pinned element')
						this.localVideoTrack.detach(pinnedElement)
					}

					console.log('🔗 [TWILIO ATTACH] Attaching track to normal element')
					const attachedElements = this.localVideoTrack.attach(normalElement)
					console.log('🔗 [TWILIO ATTACH] Successfully attached to normal element:', attachedElements.length, 'elements')
				} catch (error) {
					console.error('🔗 [TWILIO ATTACH] Error during detach/attach for normal:', error)
					// Fallback to stream assignment
					if (pinnedElement && pinnedElement.srcObject) {
						normalElement.srcObject = pinnedElement.srcObject
					} else if (localVideo.stream) {
						normalElement.srcObject = localVideo.stream
					}
				}
			} else {
				console.log('🔗 [TWILIO ATTACH] No localVideoTrack found, using fallback')
				if (pinnedElement && pinnedElement.srcObject) {
					normalElement.srcObject = pinnedElement.srcObject
				} else if (localVideo.stream) {
					normalElement.srcObject = localVideo.stream
				}
			}
		},
		attachToPinnedElementOnly(localVideo) {
			console.log('🔗 [ATTACH ONLY] Attaching track to pinned element only')

			const pinnedElement = document.getElementById(`pinned_${localVideo.id}`)

			if (!pinnedElement) {
				console.log('🔗 [ATTACH ONLY] Pinned element not found:', `pinned_${localVideo.id}`)
				return
			}

			// Find the local video track from Twilio and attach to pinned element
			if (this.localVideoTrack) {
				try {
					console.log('🔗 [ATTACH ONLY] Attaching track to pinned element')
					const attachedElements = this.localVideoTrack.attach(pinnedElement)
					console.log('🔗 [ATTACH ONLY] Successfully attached to pinned element:', attachedElements.length, 'elements')
				} catch (error) {
					console.error('🔗 [ATTACH ONLY] Error during attach to pinned:', error)
					// Fallback to stream assignment
					if (localVideo.stream) {
						pinnedElement.srcObject = localVideo.stream
					}
				}
			} else {
				console.log('🔗 [ATTACH ONLY] No localVideoTrack found, using fallback')
				if (localVideo.stream) {
					pinnedElement.srcObject = localVideo.stream
				}
			}
		},
		attachToNormalElementOnly(localVideo) {
			console.log('🔗 [ATTACH ONLY] Attaching track to normal element only')

			const normalElement = document.getElementById(localVideo.id)

			if (!normalElement) {
				console.log('🔗 [ATTACH ONLY] Normal element not found:', localVideo.id)
				return
			}

			// Find the local video track from Twilio and attach to normal element
			if (this.localVideoTrack) {
				try {
					console.log('🔗 [ATTACH ONLY] Attaching track to normal element')
					const attachedElements = this.localVideoTrack.attach(normalElement)
					console.log('🔗 [ATTACH ONLY] Successfully attached to normal element:', attachedElements.length, 'elements')
				} catch (error) {
					console.error('🔗 [ATTACH ONLY] Error during attach to normal:', error)
					// Fallback to stream assignment
					if (localVideo.stream) {
						normalElement.srcObject = localVideo.stream
					}
				}
			} else {
				console.log('🔗 [ATTACH ONLY] No localVideoTrack found, using fallback')
				if (localVideo.stream) {
					normalElement.srcObject = localVideo.stream
				}
			}
		},
		async reapplyCurrentEffects() {
			console.log('🔄 [REAPPLY DEBUG] Reapplying current effects')
			console.log('🔄 [REAPPLY DEBUG] Current blur:', this.blur)
			console.log('🔄 [REAPPLY DEBUG] Current virtual background:', this.currentVirtualBackground)

			try {
				if (this.currentVirtualBackground && this.currentVirtualBackground.image) {
					console.log('🔄 [REAPPLY DEBUG] Reapplying virtual background')
					await this.applyVirtualBackgroundToMainVideo(this.currentVirtualBackground)
				} else if (this.blur > 0) {
					console.log('🔄 [REAPPLY DEBUG] Reapplying blur filter')
					await this.applyActualBlurFilter(this.blur)
				}
				console.log('🔄 [REAPPLY DEBUG] Effects reapplication completed')
			} catch (error) {
				console.error('🔄 [REAPPLY DEBUG] Error reapplying effects:', error)
			}
		},
		// startMediaPipe(video) {
		// 	/* 		if (this.selfieSegementationsCostructors[video.id]) {
		// 		this.selfieSegementationsCostructors[video.id].close()
		// 		delete this.selfieSegementationsCostructors[video.id]
		// 		delete this.selfieSegementationsImages[video.id]
		// 		delete this.cameras[video.id]
		// 	} */
		// 	const videoElement = document.getElementById(video.id) ? document.getElementById(video.id) : document.getElementById('pinned_' + video.id)
		// 	if (!videoElement) return

		// 	videoElement.width = videoElement.parentNode.offsetWidth
		// 	videoElement.height = videoElement.parentNode.offsetHeight
		// 	const canvasElement = document.getElementsByClassName('output_canvas_' + video.id)[0]
		// 	const canvasCtx = canvasElement.getContext('2d')
		// 	let i = null
		// 	i = document.createElement('img')
		// 	i.width = videoElement.width
		// 	i.height = videoElement.height
		// 	i.src = video.videoEffects.src

		// 	this.selfieSegementationsImages[video.id] = i
		// 	if (!this.selfieSegementationsCostructors[video.id]) {
		// 		this.selfieSegementationsCostructors[video.id] = new SelfieSegmentation({
		// 			locateFile: (file) => {
		// 				return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`
		// 			}
		// 		})
		// 	}
		// 	this.selfieSegementationsCostructors[video.id].setOptions({
		// 		modelSelection: 1,
		// 		selfieMode: true
		// 	})

		// 	this.selfieSegementationsCostructors[video.id].onResults((results) => {
		// 		canvasCtx.save()
		// 		canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height)
		// 		canvasCtx.drawImage(results.segmentationMask, 0, 0, canvasElement.width, canvasElement.height)

		// 		// Only overwrite existing pixels.
		// 		canvasCtx.globalCompositeOperation = 'source-in'
		// 		canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height)

		// 		// Only overwrite missing pixels.
		// 		canvasCtx.globalCompositeOperation = 'destination-atop'
		// 		canvasCtx.filter = 'blur(' + video.videoEffects.blur + 'px)'

		// 		if (video.videoEffects.src) {
		// 			canvasCtx.drawImage(i, 0, 0, canvasElement.width, canvasElement.height)
		// 		} else {
		// 			canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height)
		// 		}

		// 		canvasCtx.restore()
		// 	})

		// 	const sendToMediaPipe = async () => {
		// 		if (!videoElement) {
		// 			requestAnimationFrame(sendToMediaPipe)
		// 		} else {
		// 			await this.selfieSegementationsCostructors[video.id]
		// 				.send({ image: videoElement })
		// 				.then(() => {
		// 					requestAnimationFrame(sendToMediaPipe)
		// 				})
		// 				.catch((err) => {
		// 					console.error(err)
		// 				})
		// 		}
		// 	}
		// 	sendToMediaPipe()
		// },
		toggleTimer() {
			this.interval = setInterval(() => {
				if (this.timestampRecord) {
					this.timestampRecord = this.timestampRecord.add(1, 'second')
				}
			}, 1000)
		},
		getBubbleMinWidth(text) {
			const canvas = this.getBubbleMinWidth.canvas || (this.getBubbleMinWidth.canvas = document.createElement('canvas'))
			const context = canvas.getContext('2d')
			const metrics = context.measureText(text)
			if (metrics.width > 70) {
				return 'min-width:' + metrics.width + 'px!important'
			}
		},
		addEmoji(emoji) {
			this.textMessage += ' ' + emoji.emoji + ' '
		},
		async manageRightBox(element) {
			this.chatActionMobile = false
			this.showEmoji = false
			if (element === 'chat') {
				if (this.partecipantsVisible) {
					this.alreadyOpen = true
				}
				this.showMediaPipe = false
				this.canvasVisible = false
				this.partecipantsVisible = false
				this.chatVisible = !this.chatVisible
				// Reset message counter when opening chat
				if (this.chatVisible) {
					this.countMessage = 0
				}
				const myTimeout = setTimeout(() => {
					const element = document.getElementById('chat-messages')
					if (element) {
						element.scrollTop = element.scrollHeight
					}
					this.dimensions()
					clearTimeout(myTimeout)
				}, 405)
			}

			if (element === 'list') {
				this.showMediaPipe = false
				this.canvasVisible = false
				this.chatVisible = false
				this.partecipantsVisible = !this.partecipantsVisible
				this.dimensions()
				const myTimeout = setTimeout(() => {
					this.dimensions()
					clearTimeout(myTimeout)
				}, 405)
			}
			if (element === 'background') {
				this.chatVisible = false
				this.partecipantsVisible = false
				this.showMediaPipe = !this.showMediaPipe
				const myTimeout = setTimeout(() => {
					this.dimensions()
					clearTimeout(myTimeout)
				}, 600)
				if (this.showMediaPipe) {
					// Check if video is currently enabled before starting preview
					if (this.videoOn) {
						console.log('Opening filters panel with video ON - starting preview')
						this.selfieStart = true
						this.startLocal()
						// Initialize preview blur level to current saved settings
						this.previewBlurLevel = this.blur
						// Delay canvas visibility to allow panel transition to complete
						setTimeout(() => {
							this.canvasVisible = true
							// Initialize default preview when opening the panel
							if (this.background && this.background.image) {
								// Show current virtual background in preview
								this.showVirtualBackgroundPreview(this.background)
							} else if (this.previewBlurLevel === 0) {
								this.showOriginalVideoPreview()
							} else {
								this.showBlurPreview(this.previewBlurLevel)
							}
						}, 1000) // Delay to allow panel transition to complete before showing canvas
					} else {
						console.log('Opening filters panel with video OFF - showing placeholder message')
						// Show a message that video is turned off
						this.canvasVisible = false
						// Could add a placeholder message here
					}
				} else {
					// Hide canvas immediately when closing panel
					this.canvasVisible = false
					// Clean up preview when closing modal
					this.cleanupPreviewTrack()

					// Do not apply blur settings when closing panel - only apply when user clicks "Save settings"
					// The blur should only be applied through saveMediaPipe() method
				}
			}

			if (this.chatVisible || this.partecipantsVisible || this.showMediaPipe) {
				this.margin = 20
			} else {
				this.margin = 10
			}
			this.dimensions()
		},
		async addMessage() {
			this.showEmoji = false
			if (this.textMessage === '') {
				return
			}
			if (this.textMessage.charAt(0) === '@') {
				const split = this.textMessage.trim().split(' ')
				if (split.length === 1) {
					return
				}
			}
			const date = new Date()
			let hours = date.getHours()
			hours = hours >= 10 ? hours : '0' + hours
			let minutes = date.getMinutes()
			minutes = minutes >= 10 ? minutes : '0' + minutes

			const message = {
				id: this.partecipant.partecipantName, // Use participant identity instead of local video ID
				name: this.partecipant.partecipantName,
				text: this.textMessage,
				time: hours + ':' + minutes,
				key: this.roomId,
				private: false,
				receiver: null
			}

			// Check if it's a private message
			if (this.textMessage.charAt(0) === '@') {
				try {
					// Extract the target name from the message (everything after @ until first space)
					const parts = this.textMessage.split(' ')
					const targetName = parts[0].substring(1) // Remove @ symbol

					console.log('Looking for private message target:', targetName)
					console.log(
						'Available participants:',
						this.videoList.map((v) => ({ name: v.name, isLocal: v.isLocal }))
					)

					// Find target participant by name match (handle spaces and underscores)
					const targetParticipant = this.videoList.find((f) => {
						if (!f.name || f.isLocal) return false

						const nameNormalized = f.name.toLowerCase().replace(/\s+/g, '_')
						const targetNormalized = targetName.toLowerCase().replace(/\s+/g, '_')

						console.log('🔍 SEND: Comparing normalized names:', nameNormalized, '===', targetNormalized)

						return nameNormalized === targetNormalized
					})

					if (targetParticipant) {
						message.receiver = targetParticipant.name // Use participant name instead of ID
						message.private = true
						const replacedText = parts.slice(1).join(' ') // Remove @username from message text
						message.text = replacedText
						console.log('🔵 SEND: Private message target found:', targetParticipant.name)
						console.log('🔵 SEND: Message receiver set to:', message.receiver)
						console.log('🔵 SEND: My name is:', this.partecipant.partecipantName)
					} else {
						console.log('🔴 SEND: Private message target not found:', targetName)
					}
				} catch (error) {
					console.log('Error finding recipient:', error)
				}
			}

			// Send message via persistent DataTrack with lazy creation
			if (this.twilioRoom) {
				try {
					// DataTrack is now created immediately in join() method, so it's always available
					if (!this.localDataTrack) {
						console.error('LocalDataTrack not available. Make sure you joined the room first.')
						return
					}

					// Add message to local list
					this.messages.push({
						message: message,
						private: message.private
					})

					// Send message via persistent DataTrack
					const messageData = JSON.stringify({
						type: 'chat',
						message: message
					})
					this.localDataTrack.send(messageData)
					console.log('Message sent via persistent DataTrack:', message)

					// Clear input and scroll to bottom
					this.textMessage = ''
					this.$nextTick(() => {
						const element = document.getElementById('chat-messages')
						if (element) {
							element.scrollTop = element.scrollHeight
						}
					})
				} catch (error) {
					console.error('Error sending message via persistent DataTrack:', error)
				}
			} else {
				console.warn('Twilio room not available, message not sent')
			}
		},
		async toggleVideo() {
			console.log('---> TOGGLEVIDEO START <---', this.videoOn, 'isIOSDevice:', this.isIOSDevice, new Date())

			if (this.twilioRoom && this.twilioRoom.localParticipant) {
				try {
					if (this.videoOn) {
						// DISATTIVA: ferma completamente la camera (luce si spegne)
						console.log('Stopping and unpublishing video tracks...')

						// 1. PRIMA: Cleanup dell'anteprima che mantiene la camera attiva
						console.log('Cleaning up preview system that maintains camera')
						await this.cleanupPreviewTrack()

						// 2. SECONDO: Cleanup dei processori attivi per liberare camera completamente
						if (this.currentProcessor) {
							console.log('Cleaning up current processor FIRST')
							try {
								// Rimuovi il processore dal track principale se esiste
								const localParticipant = this.twilioRoom?.localParticipant
								if (localParticipant && this.currentProcessor) {
									for (const publication of localParticipant.videoTracks.values()) {
										if (publication.track && !publication.track.name.includes('screen')) {
											await publication.track.removeProcessor(this.currentProcessor)
											console.log('Removed processor from local track')
											break
										}
									}
								}

								if (this.currentProcessor.destroy) {
									await this.currentProcessor.destroy()
									console.log('Processor destroyed')
								}
								this.currentProcessor = null
							} catch (error) {
								console.warn('Error cleaning up processor:', error)
							}
						}

						// 3. TERZO: Stop tutte le tracce locali (come fa Preview)
						if (this.localVideoTrack) {
							console.log('Stopping localVideoTrack (main camera reference)')
							this.localVideoTrack.stop()
							this.localVideoTrack = null
						}

						// 4. QUARTO: Stop tracce nel localStream
						this.localStream.getVideoTracks().forEach((track) => {
							console.log('Stopping and removing track from localStream')
							this.localStream.removeTrack(track)
							track.stop()
						})

						// 4.5. CRITICAL: Stop originalLocalVideoTrack che mantiene la camera attiva
						if (this.originalLocalVideoTrack) {
							console.log('Stopping originalLocalVideoTrack (camera light source)')
							this.originalLocalVideoTrack.stop()
							this.originalLocalVideoTrack = null
						}

						// 4.6. CRITICAL: Stop tracks in originalLocalStream che mantiene la camera attiva
						if (this.originalLocalStream) {
							console.log('Stopping tracks in originalLocalStream (main camera light source)')
							this.originalLocalStream.getVideoTracks().forEach((track) => {
								console.log('Stopping original stream video track')
								track.stop()
							})
							// Non mettiamo a null originalLocalStream perché potrebbe servire per riavviare
							// Ma dovremo ricrearla quando riaccendiamo la camera
						}

						// 4.7. CLEANUP: Cleanup any hidden video elements that might maintain camera access
						const hiddenVideo = document.getElementById('hidden-preview-video')
						if (hiddenVideo && hiddenVideo.srcObject) {
							console.log('Clearing hidden video element srcObject')
							hiddenVideo.srcObject = null
						}

						// 5. ULTIMO: Unpublish da Twilio (questo non dovrebbe influenzare la camera fisica)
						const videoPublications = Array.from(this.twilioRoom.localParticipant.videoTracks.values())
						for (const publication of videoPublications) {
							if (publication.track) {
								console.log('Unpublishing track from Twilio room')
								await this.twilioRoom.localParticipant.unpublishTrack(publication.track)
								// Non facciamo stop qui perché dovrebbe essere già fermata sopra
								console.log('Video track unpublished from room')
							}
						}
					} else {
						// RIATTIVA: crea nuova traccia video (luce si accende)
						console.log('Creating new video track...')
						const { createLocalTracks } = await import('twilio-video')

						// iOS-specific constraints for better compatibility - Following Twilio best practices
						const constraints = { audio: false, video: true }
						if (this.isIOSDevice) {
							constraints.video = {
								width: { ideal: 640 },
								height: { ideal: 480 },
								frameRate: { ideal: 30, max: 30 },
								facingMode: 'user'
							}
							console.log('Using iOS-specific video constraints following Twilio best practices:', constraints)
						}

						// Use createLocalTracks() as recommended by Twilio for mobile browsers
						// This prevents issues with multiple getUserMedia calls on mobile
						const localTracks = await createLocalTracks(constraints)
						const newVideoTrack = localTracks.find((track) => track.kind === 'video')

						if (newVideoTrack) {
							console.log('New video track created, applying filters before publishing...')

							// Apply filters BEFORE publishing to prevent others from seeing unfiltered video
							await this.applyFiltersToNewTrack(newVideoTrack)

							// Store reference to the video track for local display
							this.localVideoTrack = newVideoTrack
							console.log('Stored video track reference for local display')

							// Now publish the track with filters already applied
							await this.twilioRoom.localParticipant.publishTrack(newVideoTrack)
							console.log('New video track published with filters pre-applied')

							// Update localStream with new track (for compatibility)
							const oldVideoTracks = this.localStream.getVideoTracks()
							oldVideoTracks.forEach((track) => {
								console.log('Removing old video track from localStream')
								this.localStream.removeTrack(track)
							})
							this.localStream.addTrack(newVideoTrack.mediaStreamTrack)
							console.log('Updated localStream with new video track')

							// Update local participant in videoList with new stream FIRST
							this.$nextTick(() => {
								const localVideo = this.videoList.find((v) => v.isLocal)
								if (localVideo) {
									console.log('Updating local video participant with new stream')
									// Update the stream reference
									localVideo.stream = this.localStream
									localVideo.videoEnabled = true
									console.log('Local video participant updated successfully')

									// Force Vue re-render by updating component key if needed
									if (localVideo.id) {
										// Update timestamp to force re-render
										localVideo.lastUpdated = Date.now()
									}

									// THEN attach processed track if filters are active
									if (this.hasActiveFilters()) {
										console.log('Attaching processed track directly to local video element')
										console.log('Active filters detected:', {
											blur: this.blur,
											background: this.background?.image || null,
											hasProcessors: newVideoTrack.processors ? newVideoTrack.processors.length : 0
										})

										// Use nextTick to ensure DOM is updated before attachment
										this.$nextTick(() => {
											this.updateLocalVideoElement(newVideoTrack)
											console.log('Local video element updated with processed track')
										})
									} else {
										console.log('No active filters detected, using standard stream')
										// For no filters, just update the video element normally
										const videoElement = this.getLocalVideoElement(localVideo)
										if (videoElement) {
											console.log('Found video element, updating srcObject directly')
											videoElement.srcObject = this.localStream
											// Force video to reload
											videoElement.load()
										}
									}

									// Additional iOS-specific handling
									if (this.isIOSDevice) {
										console.log('iOS: Additional force update for video element')
										// Force videoEnabled to trigger UI refresh on iOS
										localVideo.videoEnabled = false
										this.$nextTick(() => {
											localVideo.videoEnabled = true
										})
									}
								}
							})
						} else {
							console.error('Failed to create video track with createLocalTracks()')
						}
					}
				} catch (error) {
					console.error('Error toggling video:', error)
					// Se c'è un errore, non cambiare lo stato
					return
				}
			}

			// Update local state and UI solo se tutto è andato bene
			this.videoOn = !this.videoOn

			// Update local video in videoList
			const localVideo = this.videoList.find((v) => v.isLocal)
			if (localVideo) {
				localVideo.videoEnabled = this.videoOn
			}

			console.log('---> TOGGLEVIDEO END <---', this.videoOn, new Date())
		},
		async toggleAudio() {
			console.log('---> TOGGLEAUDIO START <---', this.audioOn)

			try {
				if (this.twilioRoom && this.twilioRoom.localParticipant) {
					// Get the first audio track from Twilio local participant
					const audioPublications = Array.from(this.twilioRoom.localParticipant.audioTracks.values())
					const audioPublication = audioPublications.find((pub) => pub.track && pub.track.kind === 'audio')

					if (this.audioOn) {
						// DISABLING AUDIO
						if (audioPublication && audioPublication.track) {
							audioPublication.track.disable()
							console.log('LOCAL Audio track disabled:', {
								trackSid: audioPublication.trackSid,
								trackName: audioPublication.trackName,
								trackState: audioPublication.track.isEnabled ? 'enabled' : 'disabled'
							})
						} else {
							console.log('No audio track found to disable - participant may have entered with audio OFF')
						}
					} else {
						// ENABLING AUDIO
						if (audioPublication && audioPublication.track) {
							// Track exists, just enable it
							audioPublication.track.enable()
							console.log('LOCAL Audio track enabled (existing):', {
								trackSid: audioPublication.trackSid,
								trackName: audioPublication.trackName,
								trackState: audioPublication.track.isEnabled ? 'enabled' : 'disabled'
							})
						} else {
							// No audio track exists - this should not happen with unified audio management
							// Audio tracks should be created in Preview and passed to Meeting
							console.warn('No audio track found - audio should be managed by Preview component')
							console.warn('Cannot enable audio without existing track from Preview')
							return
						}
					}
				}

				// Update local state and UI only after successful track operations
				this.audioOn = !this.audioOn

				// Update local audio in videoList
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (localVideo) {
					localVideo.audioEnabled = this.audioOn
				}

				console.log('---> TOGGLEAUDIO END SUCCESS <---', this.audioOn)
			} catch (error) {
				console.error('Error in toggleAudio:', error)
				console.log('---> TOGGLEAUDIO END ERROR <---')
			}
		},

		setLocalAudioTrack(audioTrack) {
			// Set local audio track reference
			this.localAudioTrack = audioTrack
			console.log('Local audio track set:', {
				hasTrack: !!audioTrack,
				trackSid: audioTrack?.sid || 'none'
			})
		},

		setupLocalAudioAnalyzer() {
			console.log('---> SETUP LOCAL AUDIO ANALYZER START <---')
			try {
				if (!this.localStream) {
					console.log('No localStream available for audio analysis')
					return
				}

				const audioTracks = this.localStream.getAudioTracks()
				if (audioTracks.length === 0) {
					console.log('No audio tracks in localStream')
					return
				}

				// Create a new MediaStream with just the audio track for analysis
				const audioStream = new MediaStream([audioTracks[0]])

				const audioCTX = new AudioContext()
				const analyser = audioCTX.createAnalyser()
				const source = audioCTX.createMediaStreamSource(audioStream)
				source.connect(analyser)

				// Use localStream.id for consistency with existing code
				this.frameLoop(this.localStream.id, analyser)

				console.log('Local audio analyzer setup completed:', {
					streamId: this.localStream.id,
					audioTrackId: audioTracks[0].id,
					audioTrackLabel: audioTracks[0].label
				})
				console.log('---> SETUP LOCAL AUDIO ANALYZER SUCCESS <---')
			} catch (error) {
				console.error('Error setting up local audio analyzer:', error)
				console.log('---> SETUP LOCAL AUDIO ANALYZER FAILED <---')
			}
		},

		frameLoop(id, analyser) {
			window.requestAnimationFrame(() => this.frameLoop(id, analyser))
			const borderEl = document.getElementsByClassName('video-' + id)[0]
			const circleEl = document.getElementsByClassName('initials-audio-effect-' + id)[0]
			const circleElBig = document.getElementsByClassName('initials-audio-effect-big-' + id)[0]
			const e1 = document.getElementsByClassName('o1_' + id)[0]
			const e2 = document.getElementsByClassName('o2_' + id)[0]
			const e3 = document.getElementsByClassName('o3_' + id)[0]

			const e4 = document.getElementsByClassName('o4_' + id)[0]
			const e5 = document.getElementsByClassName('o5_' + id)[0]
			const e6 = document.getElementsByClassName('o6_' + id)[0]

			// Find the video container for inner border effect
			const videoContainer = document.getElementById(id)?.closest('.video-container')

			const fbc_array = new Uint8Array(analyser.frequencyBinCount)

			analyser.getByteFrequencyData(fbc_array)

			let o1 = fbc_array[20] / 300
			let o2 = fbc_array[50] / 200

			o1 = o1 < 0.5 ? 0.19 : o1 > 1 ? 1 : o1
			o2 = o2 < 0.4 ? 0.19 : o2 > 1 ? 1 : o2

			const scale2 = o2 * 5 > 2 ? 2 : o2 * 4.5
			const scale1 = o1 * 5 > 2 ? 2 : o1 * 5

			if (circleElBig) {
				circleElBig.style.transform = 'scale(' + scale2 + ')'
				circleElBig.style.opacity = scale2 > 1 ? 0 : scale2 / 2
			}
			if (circleEl) {
				circleEl.style.transform = 'scale(' + scale1 + ')'
				circleEl.style.opacity = scale1 * 5
			}

			// Use inner border instead of changing container border
			if (videoContainer) {
				const borderWidth = Math.max(o2 * 5.5, 0)
				const borderOpacity = Math.max(o2 * 2, 0)

				// Apply inner border using ::before pseudo-element
				videoContainer.style.setProperty('--speaking-border-width', `${borderWidth}px`)
				videoContainer.style.setProperty('--speaking-border-color', `hsla(210, 65%, 67%, ${borderOpacity})`)
			}

			// Remove the old border effect that caused layout shifts
			// if (borderEl) {
			// 	const px = o2 * 5.5
			// 	borderEl.style.border = px + 'px solid hsla(210, 65%, 67%,' + o2 * 2 + ')'
			// }

			if (e1) {
				e1.style.height = `${o1 * 100}%`
			}
			if (e3) {
				e3.style.height = `${o1 * 100}%`
			}
			if (e2) {
				e2.style.height = `${o2 * 100}%`
			}
			if (e4) {
				e4.style.height = `${o1 * 100}%`
			}
			if (e5) {
				e5.style.height = `${o1 * 100}%`
			}
			if (e6) {
				e6.style.height = `${o2 * 100}%`
			}

			// Update isSpeaking based on audio levels
			const participant = this.videoList.find((v) => v.id === id)
			if (participant) {
				// Consider speaking if audio level is above threshold
				const isSpeaking = o1 > 0.5 || o2 > 0.4
				participant.isSpeaking = isSpeaking
			}
		},

		dimensions() {
			const dish = document.getElementsByClassName('Dish')[0]
			if (dish) {
				const dimension = {
					width: dish.offsetWidth - this.margin * 2,
					height: dish.offsetHeight - this.margin * 2
				}
				// loop (i recommend you optimize this)
				let max = 0
				for (let i = 0; i < 5000; i++) {
					const area = this.area(i, dimension)
					if (area === false) {
						max = i - 1
						break
					}
				}

				// remove margins
				max = max - this.margin * 2

				this.dishWidth = max
				this.dishHeight = dimension.height
			}
		},
		area(increment, dimension) {
			let w = 0
			let h = increment * this.ratio + this.margin * 2

			for (let i = 0; i < this.videoList.length; i++) {
				if (w + increment > dimension.width) {
					w = 0
					h = h + increment * this.ratio + this.margin * 2
				}
				w = w + increment + this.margin * 2
			}

			if (h > dimension.height || increment > dimension.width) return false
			return increment
		},

		expand(video) {
			console.log('🔥 [PIN DEBUG] Expanding video:', video.id, 'isLocal:', video.isLocal)
			console.log('🔥 [PIN DEBUG] Video has active processors:', this.localVideoTrack && this.localVideoTrack.processor)
			console.log('🔥 [PIN DEBUG] Current blur level:', this.blur)
			console.log('🔥 [PIN DEBUG] Current virtual background:', this.currentVirtualBackground)

			const someVideoAlreadyPinned = this.videoList.find((f) => f.pinned)
			if (someVideoAlreadyPinned) this.unexpand(someVideoAlreadyPinned)

			// PRE-DETACH: For local video, detach from normal element BEFORE changing pinned state
			if (video.isLocal && this.localVideoTrack) {
				const normalElement = document.getElementById(video.id)
				if (normalElement) {
					console.log('🔗 [PRE-DETACH] Detaching track from normal element before pin')
					try {
						this.localVideoTrack.detach(normalElement)
						console.log('🔗 [PRE-DETACH] Successfully detached from normal element')
					} catch (error) {
						console.error('🔗 [PRE-DETACH] Error detaching from normal element:', error)
					}
				} else {
					console.log('🔗 [PRE-DETACH] Normal element not found for pre-detach')
				}
			}

			this.videoList.forEach((v) => {
				if (v.id === video.id) {
					Vue.set(v, 'pinned', true)
					console.log('🔥 [PIN DEBUG] Video pinned, stream:', v.stream)

					// For local video, attach to pinned element after DOM update
					if (v.isLocal && !v.isScreenShare) {
						console.log('🔥 [PIN DEBUG] Waiting for pinned element to be ready (normal video)')
						setTimeout(() => {
							this.attachToPinnedElementOnly(v)
						}, 50) // Short delay for DOM readiness
					} else if (v.isLocal && v.isScreenShare) {
						console.log('🔥 [PIN DEBUG] Screen share pinned - using stream directly')
						// For screen sharing, the stream is already correctly set in the video object
						// No need for Twilio track attachment - Vue will handle it via :srcObject
					}

					setTimeout(() => {
						this.dimensions()
					}, 200)
				}
			})
		},

		unexpand(video) {
			console.log('🔥 [UNPIN DEBUG] Unexpanding video:', video.id, 'isLocal:', video.isLocal)
			console.log('🔥 [UNPIN DEBUG] Video has active processors:', this.localVideoTrack && this.localVideoTrack.processor)

			// PRE-DETACH: For local video, detach from pinned element BEFORE changing pinned state
			if (video.isLocal && !video.isScreenShare && this.localVideoTrack) {
				const pinnedElement = document.getElementById(`pinned_${video.id}`)
				if (pinnedElement) {
					console.log('🔗 [PRE-DETACH] Detaching track from pinned element before unpin')
					try {
						this.localVideoTrack.detach(pinnedElement)
						console.log('🔗 [PRE-DETACH] Successfully detached from pinned element')
					} catch (error) {
						console.error('🔗 [PRE-DETACH] Error detaching from pinned element:', error)
					}
				} else {
					console.log('🔗 [PRE-DETACH] Pinned element not found for pre-detach')
				}
			}

			this.videoList.forEach((v) => {
				if (v.id === video.id) {
					Vue.set(v, 'pinned', false)
					console.log('🔥 [UNPIN DEBUG] Video unpinned, stream:', v.stream)

					// For local video, attach to normal element after DOM update
					if (v.isLocal && !v.isScreenShare) {
						console.log('🔥 [UNPIN DEBUG] Waiting for normal element to be ready (normal video)')
						setTimeout(() => {
							this.attachToNormalElementOnly(v)
						}, 50) // Short delay for DOM readiness
					} else if (v.isLocal && v.isScreenShare) {
						console.log('🔥 [UNPIN DEBUG] Screen share unpinned - stream handled by Vue')
						// For screen sharing, no special attachment needed
					}

					// With v-if, the pinned video element will be removed from DOM
					// Just update dimensions after a slight delay
					setTimeout(() => {
						this.dimensions()
					}, 200)
				}
			})
		},

		handleUserPin(user) {
			if (user.pinned) {
				this.unexpand(user)
			} else {
				this.expand(user)
			}
		},
		handleSendMessage(textMessage) {
			this.textMessage = textMessage
			this.addMessage()
		},

		handleRemoteParticipant(participant) {
			console.log('🔄 [DATATRACK DEBUG] Handling remote participant:', participant.identity)
			console.log('🔄 [DATATRACK DEBUG] Participant SID:', participant.sid)
			console.log('🔄 [DATATRACK DEBUG] Total tracks for participant:', participant.tracks.size)

			// Store participant tracks in component data
			if (!this.participantTracks) {
				this.participantTracks = {}
			}

			// Initialize tracks container for this participant
			this.participantTracks[participant.sid] = {
				audio: null,
				video: null
			}

			// Handle already subscribed tracks
			console.log('🔍 [DATATRACK DEBUG] Checking existing tracks for:', participant.identity)
			participant.tracks.forEach((publication) => {
				console.log('🔍 [DATATRACK DEBUG] Found track:', {
					kind: publication.track?.kind,
					isSubscribed: publication.isSubscribed,
					trackSid: publication.trackSid,
					trackName: publication.trackName
				})

				if (publication.isSubscribed && publication.track) {
					// Handle data tracks for chat
					if (publication.track.kind === 'data') {
						console.log('✅ [DATATRACK DEBUG] Existing data track found from:', participant.identity, 'trackName:', publication.trackName)

						this.remoteDataTracks.set(participant.sid, publication.track)

						// Listen for messages on this data track
						publication.track.on('message', (data) => {
							try {
								const parsedData = JSON.parse(data)
								if (parsedData.type === 'chat') {
									console.log('Received chat message from', participant.identity, ':', parsedData.message)
									console.log('Message details - Private:', parsedData.message.private, 'Receiver:', parsedData.message.receiver, 'My name:', this.partecipant.partecipantName)

									// 🔍 DEBUG: Detailed participant info
									console.log('📨 RECEIVE: Handler 2 - Processing message')
									console.log('👤 RECEIVE: From participant.identity:', participant.identity)
									console.log('👤 RECEIVE: My partecipant.partecipantName:', this.partecipant.partecipantName)
									console.log('📩 RECEIVE: Message private:', parsedData.message.private)
									console.log('📩 RECEIVE: Message receiver:', parsedData.message.receiver)
									console.log('📩 RECEIVE: Message sender (id):', parsedData.message.id)

									// Unified intelligent filtering for public and private messages
									let shouldShowMessage = false

									if (participant.identity === this.partecipant.originalIdentity) {
										// This is my own message (loopback)
										console.log('🔄 RECEIVE: This is MY OWN message (loopback)')
										if (parsedData.message.private) {
											// It's my private message - show it so I can see what I sent
											console.log('✅ RECEIVE: Showing my own private message (sender confirmation)')
											shouldShowMessage = true
										} else {
											// It's my public message - ignore it (already shown locally)
											console.log('❌ RECEIVE: Ignoring my own public message (loopback prevention)')
											shouldShowMessage = false
										}
									} else {
										// Message from other participants
										console.log('👥 RECEIVE: Message from OTHER participant')
										if (parsedData.message.private) {
											console.log('🔒 RECEIVE: This is a PRIVATE message')
											// Private message from others - check if it's for me
											const isForMe = parsedData.message.receiver === this.partecipant.partecipantName
											console.log('🎯 RECEIVE: Is for me?', isForMe)
											console.log('🎯 RECEIVE: Comparing receiver "' + parsedData.message.receiver + '" === my name "' + this.partecipant.partecipantName + '"')

											if (isForMe) {
												// It's for me - show it
												console.log('✅ RECEIVE: Private message FOR ME from', participant.identity)
												shouldShowMessage = true
											} else {
												// Not for me - ignore it (privacy)
												console.log('❌ RECEIVE: Private message NOT FOR ME (privacy filter)')
												shouldShowMessage = false
											}
										} else {
											// Public message from others - always show it
											console.log('🌍 RECEIVE: Public message from', participant.identity)
											shouldShowMessage = true
										}
									}

									console.log('🎯 RECEIVE: Final decision - shouldShowMessage:', shouldShowMessage)

									// Only add the message if it should be shown
									if (shouldShowMessage) {
										// Add the message to our list
										this.messages.push({
											message: parsedData.message,
											private: parsedData.message.private
										})

										// Scroll to bottom if chat is visible
										if (this.chatVisible) {
											this.$nextTick(() => {
												const element = document.getElementById('chat-messages')
												if (element) {
													element.scrollTop = element.scrollHeight
												}
											})
										}

										// Increment unread counter if chat is hidden
										if (!this.chatVisible) {
											this.countMessage++
										}
									}
								} else if (parsedData.type === 'recording_status') {
									// Handle recording status updates
									console.log('Received recording status update from', participant.identity, ':', parsedData)
									this.handleRecordingStatusUpdate(parsedData, participant.identity)
								}
							} catch (error) {
								console.error('Error parsing data track message:', error)
							}
						})
					} else {
						// Handle audio/video tracks
						this.addRemoteTrack(publication.track, participant)
					}
				}

				// Listen for track enabled/disabled events (mute/unmute)
				if (publication.kind === 'audio') {
					publication.on('trackEnabled', () => {
						console.log('REMOTE Audio track enabled for:', participant.identity, {
							trackSid: publication.trackSid,
							isLocal: participant === this.twilioRoom.localParticipant,
							trackName: publication.trackName
						})
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.audioEnabled = true
							console.log('Updated participant video audioEnabled to true for:', participant.identity)
						}
					})

					publication.on('trackDisabled', () => {
						console.log('REMOTE Audio track disabled for:', participant.identity, {
							trackSid: publication.trackSid,
							isLocal: participant === this.twilioRoom.localParticipant,
							trackName: publication.trackName
						})
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.audioEnabled = false
							console.log('Updated participant video audioEnabled to false for:', participant.identity)
						}
					})
				}

				// Listen for track enabled/disabled events for video
				if (publication.kind === 'video') {
					publication.on('trackEnabled', () => {
						console.log('Video track enabled for:', participant.identity)
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.videoEnabled = true
						}
					})

					publication.on('trackDisabled', () => {
						console.log('Video track disabled for:', participant.identity)
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.videoEnabled = false
						}
					})
				}
			})

			// Listen for new track subscriptions
			participant.on('trackSubscribed', (track) => {
				console.log('📥 [DATATRACK DEBUG] Track subscribed:', track.kind, 'from', participant.identity)
				console.log('📥 [DATATRACK DEBUG] Track details:', {
					kind: track.kind,
					id: track.id,
					name: track.name,
					enabled: track.isEnabled
				})

				// Handle DataTrack for chat messages
				if (track.kind === 'data') {
					console.log('✅ [DATATRACK DEBUG] NEW Data track subscribed from:', participant.identity, 'trackName:', track.name)

					this.remoteDataTracks.set(participant.sid, track)

					// Listen for messages on this data track
					track.on('message', (data) => {
						try {
							const parsedData = JSON.parse(data)
							if (parsedData.type === 'chat') {
								console.log('Received chat message from', participant.identity, ':', parsedData.message)
								console.log('Message details - Private:', parsedData.message.private, 'Receiver:', parsedData.message.receiver, 'My name:', this.partecipant.partecipantName)

								// 🔍 DEBUG: Detailed participant info
								console.log('📨 RECEIVE: Handler 1 - Processing message')
								console.log('👤 RECEIVE: From participant.identity:', participant.identity)
								console.log('👤 RECEIVE: My partecipant.partecipantName:', this.partecipant.partecipantName)
								console.log('📩 RECEIVE: Message private:', parsedData.message.private)
								console.log('📩 RECEIVE: Message receiver:', parsedData.message.receiver)
								console.log('📩 RECEIVE: Message sender (id):', parsedData.message.id)

								// Unified intelligent filtering for public and private messages
								let shouldShowMessage = false

								if (participant.identity === this.partecipant.originalIdentity) {
									// This is my own message (loopback)
									console.log('🔄 RECEIVE: This is MY OWN message (loopback)')
									if (parsedData.message.private) {
										// It's my private message - show it so I can see what I sent
										console.log('✅ RECEIVE: Showing my own private message (sender confirmation)')
										shouldShowMessage = true
									} else {
										// It's my public message - ignore it (already shown locally)
										console.log('❌ RECEIVE: Ignoring my own public message (loopback prevention)')
										shouldShowMessage = false
									}
								} else {
									// Message from other participants
									console.log('👥 RECEIVE: Message from OTHER participant')
									if (parsedData.message.private) {
										console.log('🔒 RECEIVE: This is a PRIVATE message')
										// Private message from others - check if it's for me
										const isForMe = parsedData.message.receiver === this.partecipant.partecipantName
										console.log('🎯 RECEIVE: Is for me?', isForMe)
										console.log('🎯 RECEIVE: Comparing receiver "' + parsedData.message.receiver + '" === my name "' + this.partecipant.partecipantName + '"')

										if (isForMe) {
											// It's for me - show it
											console.log('✅ RECEIVE: Private message FOR ME from', participant.identity)
											shouldShowMessage = true
										} else {
											// Not for me - ignore it (privacy)
											console.log('❌ RECEIVE: Private message NOT FOR ME (privacy filter)')
											shouldShowMessage = false
										}
									} else {
										// Public message from others - always show it
										console.log('🌍 RECEIVE: Public message from', participant.identity)
										shouldShowMessage = true
									}
								}

								console.log('🎯 RECEIVE: Final decision - shouldShowMessage:', shouldShowMessage)

								// Only add the message if it should be shown
								if (shouldShowMessage) {
									// Add the message to our list
									this.messages.push({
										message: parsedData.message,
										private: parsedData.message.private
									})

									// Scroll to bottom if chat is visible
									if (this.chatVisible) {
										this.$nextTick(() => {
											const element = document.getElementById('chat-messages')
											if (element) {
												element.scrollTop = element.scrollHeight
											}
										})
									}

									// Increment unread counter if chat is hidden
									if (!this.chatVisible) {
										this.countMessage++
									}
								}
							} else if (parsedData.type === 'recording_status') {
								// Handle recording status updates
								console.log('Received recording status update from', participant.identity, ':', parsedData)
								this.handleRecordingStatusUpdate(parsedData, participant.identity)
							}
						} catch (error) {
							console.error('Error parsing data track message:', error)
						}
					})
				} else {
					// Handle audio/video tracks as before
					this.addRemoteTrack(track, participant)
				}
			})

			// Listen for track unsubscriptions
			participant.on('trackUnsubscribed', (track) => {
				console.log('Track unsubscribed:', track.kind, 'from', participant.identity)

				if (track.kind === 'data') {
					// Remove data track from our map
					this.remoteDataTracks.delete(participant.sid)
				} else {
					this.removeRemoteTrack(track, participant)
				}
			})

			// Listen for new tracks being published
			participant.on('trackPublished', (publication) => {
				console.log('📤 [DATATRACK DEBUG] Track published:', publication.kind, 'from', participant.identity)
				console.log('📤 [DATATRACK DEBUG] Publication details:', {
					kind: publication.kind,
					trackSid: publication.trackSid,
					trackName: publication.trackName,
					isSubscribed: publication.isSubscribed
				})

				// Handle DataTrack publications specifically
				if (publication.kind === 'data') {
					console.log('🔔 [DATATRACK DEBUG] DataTrack published from:', participant.identity, 'trackName:', publication.trackName)

					// Wait for automatic subscription and then set up event listener
					publication.on('subscribed', (track) => {
						console.log('✅ [DATATRACK DEBUG] DataTrack auto-subscribed from:', participant.identity)

						if (!this.remoteDataTracks.has(participant.sid)) {
							this.remoteDataTracks.set(participant.sid, track)
							console.log('🔗 [DATATRACK DEBUG] Added DataTrack to map for:', participant.identity)
						}

						// Set up message listener for this new DataTrack
						track.on('message', (data) => {
							try {
								const parsedData = JSON.parse(data)
								console.log('📨 [DATATRACK DEBUG] Message received via trackPublished from:', participant.identity, 'type:', parsedData.type)

								if (parsedData.type === 'recording_status') {
									console.log('🎬 [DATATRACK DEBUG] Recording status message via trackPublished from:', participant.identity, ':', parsedData)
									this.handleRecordingStatusUpdate(parsedData, participant.identity)
								} else if (parsedData.type === 'chat') {
									// Handle chat messages - existing logic would go here
									console.log('💬 [DATATRACK DEBUG] Chat message via trackPublished')
								}
							} catch (error) {
								console.error('❌ [DATATRACK DEBUG] Error parsing message via trackPublished:', error)
							}
						})
					})
				}

				// Add listeners for track enabled/disabled on newly published tracks
				if (publication.kind === 'audio') {
					publication.on('trackEnabled', () => {
						console.log('REMOTE Audio track enabled for:', participant.identity, {
							trackSid: publication.trackSid,
							isLocal: participant === this.twilioRoom.localParticipant,
							trackName: publication.trackName
						})
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.audioEnabled = true
							console.log('Updated participant video audioEnabled to true for:', participant.identity)
						}
					})

					publication.on('trackDisabled', () => {
						console.log('REMOTE Audio track disabled for:', participant.identity, {
							trackSid: publication.trackSid,
							isLocal: participant === this.twilioRoom.localParticipant,
							trackName: publication.trackName
						})
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.audioEnabled = false
							console.log('Updated participant video audioEnabled to false for:', participant.identity)
						}
					})
				}

				if (publication.kind === 'video') {
					publication.on('trackEnabled', () => {
						console.log('Video track enabled for:', participant.identity)
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.videoEnabled = true
						}
					})

					publication.on('trackDisabled', () => {
						console.log('Video track disabled for:', participant.identity)
						const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
						if (participantVideo) {
							participantVideo.videoEnabled = false
						}
					})
				}
			})

			// Invia gli stati di registrazione correnti al nuovo partecipante
			// Aspetta un po' per assicurarsi che il DataTrack sia pronto
			setTimeout(() => {
				this.sendRecordingStatesForNewParticipant()
			}, 1000) // Aspetta 1 secondo per essere sicuri che il DataTrack sia stabilito

			// Creare immediatamente l'entry del partecipante nella videoList
			// anche se non ha ancora audio/video track (potrebbero essere disattivati)
			this.ensureParticipantInVideoList(participant)

			// If recording is active, add participant's email to tracking
			if (this.recordOn && participant.identity) {
				const email = getEmailFromIdentity(participant.identity)
				if (email) {
					this.recordingParticipantEmails.add(email)
					console.log('Added new participant email to active recording:', email)
				}
			}
		},

		ensureParticipantInVideoList(participant) {
			// Controlla se il partecipante è già nella videoList (escludendo screen shares)
			const existingVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity && !v.isScreenShare)

			if (!existingVideo) {
				console.log('🆕 [PARTICIPANT DEBUG] Creating initial entry for participant:', participant.identity)

				// Controlla se ci sono effettivamente track audio/video pubblicati
				let hasAudioTrack = false
				let hasVideoTrack = false

				participant.tracks.forEach((publication) => {
					if (publication.kind === 'audio') hasAudioTrack = true
					if (publication.kind === 'video') hasVideoTrack = true
				})

				console.log('🔍 [PARTICIPANT DEBUG] Track analysis:', {
					hasAudioTrack,
					hasVideoTrack,
					totalTracks: participant.tracks.size
				})
				// Crea entry iniziale con stati basati sulla presenza di track
				// Se non ci sono track, assume che siano disattivati
				const initialVideo = {
					id: participant.sid,
					twilioIdentity: participant.identity,
					name: getNameFromIdentity(participant.identity) || 'Unknown User',
					muted: false,
					stream: null, // Verrà aggiornato quando arrivano i track
					isLocal: false,
					videoEnabled: hasVideoTrack, // Se non c'è track video, assume spento
					audioEnabled: hasAudioTrack, // Se non c'è track audio, assume muted
					isScreenShare: false,
					isRecording: false,
					videoEffects: { blur: 0, src: '' },
					avatarColor: this.getRandomColor(participant.identity.split('|')[0]),
					isSpeaking: false,
					pinned: false
				}

				this.videoList.push(initialVideo)
				console.log('✅ [PARTICIPANT DEBUG] Added initial participant entry:', initialVideo)
			} else {
				console.log('👤 [PARTICIPANT DEBUG] Participant already exists in videoList:', participant.identity)
			}
		},

		handleLocalParticipant(localParticipant) {
			console.log('Handling local participant:', localParticipant.identity)
			// Local participant is already handled through the existing stream
			// We just need to update the name if needed
			const localVideo = this.videoList.find((v) => v.isLocal)
			if (localVideo) {
				localVideo.twilioIdentity = localParticipant.identity
			}
		},

		addRemoteTrack(track, participant) {
			// Detect if this is a screen share track
			const isScreenShare =
				track.kind === 'video' &&
				(track.name === 'screen-share' || track.name === 'screen' || track.mediaStreamTrack?.label?.includes('screen') || track.mediaStreamTrack?.getSettings()?.displaySurface)

			console.log('Adding remote track:', track.kind, 'isScreenShare:', isScreenShare, 'track name:', track.name, 'from:', participant.identity)

			// Get or create participant tracks container
			if (!this.participantTracks[participant.sid]) {
				this.participantTracks[participant.sid] = {
					audio: null,
					video: null,
					screenShare: null
				}
			}

			const participantTracks = this.participantTracks[participant.sid]

			// Store the track
			if (track.kind === 'audio') {
				participantTracks.audio = track
			} else if (track.kind === 'video') {
				if (isScreenShare) {
					participantTracks.screenShare = track
				} else {
					participantTracks.video = track
				}
			}

			// Handle screen share separately from normal video
			if (isScreenShare && participantTracks.screenShare) {
				// Create stream for screen share only
				const screenStream = new MediaStream([participantTracks.screenShare.mediaStreamTrack])

				// Remove any existing screen share from this participant
				this.videoList = this.videoList.filter((v) => !(v.twilioIdentity === participant.identity && v.isScreenShare))
				// Add screen share as separate video
				const screenShareVideo = {
					id: participant.sid + '_screen',
					twilioIdentity: participant.identity,
					name: (getNameFromIdentity(participant.identity) || 'Unknown User') + ' (Screen)',
					muted: true, // Screen shares don't have audio
					stream: screenStream,
					isLocal: false,
					videoEnabled: true,
					audioEnabled: false,
					isScreenShare: true,
					isRecording: false,
					videoEffects: { blur: 0, src: '' },
					avatarColor: this.getRandomColor(participant.identity.split('|')[0]),
					isSpeaking: false,
					pinned: false
				}

				this.videoList.push(screenShareVideo)
				console.log('Added remote screen share to videoList:', screenShareVideo)

				// Auto-pin the screen share
				this.$nextTick(() => {
					this.expand(screenShareVideo)
				})

				return
			}

			// Handle normal video/audio tracks
			const tracks = []
			if (participantTracks.audio) tracks.push(participantTracks.audio.mediaStreamTrack)
			if (participantTracks.video) tracks.push(participantTracks.video.mediaStreamTrack)

			if (tracks.length > 0) {
				const stream = new MediaStream(tracks)

				// Check if participant already exists in videoList (excluding screen shares)
				const existingVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity && !v.isScreenShare)

				if (existingVideo) {
					// Update existing participant
					existingVideo.stream = stream
					existingVideo.videoEnabled = participantTracks.video !== null && this.isTrackEnabled(participantTracks.video)
					existingVideo.audioEnabled = participantTracks.audio !== null && this.isTrackEnabled(participantTracks.audio)

					// iOS-specific: Force video element update for remote participants
					if (this.isIOSDevice && track.kind === 'video') {
						console.log('iOS: Force updating video element for remote participant:', participant.identity)
						this.$nextTick(() => {
							// Force re-render of video element by temporarily disabling/enabling
							const wasEnabled = existingVideo.videoEnabled
							existingVideo.videoEnabled = false
							this.$nextTick(() => {
								existingVideo.videoEnabled = wasEnabled
							})
						})
					}
				} else {
					// Add new participant to videoList
					const video = {
						id: participant.sid,
						twilioIdentity: participant.identity,
						name: getNameFromIdentity(participant.identity) || 'Unknown User',
						muted: false,
						stream: stream,
						isLocal: false,
						videoEnabled: participantTracks.video !== null && this.isTrackEnabled(participantTracks.video),
						audioEnabled: participantTracks.audio !== null && this.isTrackEnabled(participantTracks.audio),
						isScreenShare: false,
						isRecording: false,
						videoEffects: { blur: 0, src: '' },
						avatarColor: this.getRandomColor(participant.identity.split('|')[0]),
						isSpeaking: false
					}

					this.videoList.push(video)
					console.log('Added remote participant to videoList:', video)

					// Trigger dimensions recalculation
					this.$nextTick(() => {
						this.dimensions()
					})
				}

				// Setup audio analysis for remote participants if audio track is available
				if (participantTracks.audio) {
					try {
						console.log('Setting up audio analysis for remote participant:', participant.identity)
						const audioCTX = new AudioContext()
						const analyser = audioCTX.createAnalyser()
						const source = audioCTX.createMediaStreamSource(stream)
						source.connect(analyser)
						this.frameLoop(participant.sid, analyser)
					} catch (error) {
						console.log('Error setting up audio analysis for remote participant:', error)
					}
				}
			}
		},

		removeRemoteTrack(track, participant) {
			// Detect if this is a screen share track
			const isScreenShare =
				track.kind === 'video' &&
				(track.name === 'screen-share' || track.name === 'screen' || track.mediaStreamTrack?.label?.includes('screen') || track.mediaStreamTrack?.getSettings()?.displaySurface)

			console.log('Removing remote track:', track.kind, 'isScreenShare:', isScreenShare, 'from:', participant.identity)

			// Handle screen share removal
			if (isScreenShare) {
				// Remove screen share from videoList
				this.videoList = this.videoList.filter((v) => !(v.twilioIdentity === participant.identity && v.isScreenShare))
				console.log('Removed screen share from videoList for:', participant.identity)

				// Clean up participant tracks
				if (this.participantTracks[participant.sid]) {
					this.participantTracks[participant.sid].screenShare = null
				}

				// If this was the pinned video, unpin it
				if (this.pinVideo && this.pinVideo.twilioIdentity === participant.identity && this.pinVideo.isScreenShare) {
					this.pinVideo = null
					this.pin = false
				}

				return
			}

			// Handle normal video/audio track removal
			const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity && !v.isScreenShare)

			if (participantVideo) {
				// Update track availability
				if (track.kind === 'audio') {
					participantVideo.audioEnabled = false
				} else if (track.kind === 'video') {
					participantVideo.videoEnabled = false
				}

				// Update participant tracks
				if (this.participantTracks[participant.sid]) {
					if (track.kind === 'audio') {
						this.participantTracks[participant.sid].audio = null
					} else if (track.kind === 'video') {
						this.participantTracks[participant.sid].video = null
					}
				}

				console.log('Updated participant track availability:', participantVideo)
			}
		},

		removeRemoteParticipant(participant) {
			console.log('Removing participant:', participant.identity)
			console.log(
				'Current videoList before removal:',
				this.videoList.map((v) => ({ name: v.name, twilioIdentity: v.twilioIdentity, isLocal: v.isLocal }))
			)

			// Find participant in videoList to get the name before removing
			const participantVideo = this.videoList.find((v) => v.twilioIdentity === participant.identity)
			const participantName = participantVideo ? participantVideo.name : participant.identity

			console.log('Found participantVideo:', participantVideo)
			console.log('Participant name:', participantName)
			console.log('Is local participant?', participantVideo?.isLocal)

			// Remove participant from videoList
			this.videoList = this.videoList.filter((v) => v.twilioIdentity !== participant.identity)

			// Show participant left notification
			if (participantName && !participantVideo?.isLocal) {
				console.log('Showing participant left notification for:', participantName)

				// Clear any existing timeout to avoid conflicts
				if (this.alertTimeout) {
					clearTimeout(this.alertTimeout)
				}

				this.leftParticipantName = participantName
				this.toastType = 'participant_left'
				this.showToast = true
				console.log('Toast state set - showToast:', this.showToast, 'toastType:', this.toastType)

				// Force Vue reactivity update
				this.$forceUpdate()

				// Additional debugging
				setTimeout(() => {
					console.log('After timeout - showToast:', this.showToast, 'toastType:', this.toastType)
				}, 100)

				this.alertTimeout = setTimeout(() => {
					this.showToast = false
					this.alertTimeout = null
					console.log('Toast hidden after timeout')
				}, 5000)
			} else {
				console.log('Not showing notification - participantName:', participantName, 'isLocal:', participantVideo?.isLocal)
			}

			// Clean up participant tracks
			if (this.participantTracks && this.participantTracks[participant.sid]) {
				delete this.participantTracks[participant.sid]
			}
			// Clean up data track for this participant
			if (this.remoteDataTracks.has(participant.sid)) {
				this.remoteDataTracks.delete(participant.sid)
				console.log('Removed data track for participant:', participant.identity)
			}
			// Recalculate dimensions
			this.$nextTick(() => {
				this.dimensions()
			})
		},
		getRandomColor(name) {
			if (!name) return '#CCCCCC' // Colore di default se il nome non è valido
			const colors = [
				'#FFC312', // Giallo Oro Vivace
				'#FF8C42', // Arancio Mandarino
				'#E74C3C', // Rosso Rubino
				'#FF6B9D', // Rosa Fucsia Vivido
				'#A55EEA', // Viola Ametista
				'#9B59B6', // Viola Orchidea
				'#4A90E2', // Blu Reale Luminoso
				'#5DADE2', // Azzurro Cielo Elettrico
				'#26C281', // Verde Smeraldo
				'#A3CB38' // Verde Lime Brillante
			]

			// Funzione di hash FNV-1a con gestione corretta degli overflow
			let hash = 2166136261
			for (let i = 0; i < name.length; i++) {
				hash ^= name.charCodeAt(i)
				hash = Math.imul(hash, 16777619) // Moltiplicazione a 32-bit
			}

			// Restituisce il colore corrispondente all'indice calcolato
			return colors[Math.abs(hash) % colors.length]
		},

		handlePageUnload() {
			const unloadStartTime = performance.now()
			console.log('[PAGE_UNLOAD] Page unloading at:', unloadStartTime, '- disconnecting from Twilio room')
			// Synchronous disconnect for page unload
			this.disconnectFromRoom()
			console.log('[PAGE_UNLOAD] Disconnect call completed')
		},

		async disconnectFromRoom() {
			if (this.twilioRoom) {
				const disconnectStartTime = performance.now()
				console.log('[DISCONNECT] Starting Twilio room disconnection at:', disconnectStartTime)
				try {
					// Simply disconnect from room - Twilio will handle all cleanup automatically
					// The 'disconnected' event will fire and handle all cleanup
					console.log('[DISCONNECT] Calling twilioRoom.disconnect() - Twilio will handle all cleanup')
					this.twilioRoom.disconnect()

					const disconnectEndTime = performance.now()
					console.log('[DISCONNECT] Disconnect call completed in:', disconnectEndTime - disconnectStartTime, 'ms')
				} catch (error) {
					console.error('[DISCONNECT]  Error disconnecting from Twilio room:', error)
				}
			}
		},

		// richiamato quando clicco su [Partecipa al meet]
		async join(partecipant) {
			console.log('---> JOIN START <---')
			console.log('Platform info:', this.platformInfo)
			console.log('Participant data:', {
				hasVideoTrack: !!partecipant.videoTrack,
				hasAudioTrack: !!partecipant.audioTrack,
				enableVideo: partecipant.enableVideo,
				enableAudio: partecipant.enableAudio,
				currentBlurLevel: partecipant.currentBlurLevel,
				currentBackground: partecipant.currentBackground?.image || null,
				hasCurrentProcessor: partecipant.hasCurrentProcessor
			})

			this.meetName = partecipant.meetName

			// Parse identity to extract name and email
			const identityData = parseIdentity(partecipant.partecipantName)
			console.log('Parsed identity:', identityData)

			// Store participant data with parsed identity
			this.partecipant = {
				...partecipant,
				partecipantName: identityData.name, // Store just the name for UI display
				partecipantEmail: identityData.email, // Store email separately
				originalIdentity: partecipant.partecipantName // Keep original for Twilio
			}

			// Connect to Twilio room with LocalTracks from Preview
			if (partecipant.twilioToken) {
				try {
					const { connect } = await import('twilio-video')
					const twilioTracks = []

					// Use LocalTracks directly from Preview
					if (partecipant.videoTrack && partecipant.enableVideo) {
						console.log('Using LocalVideoTrack from Preview (may have processors applied)')
						twilioTracks.push(partecipant.videoTrack)
					}

					// Always include audio track if it exists, regardless of enabled state
					// The track itself maintains its enabled/disabled state
					if (partecipant.audioTrack) {
						console.log('Using LocalAudioTrack from Preview (with Krisp if supported)')
						console.log('Audio track enabled state:', partecipant.audioTrack.isEnabled)
						twilioTracks.push(partecipant.audioTrack)
						this.setLocalAudioTrack(partecipant.audioTrack)
					} else {
						// No audio track from Preview - this shouldn't happen with unified management
						console.warn('No audio track provided by Preview - unified audio management requires Preview to always create audio tracks')
					}

					console.log('Connecting to Twilio with proper Twilio tracks:', twilioTracks)

					const room = await connect(partecipant.twilioToken, {
						tracks: twilioTracks,
						name: this.roomId
					})

					console.log('Connected to Twilio room:', room)
					this.twilioRoom = room

					// Update debug reference
					console.log('🔧 [DEBUG] Twilio Room now available at: window.vueWebrtcInstance.twilioRoom')
					console.log('🔧 [DEBUG] Room participants:', room.participants.size)
					console.log('🔧 [DEBUG] Room state:', room.state)

					// Create and publish LocalDataTrack immediately for chat functionality
					console.log('Creating persistent LocalDataTrack for chat')
					const { LocalDataTrack } = await import('twilio-video')
					this.localDataTrack = new LocalDataTrack({ name: 'chat' })

					console.log('Publishing LocalDataTrack to room')
					await room.localParticipant.publishTrack(this.localDataTrack)
					console.log('LocalDataTrack published and ready for messaging')

					// Handle existing participants
					room.participants.forEach((participant) => {
						console.log('Existing participant:', participant.identity)
						this.handleRemoteParticipant(participant)
					})

					// Handle new participants joining
					room.on('participantConnected', (participant) => {
						console.log('Participant connected:', participant.identity)
						this.handleRemoteParticipant(participant)
					})

					// Handle participants leaving
					room.on('participantDisconnected', (participant) => {
						const disconnectEventTime = performance.now()
						console.log('[PARTICIPANT_DISCONNECT] Participant disconnected:', participant.identity, 'at time:', disconnectEventTime)
						console.log('[PARTICIPANT_DISCONNECT] Removing participant immediately from UI')
						this.removeRemoteParticipant(participant)
						console.log('[PARTICIPANT_DISCONNECT] Participant removal completed')
					})

					// Handle room disconnection (automatic cleanup)
					room.once('disconnected', (_, error) => {
						console.log('[ROOM_DISCONNECT] Room disconnected, performing automatic cleanup')
						if (error) {
							console.log('[ROOM_DISCONNECT] Disconnection due to error:', error)
						}
						// Clean up DataTrack reference (Twilio handles the actual cleanup)
						this.localDataTrack = null
						this.remoteDataTracks.clear()
						this.twilioRoom = null
						console.log('[ROOM_DISCONNECT] Automatic cleanup completed')
					})

					// Handle local participant (myself)
					this.handleLocalParticipant(room.localParticipant)
				} catch (error) {
					console.error('Error connecting to Twilio:', error)
				}
			}

			// Set local video/audio states
			this.videoOn = partecipant.enableVideo
			this.audioOn = partecipant.enableAudio

			// Save reference to LocalVideoTrack for direct attachment (preserves effects)
			this.localVideoTrack = partecipant.videoTrack
			this.localAudioTrack = partecipant.audioTrack

			// Sync filter state from Preview to Meeting component
			this.syncFilterStateFromPreview(partecipant)

			// Create MediaStream from LocalTracks for compatibility with existing code
			const mediaStreamTracks = []
			if (partecipant.videoTrack && partecipant.enableVideo) {
				console.log('Adding video track to MediaStream:', partecipant.videoTrack.mediaStreamTrack)
				mediaStreamTracks.push(partecipant.videoTrack.mediaStreamTrack)
			}
			// Always include audio track if it exists, regardless of enabled state
			// The track itself maintains its enabled/disabled state
			if (partecipant.audioTrack) {
				console.log('Adding audio track to MediaStream:', partecipant.audioTrack.mediaStreamTrack)
				console.log('Audio track enabled state:', partecipant.audioTrack.isEnabled)
				mediaStreamTracks.push(partecipant.audioTrack.mediaStreamTrack)
			}

			this.localStream = new MediaStream(mediaStreamTracks)
			console.log(
				'Created MediaStream from LocalTracks for compatibility:',
				this.localStream.getTracks().map((t) => t.kind)
			)
			console.log(
				'MediaStream tracks enabled status:',
				this.localStream.getTracks().map((t) => ({ kind: t.kind, enabled: t.enabled, readyState: t.readyState }))
			)
			console.log('Saved LocalVideoTrack reference for direct attachment (preserves effects)')

			// Save original stream for preview purposes (create a clone to preserve original tracks)
			// IMPORTANT: Always recreate originalLocalStream since we stopped its tracks in toggleVideo
			// No need to clone streams with unified approach
			console.log('Using unified stream approach - no cloning needed')

			// Add local participant to video list
			this.joinedRoom(this.localStream, true)

			// Attach LocalVideoTrack directly to local video element for effects
			this.$nextTick(() => {
				this.attachLocalVideoTrack()
			})

			// Ensure dimensions are calculated after DOM updates
			this.$nextTick(() => {
				setTimeout(() => {
					this.dimensions()
					console.log('Dimensions recalculated after joining room')
				}, 100)
			})
		},
		joinedRoom(stream, isLocal, isScreenShare) {
			console.log('---> JOINEDROOM START <---', stream, ' ', isLocal, ' ', isScreenShare)
			const found = this.videoList.find((v) => v.id === stream.id)
			let video = {}
			if (found === undefined || !found.stream) {
				console.log('found === undefined || !found.stream', true)
				video = {
					id: stream.id, // stream of the current user
					muted: isLocal,
					stream,
					isLocal,
					videoEnabled: isScreenShare || this.partecipant.enableVideo,
					audioEnabled: isScreenShare ? false : this.partecipant.enableAudio,
					isScreenShare,
					isRecording: false,
					videoEffects: isScreenShare ? { blur: 0, src: '' } : { blur: this.partecipant.blur, src: this.partecipant.src },
					isSpeaking: false
				}

				if (isLocal) {
					console.log('isLocal', true)
					video.name = this.partecipant.partecipantName
				}

				const partecipant = this.tmpVideoList.find((f) => f.id === video.id)

				if (partecipant) {
					console.log('partecipant', true)
					video.avatarColor = partecipant.avatarColor
					video.videoEnabled = partecipant.videoEnabled
					video.audioEnabled = partecipant.audioEnabled
					video.name = partecipant.name
					video.isScreenShare = partecipant.isScreenShare
					video.isRecording = partecipant.isRecording

					if (partecipant.videoEffects && !partecipant.isScreenShare) {
						video.videoEffects = {
							blur: partecipant.videoEffects.blur,
							src: partecipant.videoEffects.src
						}
					} else {
						video.videoEffects = {
							blur: 0,
							src: ''
						}
					}
				}
				this.dimensions()

				this.videoList.push(video)
			}

			setTimeout(() => {
				console.log('JOINED ROOM HANDLED AUDIO')
				// if its me and i'm muted emit socket
				if (!this.partecipant.enableAudio && isLocal) {
					// this.socket.emit('disableAudio', {
					// 	key: this.roomId,
					// 	id: this.localStream.id
					// })

					// this.localStream.getTracks().find((track) => track.kind === 'audio').enabled = false
					this.audioOn = false
				}
				// if its me and i'm using mediapipe

				if (!isScreenShare) {
					console.log('JOINED ROOM !isScreenShare')
					try {
						// try catch per gestire errore in console di aggiunta audio ctx a uno share screen (non ha audio)
						// [TODO] va trovata una logica migliore
						const audioCTX = new AudioContext()
						const analyser = audioCTX.createAnalyser()
						const source = audioCTX.createMediaStreamSource(stream)
						source.connect(analyser)
						this.frameLoop(stream.id, analyser)
					} catch (error) {
						console.log(error)
					}
				}
			}, 500)

			// animation for people icon
			if (!isLocal) {
				this.newUser = true
				setTimeout(() => {
					this.newUser = false
				}, 2000)
			}
			console.log('---> JOINEDROOM END <---')
		},
		async leave() {
			console.log('---> LEAVE START <---')
			this.videoList.forEach((v) => {
				// Check if stream exists and has getTracks method before calling it
				if (v.stream && v.stream.getTracks) {
					v.stream.getTracks().forEach((t) => t.stop())
				}
			})
			this.videoList = []
			console.log('VIDEOLIST LOG 2', [])

			// Use the new disconnect method
			this.disconnectFromRoom()

			EventBus.$emit('left-room')
			console.log('---> LEAVE END <---')
			window.location.reload()
		},
		async recordVideo() {
			console.log('recordVideo', this.mediaRecorder, 'recordOn:', this.recordOn)

			// Controllo di sicurezza: se altri stanno registrando e noi non stiamo registrando, blocca l'azione
			if (!this.recordOn && this.hasOtherRecordingParticipants) {
				console.log('Recording blocked: another participant is already recording')
				if (this.$toast?.warning) {
					this.$toast.warning(this.$t('someone_else_recording'))
				}
				return
			}

			if (this.recordOn) {
				/* ===== OLD MEDIARECORDER METHOD - COMMENTED OUT =====
				// Stop recording - original method
				try {
					clearInterval(this.interval)
					this.interval = null

					// Stop the MediaRecorder if it's recording
					if (this.mediaRecorder.state === 'recording') {
						this.mediaRecorder.stop()
					}

					// Stop all tracks if they exist
					if (this.recordedScreen) {
						this.recordedScreen.getTracks().forEach((track) => {
							if (track.readyState === 'live') {
								track.stop()
							}
						})
					}

					this.recordOn = false
					this.recordedScreen = null
					this.mediaRecorder = null
					this.timestampRecord = null
				} catch (error) {
					console.error('Error stopping recording:', error)
					// Reset state even if error
					this.recordOn = false
					this.recordedScreen = null
					this.mediaRecorder = null
					this.timestampRecord = null
					this.interval = null
				}

				// Notifica agli altri partecipanti che la registrazione è terminata
				this.broadcastRecordingStatus(false)
				===== END OLD MEDIARECORDER METHOD ===== */

				// ===== TWILIO SERVER-SIDE RECORDING =====
				// Prevent concurrent API calls
				if (this.recordingInProgress) {
					console.log('Recording operation already in progress, ignoring click')
					return
				}

				this.recordingInProgress = true

				try {
					console.log('Stopping recording...')

					// Get the actual Twilio Room SID (not the room name)
					const roomSid = this.twilioRoom?.sid || this.roomId
					console.log('Using Room SID for stop recording:', roomSid)

					// Validate Room SID format (should be 34 chars starting with RM)
					if (!roomSid || (!roomSid.startsWith('RM') && roomSid.length !== 34)) {
						console.warn('Room SID appears to be invalid format:', roomSid)
					}

					// Prepare participant emails array for API call
					const participantEmails = [...this.recordingParticipantEmails]
					console.log('Sending participant emails to stop recording API:', participantEmails)

					// Call backend API to stop Twilio recording FIRST
					const response = await goapi.post('/recording/stop', {
						room_sid: roomSid,
						participant_emails: participantEmails
					})

					const result = response.data

					if (result.success) {
						console.log('Recording stopped successfully:', result.message)

						// Only update state after successful API call
						this.recordOn = false
						clearInterval(this.interval)
						this.interval = null
						this.timestampRecord = null

						// Emit socket event for real-time UI updates (safe call)
						try {
							if (this.socket && this.localStream?.id) {
								this.socket.emit('stopRecord', { key: this.roomId, id: this.localStream.id })
							}
						} catch (socketError) {
							console.warn('Socket emit failed:', socketError)
						}

						// Notify other participants that recording has stopped
						this.broadcastRecordingStatus(false)

						// Clear participant emails tracking after successful stop
						this.recordingParticipantEmails.clear()
						console.log('Cleared recording participant emails after successful stop')

						this.recordingInProgress = false
					} else {
						console.error('Failed to stop recording:', result.message)
						// Keep recording state as is since API call failed
						// Show error to user
						if (this.$toast?.error) {
							this.$toast.error(result.message || 'Failed to stop recording')
						}
						this.recordingInProgress = false
					}
				} catch (error) {
					console.error('Error stopping recording:', error)
					// Keep recording state as is since API call failed
					if (this.$toast?.error) {
						this.$toast.error('Error stopping recording')
					}
					this.recordingInProgress = false
				}
			} else {
				// ===== END TWILIO SERVER-SIDE RECORDING =====
				/* ===== OLD MEDIARECORDER METHOD - COMMENTED OUT =====
				// Start recording - original method
				try {
					this.recordedScreen = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false, preferCurrentTab: true })
					this.recordedScreen.getVideoTracks()[0].onended = () => {
						console.log('Screen sharing ended by user')
						// Solo se stiamo ancora registrando
						if (this.recordOn && this.mediaRecorder && this.mediaRecorder.state === 'recording') {
							// Ferma la registrazione quando l'utente termina la condivisione
							this.recordVideo()
						}
					}
					let micNumber = 0
					await navigator.mediaDevices
						.enumerateDevices()
						.then(async (devices) => {
							devices.forEach(function (device) {
								if (device.kind === 'audioinput') {
									micNumber++
								}
							})
							if (micNumber === 0) {
								//	no audio inputs present on device/pc
								console.log('No audio inputs detected, using video only')
								await this.onCombinedStreamAvailable(this.recordedScreen)
							} else {
								//	audio inputs present, let's get access
								navigator.mediaDevices
									.getUserMedia({ audio: true })
									.then(async (micStream) => {
										//	create a new stream in which to pack everything together
										const composedStream = new MediaStream()
										//	add the screen video stream
										this.recordedScreen.getVideoTracks().forEach(function (videoTrack) {
											composedStream.addTrack(videoTrack)
										})
										//	if system audio has been shared
										if (this.recordedScreen.getAudioTracks().length > 0) {
											//	merge the system audio with the mic audio
											const context = new AudioContext()
											const audioDestination = context.createMediaStreamDestination()
											const systemSource = context.createMediaStreamSource(this.recordedScreen)
											const systemGain = context.createGain()
											systemGain.gain.value = 1.0
											systemSource.connect(systemGain).connect(audioDestination)
											if (micStream && micStream.getAudioTracks().length > 0) {
												const micSource = context.createMediaStreamSource(micStream)
												const micGain = context.createGain()
												micGain.gain.value = 1.0
												micSource.connect(micGain).connect(audioDestination)
											}
											audioDestination.stream.getAudioTracks().forEach(function (audioTrack) {
												composedStream.addTrack(audioTrack)
											})
										} else {
											//	add just the mic audio
											micStream.getAudioTracks().forEach(function (micTrack) {
												composedStream.addTrack(micTrack)
											})
										}
										await this.onCombinedStreamAvailable(composedStream)
									})
									.catch((err) => {
										console.error('navigator.getUserMedia error: ' + err)
										this.recordOn = false
									})
							}
						})
						.catch(function (err) {
							console.error(err)
						})
				} catch (e) {
					console.error(e)
				}
				===== END OLD MEDIARECORDER METHOD ===== */

				// ===== TWILIO SERVER-SIDE RECORDING =====
				// Prevent concurrent API calls
				if (this.recordingInProgress) {
					console.log('Recording operation already in progress, ignoring click')
					return
				}

				this.recordingInProgress = true

				try {
					console.log('Starting recording...')

					// Get the actual Twilio Room SID (not the room name)
					const roomSid = this.twilioRoom?.sid || this.roomId
					console.log('Using Room SID for start recording:', roomSid)

					// Validate Room SID format (should be 34 chars starting with RM)
					if (!roomSid || (!roomSid.startsWith('RM') && roomSid.length !== 34)) {
						console.warn('Room SID appears to be invalid format:', roomSid)
					}

					// Call backend API to start Twilio recording
					const response = await goapi.post('/recording/start', {
						room_sid: roomSid
					})

					const result = response.data

					if (result.success) {
						console.log('Recording started successfully:', result.message)

						// Only update state after successful API call
						this.recordOn = true
						this.timestampRecord = dayjs('1900-01-01 00:00:00')
						this.toggleTimer()

						// Emit socket event for real-time UI updates (safe call)
						try {
							if (this.socket && this.localStream?.id) {
								this.socket.emit('startRecord', { key: this.roomId, id: this.localStream.id })
							}
						} catch (socketError) {
							console.warn('Socket emit failed:', socketError)
						}

						// Notify other participants that recording has started
						this.broadcastRecordingStatus(true)

						// Show success message to user
						if (this.$toast?.success) {
							this.$toast.success('Recording started')
						}

						// Collect participant emails for recording tracking
						this.recordingParticipantEmails.clear() // Clear any previous recording emails

						// Add current local participant's email if available
						if (this.partecipant?.partecipantEmail) {
							this.recordingParticipantEmails.add(this.partecipant.partecipantEmail)
							console.log('Added local participant email to recording:', this.partecipant.partecipantEmail)
						}

						// Add all current remote participants' emails
						this.videoList.forEach((participant) => {
							if (!participant.isLocal && participant.twilioIdentity) {
								const email = getEmailFromIdentity(participant.twilioIdentity)
								if (email) {
									this.recordingParticipantEmails.add(email)
									console.log('Added participant email to recording:', email)
								}
							}
						})

						console.log('Recording participant emails collected:', [...this.recordingParticipantEmails])

						this.recordingInProgress = false
					} else {
						console.error('Failed to start recording:', result.message)
						// Keep recording state as false since API call failed
						// Show error to user
						if (this.$toast?.error) {
							this.$toast.error(result.message || 'Failed to start recording')
						}
						this.recordingInProgress = false
					}
				} catch (error) {
					console.error('Error starting recording:', error)
					// Ensure recording state stays false on error
					this.recordOn = false
					if (this.$toast?.error) {
						this.$toast.error('Error starting recording')
					}
					this.recordingInProgress = false
				}
				// ===== END TWILIO SERVER-SIDE RECORDING =====
			}
		},

		async onCombinedStreamAvailable(stream) {
			const chunks = []
			let options = {}
			if (typeof MediaRecorder.isTypeSupported === 'function') {
				if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
					options = { mimeType: 'video/webm;codecs=vp9' }
				} else if (MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
					options = { mimeType: 'video/webm;codecs=h264' }
				} else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) {
					options = { mimeType: 'video/webm;codecs=vp8' }
				}
				this.mediaRecorder = new MediaRecorder(stream, options)
			} else {
				this.mediaRecorder = new MediaRecorder(stream)
			}
			this.mediaRecorder.ondataavailable = (e) => {
				chunks.push(e.data)
			}
			this.mediaRecorder.onerror = (e) => {
				console.error('mediaRecorder.onerror: ' + e)
			}
			this.mediaRecorder.onstop = () => {
				const blob = new Blob(chunks, { type: 'video/webm' })
				const videoURL = window.URL.createObjectURL(blob)
				const link = document.createElement('a')
				let today = new Date()
				const dd = String(today.getDate()).padStart(2, '0')
				const mm = String(today.getMonth() + 1).padStart(2, '0')
				const yyyy = today.getFullYear()
				today = mm + '-' + dd + '-' + yyyy
				const name = this.meetName.replace(' ', '_') + '_' + today + '.webm'
				link.setAttribute('download', name)
				link.setAttribute('name', name)
				link.href = videoURL
				document.body.appendChild(link)
				link.click()
			}
			this.mediaRecorder.onwarning = (e) => {
				console.warn('mediaRecorder.onwarning: ' + e)
			}
			this.mediaRecorder.start(10)
			this.recordOn = true
			this.timestampRecord = dayjs('1900-01-01 00:00:00')
			this.toggleTimer()
			// Socket.emit removed - no longer using sockets
			console.log('Recording started')

			// Notifica agli altri partecipanti che la registrazione è iniziata
			this.broadcastRecordingStatus(true)
			if (stream && stream.getTracks) {
				stream.getTracks().forEach(function (track) {
					console.log(track.kind + ':' + JSON.stringify(track.getSettings()))
					console.log(track.getSettings())
				})
			}
		},

		async pollForRecordings() {
			try {
				// Get the actual Twilio Room SID (not the room name)
				const roomSid = this.twilioRoom?.sid || this.roomId
				console.log('Polling for recordings for room SID:', roomSid)

				// Validate Room SID format (should be 34 chars starting with RM)
				if (!roomSid || (!roomSid.startsWith('RM') && roomSid.length !== 34)) {
					console.warn('Room SID appears to be invalid format:', roomSid)
				}

				const response = await goapi.get(`/recording/room?roomSid=${roomSid}`)
				const result = response.data

				if (result.success && result.data && result.data.length > 0) {
					// Filter for completed recordings
					const completedRecordings = result.data.filter((recording) => recording.status === 'completed')

					if (completedRecordings.length > 0) {
						console.log(`Found ${completedRecordings.length} completed recordings`)
						// Download all completed recordings
						for (const recording of completedRecordings) {
							await this.downloadRecording(recording.sid)
						}
						if (this.$toast?.success) {
							this.$toast.success(`Downloaded ${completedRecordings.length} recording(s)`)
						}
					} else {
						console.log('Recordings still processing, will retry...')
						// Retry after another delay if recordings are still processing
						setTimeout(() => {
							this.pollForRecordings()
						}, 5000)
					}
				} else {
					console.log('No recordings found yet, will retry...')
					// Retry after delay if no recordings found yet
					setTimeout(() => {
						this.pollForRecordings()
					}, 5000)
				}
			} catch (error) {
				console.error('Error polling for recordings:', error)
				if (this.$toast?.error) {
					this.$toast.error('Error checking for recordings')
				}
			}
		},

		async downloadRecording(recordingSid) {
			try {
				console.log('Downloading recording:', recordingSid)

				// Create a temporary anchor element to trigger download
				const link = document.createElement('a')
				link.href = `${process.env.VUE_APP_GOAPI}recording/download?recordingSid=${recordingSid}`

				// Generate filename with timestamp
				const today = new Date()
				const dd = String(today.getDate()).padStart(2, '0')
				const mm = String(today.getMonth() + 1).padStart(2, '0')
				const yyyy = today.getFullYear()
				const hh = String(today.getHours()).padStart(2, '0')
				const min = String(today.getMinutes()).padStart(2, '0')

				const timestamp = `${mm}-${dd}-${yyyy}_${hh}-${min}`
				const filename = `${this.meetName.replace(/\s+/g, '_')}_recording_${timestamp}`

				link.setAttribute('download', filename)
				link.style.display = 'none'

				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)

				console.log('Recording download initiated:', filename)
			} catch (error) {
				console.error('Error downloading recording:', error)
				if (this.$toast?.error) {
					this.$toast.error('Error downloading recording')
				}
			}
		},
		async shareScreen() {
			console.log('shareScreen', this.shareOn, this.screenTrack?.sid)

			if (!this.twilioRoom || !this.twilioRoom.localParticipant) {
				console.error('No Twilio room or local participant available for screen sharing')
				return
			}

			if (this.shareOn) {
				// Stop screen sharing
				try {
					if (this.screenTrack) {
						// Unpublish from Twilio room
						await this.twilioRoom.localParticipant.unpublishTrack(this.screenTrack)
						console.log('Screen track unpublished from Twilio room')

						// Stop the track
						this.screenTrack.stop()
						this.screenTrack = null
					}

					// Clean up legacy stream if exists
					if (this.screenStream) {
						this.screenStream.getTracks().forEach((track) => {
							track.stop()
						})
						this.screenStream = null
					}

					this.shareOn = false

					// Remove local screen share from video list
					this.removeScreenShareFromVideoList()

					console.log('Screen sharing stopped')
				} catch (error) {
					console.error('Error stopping screen share:', error)
				}
				return
			}

			// Start screen sharing
			if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
				console.error('Screen sharing not supported by browser')
				if (this.$toast?.error) {
					this.$toast.error(this.$t('screen_share_not_supported') || 'Screen sharing is not supported by your browser')
				}
				return
			}

			try {
				console.log('Starting screen share...')

				// Get display media stream with optimized options
				const displayStream = await navigator.mediaDevices.getDisplayMedia({
					video: { frameRate: 15 },
					audio: false
				})

				// Import Twilio classes
				const { LocalVideoTrack } = await import('twilio-video')

				// Create Twilio video track from the display stream with name identifier
				const videoTrack = displayStream.getVideoTracks()[0]
				this.screenTrack = new LocalVideoTrack(videoTrack, { name: 'screen-share' })

				// Add automatic cleanup event listener as recommended by Twilio guide
				this.screenTrack.once('stopped', () => {
					console.log('Screen track stopped automatically')
					if (this.twilioRoom && this.twilioRoom.localParticipant) {
						this.twilioRoom.localParticipant.unpublishTrack(this.screenTrack)
					}
					this.shareOn = false
					this.removeScreenShareFromVideoList()
					this.screenTrack = null
					this.screenStream = null
				})

				// Publish to Twilio room
				await this.twilioRoom.localParticipant.publishTrack(this.screenTrack)
				console.log('Screen track published to Twilio room')

				// Store stream for legacy compatibility
				this.screenStream = displayStream
				this.shareOn = true

				// Handle when user stops sharing via browser UI (additional fallback)
				videoTrack.addEventListener('ended', () => {
					console.log('Screen sharing ended via browser')
					if (this.shareOn) {
						this.shareScreen() // This will trigger the stop logic above
					}
				})

				// Add local screen share to video list since Twilio doesn't send local tracks as remote
				this.addScreenShareToVideoList(displayStream)

				console.log('Screen sharing started successfully')

				// Show success message
				if (this.$toast?.success) {
					this.$toast.success(this.$t('screen_share_started') || 'Screen sharing started')
				}
			} catch (error) {
				console.error('Error starting screen share:', error)
				this.shareOn = false

				// Provide user-friendly error messages
				let errorMessage = this.$t('screen_share_error') || 'Error starting screen share'

				// Handle specific error cases
				if (error.name === 'NotAllowedError') {
					errorMessage = this.$t('screen_share_permission_denied') || 'Screen sharing permission was denied'
				} else if (error.name === 'NotFoundError') {
					errorMessage = this.$t('screen_share_no_source') || 'No screen source was selected'
				} else if (error.name === 'AbortError') {
					// User cancelled the screen selection dialog - no need to show error
					console.log('User cancelled screen sharing')
					return
				}

				if (this.$toast?.error) {
					this.$toast.error(errorMessage)
				}
			}
		},

		addScreenShareToVideoList(displayStream) {
			// Add screen share to video list as local video with isScreenShare flag
			const screenShareVideo = {
				id: displayStream.id,
				muted: true, // Screen shares are always muted for audio
				stream: displayStream,
				isLocal: true,
				videoEnabled: true,
				audioEnabled: false,
				isScreenShare: true,
				name: this.partecipant.partecipantName || 'Screen Share',
				avatarColor: this.partecipant.avatarColor || '#4A90E2',
				pinned: false,
				isRecording: false,
				videoEffects: { blur: 0, src: '' },
				isSpeaking: false
			}

			// Remove any existing screen share from the same user
			this.videoList = this.videoList.filter((v) => !(v.isLocal && v.isScreenShare))

			// Add new screen share
			this.videoList.push(screenShareVideo)

			// Auto-pin the screen share
			this.$nextTick(() => {
				this.expand(screenShareVideo)
			})

			console.log('Screen share added to video list and auto-pinned')
		},

		removeScreenShareFromVideoList() {
			// Remove screen share from video list
			const screenShareIndex = this.videoList.findIndex((v) => v.isLocal && v.isScreenShare)
			if (screenShareIndex !== -1) {
				const screenShare = this.videoList[screenShareIndex]
				// If it was pinned, unpin it first
				if (screenShare.pinned) {
					this.unexpand(screenShare)
				}
				this.videoList.splice(screenShareIndex, 1)
				console.log('Screen share removed from video list')
			}
		},

		log(message, data) {
			if (this.enableLogs) {
				console.log(message)
				if (data != null) {
					console.log(data)
				}
			}
		},

		syncFilterStateFromPreview(participant) {
			console.log('Syncing filter state from Preview to Meeting component')
			console.log('Participant filter data:', {
				currentBlurLevel: participant.currentBlurLevel,
				currentBackground: participant.currentBackground?.image || null,
				hasCurrentProcessor: participant.hasCurrentProcessor,
				currentProcessor: !!participant.currentProcessor
			})

			// Determine if there are active filters based on actual values, not just processor status
			const hasBlurFilter = participant.currentBlurLevel !== undefined && participant.currentBlurLevel !== null && participant.currentBlurLevel > 0

			const hasBackgroundFilter = participant.currentBackground && participant.currentBackground.image

			// Sync blur level
			if (hasBlurFilter) {
				this.previewBlurLevel = participant.currentBlurLevel
				this.blur = participant.currentBlurLevel
				this.background = null // Clear background when blur is active
				console.log('Synced blur level:', participant.currentBlurLevel)
			} else if (hasBackgroundFilter) {
				// Sync virtual background (takes priority over blur)
				this.background = participant.currentBackground
				this.previewBlurLevel = 0
				this.blur = 0 // Clear blur when background is active
				console.log('Synced virtual background:', participant.currentBackground.image)
			} else {
				this.previewBlurLevel = 0
				this.blur = 0
				this.background = null
				console.log('No active filters detected, cleared all filter state')
			}

			// Check if the LocalVideoTrack has processors and store reference for later removal
			if (this.localVideoTrack && this.localVideoTrack.processors) {
				console.log('LocalVideoTrack has existing processors:', this.localVideoTrack.processors.length)
				// Store references to existing processors for potential removal
				this.inheritedProcessors = [...this.localVideoTrack.processors]
				console.log('Stored inherited processors for later management')
			}

			// Set currentProcessor and processedTrack when inheriting filters from Preview
			if (participant.currentProcessor && this.localVideoTrack) {
				console.log('Setting currentProcessor for inherited filters')
				this.currentProcessor = participant.currentProcessor
				console.log('Inherited processor set as current processor for removal management')
			}

			console.log('Filter state sync completed:', {
				blur: this.blur,
				previewBlurLevel: this.previewBlurLevel,
				background: this.background?.image || null,
				hasActiveFilters: hasBlurFilter || hasBackgroundFilter,
				inheritedProcessors: this.inheritedProcessors?.length || 0,
				currentProcessor: !!this.currentProcessor
			})
		},

		attachLocalVideoTrack() {
			if (!this.localVideoTrack) {
				console.log('No LocalVideoTrack available for attachment')
				return
			}

			// Find the local video element in the DOM
			const localVideo = this.videoList.find((v) => v.isLocal)
			if (!localVideo) {
				console.log('Local video not found in videoList')
				return
			}

			const videoElement = this.getLocalVideoElement(localVideo)
			if (!videoElement) {
				console.log('Local video element not found in DOM with id:', localVideo.id)
				return
			}

			try {
				// Detach any existing srcObject
				videoElement.srcObject = null

				// Attach LocalVideoTrack directly (preserves effects)
				this.localVideoTrack.attach(videoElement)

				console.log('LocalVideoTrack attached to local video element (effects preserved)')
			} catch (error) {
				console.error('Failed to attach LocalVideoTrack to local video element:', error)
				// Fallback to original stream
				videoElement.srcObject = localVideo.stream
			}
		},

		// Nuovo metodo per inviare lo stato di registrazione agli altri partecipanti
		broadcastRecordingStatus(isRecording) {
			console.log('📡 [DATATRACK DEBUG] Broadcasting recording status:', isRecording, 'for participant:', this.partecipant?.partecipantName)

			if (!this.localDataTrack || !this.partecipant?.partecipantName) {
				console.warn('❌ [DATATRACK DEBUG] Cannot broadcast recording status: DataTrack or participant name not available')
				console.warn('❌ [DATATRACK DEBUG] localDataTrack:', !!this.localDataTrack, 'participantName:', this.partecipant?.partecipantName)
				return
			}

			// Verifica stato del DataTrack
			console.log('🔍 [DATATRACK DEBUG] DataTrack verification:')
			console.log('🔍 [DATATRACK DEBUG] - localDataTrack.id:', this.localDataTrack.id)
			console.log('🔍 [DATATRACK DEBUG] - localDataTrack.isEnabled:', this.localDataTrack.isEnabled)
			console.log('🔍 [DATATRACK DEBUG] - localDataTrack.name:', this.localDataTrack.name)
			console.log('🔍 [DATATRACK DEBUG] - twilioRoom participants count:', this.twilioRoom?.participants?.size || 0)

			// Verifica partecipanti remoti e loro DataTrack
			if (this.twilioRoom?.participants) {
				console.log('🔍 [DATATRACK DEBUG] Remote participants DataTrack status:')
				this.twilioRoom.participants.forEach((participant) => {
					const hasDataTrack = Array.from(participant.dataTracks.values()).length > 0
					console.log(`🔍 [DATATRACK DEBUG] - ${participant.identity}: hasDataTrack=${hasDataTrack}, dataTracks.size=${participant.dataTracks.size}`)
				})
			}

			try {
				const recordingStatusMessage = {
					type: 'recording_status',
					participantName: this.partecipant.partecipantName,
					isRecording: isRecording,
					timestamp: Date.now()
				}

				console.log('📡 [DATATRACK DEBUG] Sending recording status message:', recordingStatusMessage)
				console.log('📡 [DATATRACK DEBUG] LocalDataTrack state:', {
					id: this.localDataTrack.id,
					name: this.localDataTrack.name,
					kind: this.localDataTrack.kind,
					isEnabled: this.localDataTrack.isEnabled
				})

				this.localDataTrack.send(JSON.stringify(recordingStatusMessage))
				console.log('✅ [DATATRACK DEBUG] Recording status message sent successfully')

				// Aggiorna anche il proprio stato nella videoList
				const localVideo = this.videoList.find((v) => v.isLocal)
				if (localVideo) {
					localVideo.isRecording = isRecording
				}
			} catch (error) {
				console.error('Error broadcasting recording status:', error)
			}
		},

		// Nuovo metodo per gestire gli aggiornamenti di stato registrazione ricevuti
		handleRecordingStatusUpdate(recordingData, participantIdentity) {
			try {
				console.log('🎬 [DATATRACK DEBUG] ===== RECEIVING RECORDING STATUS =====')
				console.log('🎬 [DATATRACK DEBUG] From participant:', participantIdentity)
				console.log('🎬 [DATATRACK DEBUG] Message data:', recordingData)
				console.log('🎬 [DATATRACK DEBUG] Message timestamp:', new Date(recordingData.timestamp).toLocaleTimeString())
				console.log(
					'🎬 [DATATRACK DEBUG] Current videoList participants:',
					this.videoList.map((v) => ({
						name: v.name,
						twilioIdentity: v.twilioIdentity,
						isLocal: v.isLocal,
						isRecording: v.isRecording
					}))
				)

				// Trova il partecipante nella videoList usando l'identity di Twilio
				const participant = this.videoList.find((v) => v.twilioIdentity === participantIdentity || v.name === recordingData.participantName)

				if (participant) {
					console.log(`✅ [DATATRACK DEBUG] Found participant ${participant.name}, updating recording status: ${recordingData.isRecording}`)
					const oldStatus = participant.isRecording
					participant.isRecording = recordingData.isRecording
					console.log(`✅ [DATATRACK DEBUG] Recording status updated for ${participant.name}: ${oldStatus} → ${recordingData.isRecording}`)

					// Force Vue reactivity update
					this.$forceUpdate()
					console.log('✅ [DATATRACK DEBUG] Vue reactivity forced update completed')
				} else {
					console.warn('⚠️ [DATATRACK DEBUG] Participant not found in videoList for identity:', participantIdentity)
					console.warn('⚠️ [DATATRACK DEBUG] Searched for identity/name:', participantIdentity, '/', recordingData.participantName)
					console.warn(
						'⚠️ [DATATRACK DEBUG] Available participants:',
						this.videoList.map((v) => v.twilioIdentity || v.name)
					)
				}
			} catch (error) {
				console.error('❌ [DATATRACK DEBUG] Error in handleRecordingStatusUpdate:', error)
			}
		},

		// Nuovo metodo per inviare il proprio stato di registrazione ai nuovi partecipanti
		sendRecordingStatesForNewParticipant() {
			if (!this.localDataTrack || !this.partecipant?.partecipantName) {
				console.warn('❌ [NEW_PARTICIPANT] Cannot send recording states: DataTrack or participant name not available')
				return
			}

			// Se sto registrando, invia il mio stato di registrazione
			if (this.recordOn) {
				console.log('📡 [NEW_PARTICIPANT] I am recording, sending my recording status to new participant')
				this.broadcastRecordingStatus(true)
			} else {
				console.log('📡 [NEW_PARTICIPANT] I am not recording, nothing to sync')
			}
		},

		// Helper method to check if a track is actually enabled
		isTrackEnabled(track) {
			if (!track) {
				return false
			}

			// Per i video track, potrebbe essere necessario controllare anche il mediaStreamTrack
			if (track.kind === 'video' && track.mediaStreamTrack) {
				return track.mediaStreamTrack.enabled !== false
			}

			// Per gli audio track o fallback generale
			return track.enabled !== false
		}
	},
	async mounted() {
		console.log('---> MOUNTED START <---')

		window.addEventListener('resize', this.dimensions)

		// Handle page unload (tab close, browser close, navigation away)
		window.addEventListener('beforeunload', this.handlePageUnload)
		window.addEventListener('unload', this.handlePageUnload)

		// Expose this Vue component instance to browser console for debugging
		window.vueWebrtcInstance = this

		// Add some helpful debugging functions to the window
		window.twilioDebug = {
			getRoom: () => this.twilioRoom,
			getParticipants: () => this.twilioRoom?.participants || new Map(),
			getLocalTracks: () => {
				const participant = this.twilioRoom?.localParticipant
				return participant ? Array.from(participant.tracks.values()) : []
			},
			getVideoList: () => this.videoList,
			getRoomState: () => this.twilioRoom?.state || 'not connected',
			disconnectRoom: () => this.disconnectFromRoom(),
			getProcessors: () => ({
				current: this.currentProcessor,
				preview: this.previewProcessor,
				virtualBackground: this.virtualBackgroundProcessor
			})
		}

		console.log('🔧 [DEBUG] Vue WebRTC instance exposed as window.vueWebrtcInstance')
		console.log('🔧 [DEBUG] Access Twilio Room with: window.vueWebrtcInstance.twilioRoom')
		console.log('🔧 [DEBUG] Debugging helpers available at: window.twilioDebug')
		console.log('🔧 [DEBUG] Try: window.twilioDebug.getRoom(), window.twilioDebug.getParticipants()')

		console.log('---> MOUNTED END <---')
	},
	unmounted() {
		console.log('---> UNMOUNTED START <---')
		// Clean up preview resources
		this.cleanupPreviewTrack()
		window.removeEventListener('resize', this.dimensions)
		window.removeEventListener('beforeunload', this.handlePageUnload)
		window.removeEventListener('unload', this.handlePageUnload)

		// Clean up debug references
		if (window.vueWebrtcInstance === this) {
			delete window.vueWebrtcInstance
			console.log('🔧 [DEBUG] Cleaned up window.vueWebrtcInstance')
		}

		// Ensure Twilio room is disconnected
		this.disconnectFromRoom()

		console.log('---> UNMOUNTED END <---')
	}
})
</script>
<style lang="scss">
body {
	overflow: hidden;
}

@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,400;0,700;1,100;1,300;1,400&display=swap');

* {
	font-family: 'Lato', sans-serif;
}

.Container {
	background: #011935;
	background: radial-gradient(circle at 50% 100%, #1e4a7c, #0c2343);
	width: 100%;
	height: 100%;
	-webkit-transform: translateZ(0);
	box-sizing: border-box;
}

@keyframes slidein {
	from {
		width: 0%;
	}

	to {
		width: 100%;
		min-width: 360px;
	}
}

.RightBox {
	height: calc(100% - 15px);
	display: flex;
	align-content: center;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	vertical-align: middle;
	flex: 0;
	border-radius: 15px;
	overflow: hidden;
	transition: all 0.4s ease-out;
	overflow: hidden;

	&.open {
		border: 1px solid hsla(210, 65%, 67%, 0.55);
		border-radius: 10px;
		flex: 0 0 30%;
		transition: all 0.4s ease-out 0.1s;
	}

	.chat-container {
		box-shadow: 0 3px 6px rgba(255, 255, 255, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		// background: #1a2f49;
		background: #0c1e3d;
		overflow: hidden;
		flex-direction: column;
		height: 100%;
		display: flex;
		align-content: center;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		vertical-align: middle;
		flex: 1;

		.chat-header {
			width: 100%;
			height: 40px;
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid hsla(210, 65%, 67%, 0.55);
			color: white;
			background: rgba(116, 171, 226, 0.15);

			span,
			svg {
				padding: 0 10px;
				cursor: pointer;
			}

			svg path {
				fill: white;
			}
		}

		.chat-messages {
			width: 100%;
			flex-direction: column;
			display: flex;
			flex: 1;
			overflow-y: auto;

			.chat-messages-info {
				line-height: 1rem;
				margin: 0.75rem;
				padding: 0.75rem;
				text-align: center;
				font-size: 12px;
				border-radius: 8px;
				letter-spacing: 0.025em;
				background: white;
				color: #011730;
				transform: scale(0);
				opacity: 0;

				&.hide {
					transform: scale(0);
					opacity: 0;
				}

				&.show {
					animation: showInfo 0.6s forwards;
					animation-delay: 0.55s;
				}

				&.alreadyOpen {
					transform: scale(1);
					opacity: 1;
				}
			}

			.left-msg .private-badge {
				right: -14px;
				top: -10.5px;
			}

			.right-msg .private-badge {
				left: -12.5px;
				top: -7.5px;
			}

			.private-badge {
				position: absolute;
				border: 1.5px solid #0b1e3d;
				background: #ff004f;
				border-radius: 50%;
				width: 22px;
				height: 22px;
				display: flex;
				justify-content: center;
				align-items: center;

				svg {
					width: 15px !important;
					height: 15px !important;

					path {
						fill: white;
					}
				}
			}

			.msg {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				&:first-of-type {
					margin-top: 10px;
				}
			}

			.msg-bubble {
				position: relative;
				display: flex;
				align-items: center;
				position: relative;
				max-width: 70%;
				min-width: 115px;
				border-radius: 15px;
				background: rgb(125, 184, 243);
				color: #011730;
				animation: show 0.4s ease-out;
			}

			.private-msg.right-msg .msg-bubble {
				border-top-left-radius: 0px;
			}

			.private-msg.left-msg .msg-bubble {
				border-top-right-radius: 0px;
			}

			.msg-text {
				word-break: break-word;
				width: 100%;
				padding: 0 10px 5px 20px;
				font-size: 13px;
			}

			.msg.right-msg .msg-info {
				justify-content: flex-end;
				overflow: hidden;
				color: #011730;
			}

			.msg.right-msg .msg-text {
				color: #011730;
			}

			.left-msg .msg-bubble {
				border-bottom-left-radius: 0;
			}

			.left-msg {
				margin-left: 15px;
			}

			.right-msg {
				margin-right: 15px;
				flex-direction: row-reverse;
			}

			.right-msg .msg-bubble {
				background: #bad7ff;
				color: #011730;
				border-bottom-right-radius: 0;
			}

			.right-msg .msg-img {
				margin: 0 0 0 10px;
			}

			.private-msg .msg-bubble {
				color: #011730;
				// background: #ff004f !important;
			}

			.msg-container {
				width: 100%;
				flex-direction: column;
				padding: 2px 10px 5px 10px;
				display: flex;
				align-items: center;

				.msg-info {
					width: 100%;
					padding: 2px 10px 5px 10px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 12px;

					.msg-info-name {
						text-transform: capitalize;
						margin-right: 10px;
						font-weight: bold;
						white-space: nowrap;
						text-overflow: ellipsis;
						width: calc(100% - 40px);
						overflow: hidden;
					}

					.msg-info-time {
						font-size: 0.85em;
					}
				}
			}
		}

		.chat-input {
			background: rgba(116, 171, 226, 0.15);
			position: relative;
			border-top: 1px solid hsla(210, 65%, 67%, 0.55);
			height: 60px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;

			.suggestion {
				color: black;
				border-radius: 8px;
				position: absolute;
				backdrop-filter: blur(5px);
				left: 12px;
				border: 1px solid hsla(210, 65%, 67%, 0.55);
				animation: show 0.4s ease;

				div:first-child {
					background: #1495de;
					padding: 5px 8px 5px 8px;
					color: white;
				}

				ul {
					background: white;
					min-width: 150px;
					list-style: none;
					margin: 0;
					text-align: left;
					padding: 0;
					max-height: 110px;
					overflow: hidden;
					overflow-y: auto;

					li {
						padding: 5px 8px;
						cursor: pointer;

						&:hover,
						&:focus {
							background: hsla(210, 65%, 67%, 0.55);
							border: 0;
							outline: 0;
						}
					}
				}
			}

			input.chat {
				width: 100%;
				height: 35px !important;
				max-height: 35px !important;
				border-top-left-radius: 5px;
				border-bottom-left-radius: 5px;
				text-indent: 10px;
				border: 0;
				padding: 0;

				&:focus,
				&:focus-visible {
					outline: 0;
				}
			}

			button.send {
				border: 0;
				padding: 0;
				height: 36px;
				border-top-right-radius: 5px;
				border-bottom-right-radius: 5px;
				background: rgba(0, 174, 255, 1);
				color: white;
				padding: 5px 10px;
				text-transform: uppercase;
				cursor: pointer;

				&:hover {
					background: rgba(0, 174, 255, 0.8);
				}
			}

			.emoji-wrapper {
				animation: show 0.4s ease-out;
				position: absolute;
				bottom: 50px;
				left: 5px;
				width: calc(100% - 10px);
				border-radius: 10px;

				.composer-emoji-popover {
					height: 200px !important;
					width: 100% !important;
					overflow: hidden;
					background: white !important;
					box-shadow: 0 3px 6px rgba(34, 29, 29, 0.56), 0 3px 6px rgba(0, 0, 0, 0.53);

					//background: radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(204, 209, 215, 1) 100%);
					input,
					input:focus,
					input:focus-visible {
						display: none;
					}

					.emoji-picker-group {
						display: flex;
						flex-wrap: wrap;

						.emoji-picker-emoji {
							margin: 5px 8px;
							font-size: 20px;
							height: 20px;
							width: 20px;
							min-width: 20px;
							max-width: 20px;
							display: flex;
							cursor: pointer !important;
						}
					}

					.composer-popover-body-container {
						display: flex;
						flex-direction: column;
					}

					.composer-popover-body {
						display: flex;
						justify-content: space-between;
						padding: 5px 10px;
						max-height: calc(200px - 48px);
						overflow: hidden;
						overflow-y: auto;
					}

					.emoji-category-group {
						order: -1;
						background: #1b3456;
					}

					.tone-category-group {
						background: #1b3456;
					}

					.tone-category-group,
					.emoji-category-group {
						display: flex;
						padding: 5px 10px;

						.tone-category,
						.category {
							filter: grayscale(70%);
							cursor: pointer;
							height: 25px;
							width: 25px;
							margin: 0px 5.5px;
							min-width: 25px;
							max-width: 25px;
							display: flex;
							justify-content: center;
							align-items: center;
							align-content: center;
						}

						.category:hover {
							filter: grayscale(0%);
							background: #3280d3;
							border-radius: 50%;
						}

						.tone-category:hover {
							filter: grayscale(0%);
						}

						.category span,
						.tone-category span {
							font-size: 20px !important;
						}

						.tone-category.active,
						.category.active {
							filter: grayscale(0%);
							border-bottom: 2px solid #3280d3;
						}
					}

					.tone-category-group + .composer-popover-body {
						max-height: calc(200px - 48px - 30px);
						display: flex;
						justify-content: space-between;
					}
				}
			}
		}

		.chat-tooltip {
			z-index: -1;
			position: absolute;
			background: #0080d3;
			border: 1px solid hsla(210, 65%, 67%, 0.55);
			color: white;
			padding: 5px 15px;
			border-radius: 3px;
			font-size: 12px;
			top: 0px;
			opacity: 0;
			width: max-content;
		}

		.chat-tooltip.emojy {
			left: -300% !important;
		}

		.chat-button-wrapper {
			padding: 0;
			margin: 0 10px 0px 6px;
			width: fit-content;
			position: relative;

			&:first-child {
				margin: 0 6px 0px 10px;
			}

			&:not(.disabled) {
				&:hover {
					.chat-tooltip {
						opacity: 1;
						top: -35px;
						background: #0080d3;
						animation: show 0.7s ease;
						transition: all 0.4s ease;
					}
				}
			}

			.chat-button {
				margin: 0;
				border-radius: 50%;
				width: 28px;
				height: 28px;
				border: 0;
				background: transparent;
				justify-content: center;
				display: flex;
				align-items: center;
				color: white;
				-webkit-backdrop-filter: blur(50px);
				backdrop-filter: blur(50px);
				cursor: pointer;

				svg {
					min-width: 20px;
					min-height: 20px;
				}

				&:hover {
					background: rgba(116, 171, 226, 0.55);
				}
			}

			&.disabled .chat-button {
				opacity: 0.7;
				background: transparent;

				.chat-tooltip {
					opacity: 0;
				}
			}
		}
	}

	.background-container {
		box-shadow: 0 3px 6px rgba(255, 255, 255, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		background: #0c1e3d;
		overflow: hidden;
		flex-direction: column;
		height: 100%;
		display: flex;
		align-content: center;
		align-items: center;
		justify-content: center;
		vertical-align: middle;
		flex: 1;
		border-radius: 10px;
		color: white;
		min-width: 300px;

		.canvas-container {
			min-width: 260px;
			width: calc(100% - 25px);
			aspect-ratio: 4/3;
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			position: relative;
			border-radius: 10px;
			overflow: hidden;
			border: 1px solid hsla(210, 65%, 67%, 1);
			margin-top: 10px;

			.output_canvas_preview_none {
				height: 100%;
				width: 100%;
				background: #0b1e3d;
			}

			canvas {
				object-fit: contain;
				height: 100%;
				width: 100%;
				background: #0b1e3d;
			}

			.output_canvas_preview {
				transform: scaleX(-1);
			}
		}

		.scroller-container {
			min-width: 300px;
			width: 100%;
			height: 100%;
			overflow-y: auto;
			padding-bottom: 30px;

			.background-title {
				width: 100%;
				margin: 20px 12px 15px 12px;
			}
		}

		.effects-header {
			min-height: 40px;
			background: rgba(116, 171, 226, 0.15);
			width: 100%;
			height: 40px;
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid hsla(210, 65%, 67%, 0.55);
			color: white;

			span,
			svg {
				cursor: pointer;
				padding: 0 10px;
			}

			svg path {
				fill: white;
			}
		}

		div.effects-footer {
			border-top: 1px solid hsla(210, 65%, 67%, 0.55);
			height: 55px;
			min-height: 55px;
			max-height: 55px;
			width: 100%;
			flex: 1;
			background: rgba(116, 171, 226, 0.15);
			align-items: center;
			display: flex;
			justify-content: flex-end;

			button {
				margin-right: 10px;
				outline: 0;
				border: 0;
				background: #0080d3;
				color: white;
				display: inline-block;
				position: relative;
				cursor: pointer;
				height: 35px;
				line-height: 35px;
				padding: 0 1.5rem;
				color: white;
				font-size: 14px;
				text-align: center;
				vertical-align: middle;
				white-space: nowrap;
				outline: none;
				border: none;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
				border-radius: 2px;
				transition: all 0.3s ease-out;
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
			}
		}

		.effects-container {
			display: flex;
			flex-direction: column;
			color: #fff;
			padding: 10px 12px 5px 12px;

			label {
				font-size: 14px;
				padding-bottom: 8px;
			}

			.container-choices {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: 8px;
			}

			.choice {
				aspect-ratio: 5 / 3;
				border: 2px solid rgba(255, 255, 255, 0.2);
				border-radius: 6px;
				background-size: cover !important;
				background-position: center !important;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.2s ease;
				position: relative;
				overflow: visible; // Cambiato da hidden a visible

				&:hover {
					border-color: #00a8ff;
					box-shadow: 0 4px 12px rgba(0, 128, 211, 0.3);

					.choice-tooltip {
						opacity: 1;
					}
				}

				&.selected {
					border: 3px solid #0080d3;
					box-shadow: 0 0 0 2px rgba(0, 128, 211, 0.3);
				}

				// Tooltip annidato dentro .choice
				.choice-tooltip {
					opacity: 0;
					position: absolute;
					top: -32px;
					left: 50%;
					transform: translateX(-50%);
					white-space: nowrap;
					pointer-events: none;
					transition: opacity 0.2s ease;
					font-size: 12px;
					padding: 6px 10px;
					border-radius: 4px;
					color: white;
					background: #0080d3;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
				}
			}
		}
	}
}

.Scenary {
	width: 100%;
	max-width: inherit;
	position: fixed;
	top: 0;
	bottom: 0px;
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	//padding: 10px 20px;
	gap: 5px;
	// background-image: radial-gradient(circle at 50% 100%, rgb(1, 92, 153), rgb(2, 36, 69));
	overflow: hidden;
}

.MeetLogo {
	height: 35px;
	padding-left: 20px;
	padding-top: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 20px;
}

.ScreenSharingOn {
	display: flex;
	align-items: center;
	width: 100%;
	transition: all 0.4s ease-out;
	min-height: 40px;
	max-height: 40px;
	position: relative;

	.ScreenSharingOn-container {
		cursor: pointer;
		animation: show 0.4s ease-out;
		position: absolute;
		border-radius: 10px;
		top: 3px;
		left: 0;
		right: 0;
		box-shadow: var(--shadow-dark);
		transition: all 0.4s ease-out;
		border: 1.5px solid hsla(210, 65%, 67%, 0.55);
		background: #0c1e3d;
		color: white;
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: space-between;
		height: 35px;
		width: calc(100% - 3px);

		span {
			display: flex;
			align-items: center;
			align-content: center;
			padding: 0 10px 0 20px;
		}

		button {
			background: #3280d3;
			color: white;
			border: 1px solid hsla(210, 65%, 67%, 0.55);
			padding: 3px 10px;
			border-radius: 5px;
		}
	}
}

.PinnedContainer {
	overflow: hidden;
	position: relative;
	width: calc(100% - 3px);
	height: calc(100% - 3px);
	background: #1a2f49;
	border: 1.5px solid hsla(210, 65%, 67%, 0.55);
	border-radius: 15px;
	display: flex;
	justify-content: center;
}

.ScreenSharingOn + .PinnedContainer {
	height: calc(100% - 60px);
}

/* Container of Screen and Dish */
.Recording {
	display: flex;
	border-radius: 10px;
	height: 0px;
	max-width: 100%;
	align-items: flex-end;

	&.--on {
		height: 50px;
		animation: show 0.4s ease;

		span.alert-text {
			opacity: 1;
			transition: all 1s ease;
		}
	}

	.recording-alert-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		//background: hsla(210, 65%, 67%, 0.59);
		background: #0c1e3d;
		// border-bottom: 1px solid hsla(210, 65%, 67%, 0.55);
		// border-top: 1px solid hsla(210, 65%, 67%, 0.55);
		width: 100%;
		height: 35px;
		overflow: hidden;
		color: rgb(223, 84, 84);

		.record-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgba(255, 82, 82, 0.2);
			width: 35px;
			height: 35px;
			border-radius: 50%;
			margin-right: 10px;
			margin-left: 0px;

			svg {
				border-radius: 50%;
				animation: pulse-red 2s infinite;
				fill: #f14c49;
			}
		}

		span.alert-tooltip {
			display: none;
			position: absolute;
		}
	}

	&.--on.--on-right {
		.recording-alert-wrapper {
			background: transparent;
			transition: all 1.5s ease;
			position: relative;
			border: 0;

			.record-icon {
				margin-left: 94.2%;
				transition: all 1.8s ease;
				cursor: pointer;
			}

			.record-icon:hover + .alert-text + .alert-tooltip {
				display: block;
				opacity: 1;
				position: absolute;
				right: 75px;
				background: #0080d3;
				border: 1px solid hsla(210, 65%, 67%, 0.55);
				color: white;
				padding: 5px 15px;
				border-radius: 3px;
				animation: show 0.5s ease;
				font-size: 12px;
			}

			span.alert-text {
				width: 0;
				opacity: 0;
				white-space: nowrap;
				transition: opacity 1.3 ease, width 2.5s ease;
				transition-delay: 0s, 2s;
			}

			span.alert-tooltip {
				display: block;
				opacity: 0;
			}
		}
	}
}

.Conference {
	display: flex;
	flex: 1;
	border-radius: 10px;
	max-height: calc(100% - 110px);
	max-width: 100%;
	padding: 10px 20px;
	transition: height 0.4s ease-out;
}

.Recording.--on + .Conference {
	max-height: calc(100% - 160px);
	transition: height 0.4s ease-out;
}

/* Container of Cameras */
.Dish {
	display: flex;
	align-content: center;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	vertical-align: middle;
	flex: 1;
	border-radius: 15px;
	overflow: hidden;
	transition: all 0.4s ease-out;
}

/* Camera */
.Dish > div {
	border: 1px solid hsla(210, 65%, 67%, 0.55);
	position: relative;
	vertical-align: middle;
	align-self: center;
	border-radius: 10px;
	overflow: hidden;
	display: inline-block;
	box-shadow: var(--shadow-dark);
	transition: all 0.4s ease-out;
	animation: show 0.5s ease;

	/* Inner speaking border - doesn't affect layout */
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		/* border: 0px solid transparent; */
		border: var(--speaking-border-width, 0px) solid var(--speaking-border-color, transparent);
		border-radius: 10px;
		pointer-events: none;
		z-index: 10;
		transition: border-width 0.1s ease, border-color 0.1s ease;
		box-sizing: border-box;
	}

	/* Remove the old border effect that caused layout shifts */
	&.video-container {
		/* Remove any existing border animations */
	}
}

.Dish > div canvas {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	border-radius: 10px;
	overflow: hidden;
	left: 0;
	top: 0;
}

/* Video (check the nice property object-fit) */
.Dish > div video {
	transform: rotateY(180deg) !important;
	-webkit-transform: rotateY(180deg) !important;
	-moz-transform: rotateY(180deg) !important;
	transition: rotate 0ms ease;
	position: absolute;
	right: 0;
	object-fit: contain;
	bottom: 0;
	width: 100%;
	height: 100%;
	border-radius: 10px;
	left: 0;
	top: 0;
	background-size: contain;
	overflow: hidden;
	transition: rotate 0ms ease;

	&.isScreenShare {
		transition: rotate 0ms ease;
		transform: rotateY(0deg) !important;
		-webkit-transform: rotateY(0deg) !important;
		-moz-transform: rotateY(0deg) !important;
	}
}

/* Aspect Ratio Number */
.Dish div.video-container:after {
	color: #aaa;
	font-size: 13px;
	font-family: 'Lato', sans-serif;
	position: absolute;
	bottom: 20px;
	left: 23px;
	font-weight: 100;
	content: attr(data-aspect);
	display: block;
}

/* Gray Diagonal */
.Dish div.video-container:before {
	position: absolute;
	height: 100%;
	// background: url(./../general/diagonal.jpg);
	background-size: 100% 100%;
	width: 100%;
	opacity: 0.3;
	font-weight: 100;
	content: '';
	display: block;
}

/* Screen */
.Screen {
	overflow: hidden;
	flex: 0;
	position: relative;
	display: none;
	transition: all 0.4s ease-out;
	justify-content: center;
	align-items: center;
	border-radius: 15px;
	margin: 5px 15px;
	transition: all 0.4s ease-out;

	&.pinned {
		justify-content: space-between;
		flex: 2;
		transition: all 0.4s ease-out;
		display: flex;
		flex-direction: column;
		transition: all 0.4s ease-out;
		animation: show 0.4s ease-out;

		video {
			transform: rotateY(180deg) !important;
			-webkit-transform: rotateY(180deg) !important;
			-moz-transform: rotateY(180deg) !important;
			position: absolute;
			right: 1px;
			object-fit: contain;
			bottom: 1px;
			height: 100%;
			width: 100%;
			margin: 0 auto;
			border-radius: 10px;
			overflow: hidden;
			left: 1px;
			top: 1px;
			background-size: cover;
			overflow: hidden;
			transition: rotate 0ms ease;

			&.isScreenShare {
				transition: rotate 0ms ease;
				transform: rotateY(0deg) !important;
				-webkit-transform: rotateY(0deg) !important;
				-moz-transform: rotateY(0deg) !important;
			}
		}

		.info {
			bottom: 30px;
			left: 2%;
		}
	}
}

/* Animation of Cameras */
@keyframes opacityAl {
	0% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}

@keyframes showAlertRecord {
	0% {
		opacity: 0;
		transform: scale(0.4) translateY(20px);
	}

	10% {
		opacity: 1;
		transform: scale(1) translateY(0);
	}

	100% {
		width: 40px;
	}
}

@keyframes show {
	0% {
		opacity: 0;
		transform: scale(0.4) translateY(20px);
	}

	100% {
		opacity: 1;
		transform: scale(1) translateY(0);
	}
}

@keyframes showInfo {
	0% {
		opacity: 0;
		transform: scale(0);
	}

	100% {
		opacity: 1;
		transform: scale(1);
	}
}

.pin {
	position: absolute;
	opacity: 0;
	z-index: -1;
	backdrop-filter: blur(5px);
	background-color: hsla(210, 65%, 67%, 0.35);
	// border: 1px solid hsla(210, 65%, 67%, 1);
	position: absolute;
	top: calc(50% - 15px);
	left: calc(50% - 15px);
	border-radius: 50%;
	height: 30px;
	width: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.5 ease-in;
}

.Screen,
.Dish > div.video-container {
	&:hover {
		user-select: none;

		.pin {
			z-index: 5;
			opacity: 0.8;
			transition: all 0.5 ease-in;

			svg {
				height: 12px;
				width: 12px;
			}

			&:hover {
				backdrop-filter: blur(30px);
				background-color: transparent;
				border: 1px solid hsla(210, 65%, 67%, 0);

				opacity: 1;
				z-index: 10;
				transition: all 0.5 ease-in;
				cursor: pointer;

				svg path {
					fill: #02c9fa !important;
				}
			}
		}
	}

	.recording {
		z-index: 1;
		position: absolute;
		top: 10px;
		right: 5px;
		width: 35px;
		height: 35px;
		color: white;
		backdrop-filter: blur(10px);
		background: #ffffff0b;
		backdrop-filter: blur(10px);
		border: 1px solid #ff3b38;
		border-radius: 50%;
		font-weight: 600;
		text-align: center;
		border: 0px;
		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			width: 3vh;
			height: 3vh;
			border-radius: 50%;
			animation: pulse-red 2s infinite;

			path {
				fill: #f14c49;
			}
		}
	}

	.audio {
		z-index: 12;
		position: absolute;
		bottom: 10px;
		right: 10px;
		width: 35px;
		height: 35px;
		color: white;
		//border: 1px solid #ff004f;
		backdrop-filter: blur(10px);
		background: #ff00513e;
		border-radius: 50%;
		font-weight: 600;
		text-align: center;

		&.active {
			background: rgba(0, 174, 255, 0.5);
		}

		svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			-webkit-transform: translate(-50%, -50%);
			position: absolute;
			width: 3vh;
			height: 3vh;

			path {
				fill: white;
			}
		}
	}

	.container-initials {
		text-transform: uppercase;
		width: 100%;
		height: 100%;
		//background: rgba(116, 171, 226, 0.15);
		background: #01193520;
		display: flex;
		align-content: center;
		justify-content: center;
		position: relative;
		transition: all 0.5s ease;

		[class^='initials-audio-effect-'] {
			background: hsla(190, 100%, 55%, 0.105);
			width: 14.9vh;
			height: 14.9vh;
			z-index: 1;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			margin: auto;
			border-radius: 50%;
			text-align: center;
			opacity: 0;
			transition: all 650ms ease-out;
			animation: display 1s ease-out;
		}

		[class^='initials-audio-effect-big-'] {
			background: transparent;
			opacity: 0;
			border: 1px solid hsla(210, 65%, 67%, 1);
			width: 14.9vh;
			height: 14.9vh;
			z-index: 2;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			margin: auto;
			border-radius: 50%;
			text-align: center;
			transition: all 800ms ease-out;
			animation: display 1s ease-out;
		}

		.initials {
			z-index: 3;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			margin: auto;
			width: 15vh;
			height: 15vh;
			color: white;
			border-radius: 50%;
			line-height: 15vh;
			font-size: 7vh;
			font-weight: 600;
			text-align: center;
			animation: show 0.5s ease-out;
		}
	}

	.info {
		z-index: 10;
		padding: 0 10px;
		height: 35px;
		line-height: 31px !important;
		border-radius: 5px;
		margin: 10px;
		//border: 1px solid rgba(116, 171, 226, 0.5);
		backdrop-filter: blur(10px);
		//background: #01193520;
		color: #fff;
		color: rgba(116, 171, 226, 1);
		position: absolute;
		text-transform: capitalize;
		bottom: 0;
		font-size: 1.05rem;
		font-weight: 500;
		line-height: 1.25rem;
		letter-spacing: 0.2px;
		overflow: hidden;
		text-overflow: ellipsis;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6), 0 0 2px rgba(0, 0, 0, 0.6);
		white-space: nowrap;
	}
}

.Controls {
	display: flex;
	align-items: center;
	position: absolute;
	width: 100%;
	background: #01193520;
	bottom: 0;
	height: 100px;
	max-height: 100px;

	.Controls-meet-title {
		padding: 0 0 0 25px;
		display: flex;
		flex-direction: column;
		flex: 0 0 20%;
		color: white;
		font-size: 14px;

		p {
			margin: 0;
			padding-left: 35px;
		}
	}

	.Controls-info {
		padding: 0 25px 0 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		flex: 0 0 20%;
		height: 100%;

		.chat-action-mobile {
			display: none;
		}

		.chat-action {
			cursor: pointer;
			position: relative;
			margin-left: 10px;

			.count-badge {
				border: 1px solid #01c9fa;
				display: inline-block;
				position: absolute;
				left: -5px;
				font-weight: 600;
				top: 45px;
				border-radius: 3rem;
				text-align: center;
				font-size: 0.8rem;
				padding: 0.05rem 0.4rem 0.15rem;
				line-height: inherit;
				background: #0080d3;
				color: white;
				box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
				transform: scale(0.8);

				&.list-users-count {
					&.active {
						animation: pulse-white 2s infinite;
					}
				}

				&.message-chat-count {
					animation: pulse-white 2s infinite;
				}
			}

			button:not(.aspect) {
				cursor: pointer;
				color: white;
				background: transparent;
				border: 0;
				box-shadow: unset;
				margin: 0 6px;
				width: 100%;
				height: 22px;
				backdrop-filter: unset;

				svg {
					width: 20px;
					height: 20px;

					path {
						fill: #fffd;
					}
				}

				&:hover {
					box-shadow: unset;
				}

				&.active {
					svg path {
						fill: #01c9fa;
					}
				}
			}
		}

		.chat-action {
			display: flex;
			cursor: pointer;
			width: 47px;
			height: 100%;
			height: 100%;
			position: relative;
			overflow: visible;
			display: flex;
			justify-content: center;
			align-items: center;

			&:hover {
				.media-tooltip {
					opacity: 1;
					top: -10px;
					background: #0080d3;
					animation: show 0.7s ease;
					transition: all 0.4s ease;
				}
			}

			.media-tooltip {
				position: absolute;
				background: #0080d3;
				border: 1px solid hsla(210, 65%, 67%, 0.55);
				color: white;
				padding: 5px 15px;
				border-radius: 3px;
				font-size: 12px;
				top: 10px;
				opacity: 0;
				width: max-content;
			}

			.media-tooltip:before {
				left: 50% !important;
				transform: translate(-50%, -50%) !important;
			}

			.media-effects {
				margin-right: 15px !important;

				svg {
					width: 22px !important;
					height: 22px !important;
				}

				&.mediapipeOn {
					svg path {
						fill: #01c9fa !important;
					}
				}
			}
		}
	}

	.Controls-main-buttons {
		display: flex;
		justify-content: center;
		flex: 1;

		.media-action-button-wrapper:first-of-type {
			margin-left: -16px;
		}

		.media-action-button-wrapper:last-of-type {
			margin-left: 16px;
		}

		.media-action-button-wrapper {
			cursor: pointer;
			width: 64px;
			height: 100%;
			position: relative;
			overflow: visible;
			display: flex;
			justify-content: center;
			padding: 4px;

			.timestamp {
				position: absolute;
				bottom: -15px;
				color: white;
				opacity: 0.5;
				font-size: 10px;
				animation: show 1s ease;
			}

			&:hover {
				.media-tooltip {
					opacity: 1;
					top: -40px;
					background: #0080d3;
					animation: show 0.7s ease;
					transition: all 0.4s ease;
				}
			}
		}

		.media-tooltip {
			position: absolute;
			background: #0080d3;
			border: 1px solid hsla(210, 65%, 67%, 0.55);
			color: white;
			padding: 5px 15px;
			border-radius: 3px;
			font-size: 12px;
			top: 0;
			opacity: 0;
			top: -10px;
			width: max-content;

			&:before {
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}

		button {
			border-radius: 50%;
			width: 48px;
			height: 48px;
			border: 0;
			background: transparent;
			justify-content: center;
			display: flex;
			align-items: center;
			color: white;
			backdrop-filter: blur(50px);
			cursor: pointer;
			padding: 8px;

			&:hover {
				opacity: 0.85;
				cursor: pointer;
				background: hsla(210, 65%, 67%, 0.55) !important;
			}

			svg {
				width: 26px;
				height: 26px;

				path {
					fill: #01c9fa;
				}
			}

			&.record {
				background-color: transparent;

				svg {
					animation: pulse-red 2s infinite;
					border-radius: 50%;

					path {
						fill: #d33232;
					}
				}
			}

			&.hangup {
				background-color: #ff004f !important;
				border-radius: 100px;
				width: 60px;
				height: 48px;
				overflow: hidden;
				padding: 10px 14px;

				svg path {
					fill: white;
				}

				&:hover {
					background-color: #fb0a56 !important;
					cursor: pointer;
					opacity: 0.85;
				}
			}

			&.media-action-button-disabled {
				opacity: 0.5;
				// background-color: #ff7019;
				background: transparent;

				svg path {
					fill: white;
				}
			}

			&.media-action-button-disabled-recording {
				opacity: 0.5;
				background: transparent;
				cursor: not-allowed;

				svg path {
					fill: #888;
				}

				&:hover {
					background: transparent !important;
					opacity: 0.5 !important;
					cursor: not-allowed;
				}
			}

			&.media-action-button-enabled {
				background-color: #4caf50 !important;
				opacity: 1;

				svg path {
					fill: white;
				}
			}

			&.bg-transparent {
				// background-color: hsla(210, 65%, 67%, 0.25);
				background: transparent;
				color: white;
			}
		}
	}
}

@keyframes display {
	0% {
		visibility: hidden;
	}

	99% {
		visibility: hidden;
	}

	100% {
		visibility: visible;
	}
}

@keyframes showAvatar {
	0% {
		opacity: 0;
		transform: scale(0);
	}

	100% {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes pulse-red {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
	}
}

@keyframes pulse-green {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 20px rgba(51, 217, 178, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
	}
}

.Controls .Group {
	display: flex;
	align-items: center;
	gap: 20px;
}

.Controls .Options {
	display: flex;
	gap: 10px;
}

.Controls .Options div {
	display: inline-block;
	font-size: 12px;
}

.Controls .Link {
	color: #000;
	text-decoration: none;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 100;
	letter-spacing: 4px;
	text-align: center;
	display: flex;
	align-items: center;
	margin-left: auto;
}

.Controls .Link i {
	margin-left: 10px;
	font-size: 30px;
}

@keyframes pulse-white {
	0% {
		transform: scale(0.75);
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
	}

	70% {
		transform: scale(0.8);
		box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
	}

	100% {
		transform: scale(0.75);
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
	}
}

.Screen.pinned + .Dish > div.video-container .initials {
	width: 13vh !important;
	height: 13vh !important;
	line-height: 13vh !important;
	font-size: 6vh !important;
}

.Screen.pinned + .Dish .container-initials {
	[class^='initials-audio-effect-'] {
		width: 12.9vh !important;
		height: 12.9vh !important;
	}
}
.media-action-button-wrapper--record {
	display: flex;
}
@media only screen and (max-width: 950px) {
	.Screen.pinned + .Dish > div.video-container .initials {
		width: 11vh !important;
		height: 11vh !important;
		line-height: 11vh !important;
		font-size: 5vh !important;
	}

	.Screen.pinned + .Dish .container-initials {
		[class^='initials-audio-effect-'] {
			width: 10.9vh !important;
			height: 10.9vh !important;
		}
	}
}

@media only screen and (max-width: 768px) {
	.media-action-button-wrapper--record {
		display: none !important;
	}
	.Conference.boxRightOpen div.column {
		flex: 0;
		width: 0;
	}

	.Screen.pinned {
		order: 2;
		display: flex;
		align-content: center;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		vertical-align: middle;
		flex: 1;
		border-radius: 10px;

		video {
			object-fit: contain;
			width: 100%;
		}

		.info {
			width: 100%;
			bottom: 30px;
			left: -10px;
		}
	}

	.Screen.pinned + .Dish {
		display: none;
		min-height: 50px !important;
		max-height: 60px;
		min-width: 50px !important;

		.video-container,
		video {
			min-height: 50px !important;
			max-height: 60px;
			min-width: 50px !important;
		}

		.info {
			opacity: 0;
		}

		.audio {
			top: 1px;
			right: 1px;
			width: 3.5vh;
			height: 3.5vh;
			z-index: 10;
		}
	}

	.Controls {
		.Controls-meet-title {
			display: none;
		}

		/* 	.Controls-main-buttons {
			padding-left: 10%;
		} */

		.Controls-info {
			flex: 0 0 5%;

			.chat-action {
				display: none;
			}

			.chat-action-mobile {
				cursor: pointer;
				display: flex;

				.menu-list {
					background: white;
					position: absolute;
					z-index: -1;
					min-height: 100px;
					min-width: 220px;
					border-radius: 5px;
					display: flex;
					justify-content: space-between;
					flex-direction: column;
					display: flex;
					opacity: 0;
					overflow: hidden;
					padding: 5px 0;

					.menu-list-close {
						display: flex;
						justify-content: flex-end;
						padding-right: 4px;
						align-items: center;
						svg {
							cursor: pointer;
							width: 18px;
							height: auto;
						}
					}

					&.show {
						opacity: 1;
						z-index: 10;
						bottom: 25%;
						right: 25px;
						transition: all 0.4s ease-in-out forward;
						animation: show 0.4s ease;

						& + svg.settings {
							transform: rotate(180deg);
							transition: transform 0.4s;
						}
					}

					div.menu-list-option {
						height: 38px;
						padding: 5px 15px;
						cursor: pointer;
						display: flex;
						align-items: center;
						transition: background 0.2s ease;

						&.disabled {
							opacity: 0.5;
						}
						&.menu-list-option-recording {
							color: red;
							svg path {
								fill: red;
							}
						}

						&:hover {
							background: #dbdada5c;
							transition: background 0.2s ease;
						}

						svg {
							margin-right: 10px;
						}
					}
				}
			}
		}
	}

	.RightBox.open {
		flex: 1 !important;
		min-width: 100% !important;
	}
}

.effect-container {
	right: 5px;
	bottom: 10px;
	background: #02c9fa;
	margin: 0.5rem;
	width: 28px;
	height: 28px;
	position: absolute;
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;

	[class^='o1_'],
	[class^='o2_'],
	[class^='o3_'] {
		position: relative;
		height: 19%;
		width: 5px;
		background: white;
		margin: 1.5px;
		border-radius: 200px;
		transition: all linear 0.1s;
	}

	&:not(.speaking) {
		[class^='o1_'],
		[class^='o2_'],
		[class^='o3_'] {
			height: 19% !important;
		}
	}
}

.Toast {
	position: absolute;
	margin: auto;
	flex: 1;
	color: #ff4f4d;
	display: flex;
	justify-content: center;
	left: 0;
	right: 0;
	top: -10px;
	z-index: -1;
	height: 40px;

	* {
		visibility: hidden;
	}

	&.show {
		+ .Scenary {
			top: 40px;
			transition: all 0.4 ease-in;
		}

		top: 10px;
		z-index: 10;
		opacity: 1;
		transition: all 0.4s ease-in-out;

		* {
			visibility: visible;
			transition: all 0.4s ease-in-out;
		}

		.toast-container {
			width: fit-content;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #ff4f4d;
			border-radius: 5px;
			min-width: 250px;
			min-height: 30px;
			padding: 5px 8px;

			svg {
				margin-right: 12px;
				border-radius: 50%;
				animation: pulse-red 2s infinite;
			}
		}
	}
}

.loading-spinner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(0, 0, 0, 0.7);
	border-radius: 50%;
	padding: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.background-choice.loading {
	pointer-events: none;
	opacity: 0.7;
}

@keyframes spin {
	0% {
		transform: translate(-50%, -50%) rotate(0deg);
	}
	100% {
		transform: translate(-50%, -50%) rotate(360deg);
	}
}
</style>
